<template>
    <div>
        <div class="text-center" v-if="!loadDataPage">
            <b-spinner variant="primary" label="Text Centered" />
            <h4 class="mt-1">LOADING...</h4>
        </div>

        <div v-else-if="loadDataPage && isVSEForm">
            <div v-if="adminOrManageUsers">
                <validation-observer ref="editClinicianRulesVSE">
                    <b-form
                        class="px-2"
                    >
                        <h4>VSE Form</h4>
                        <hr>
                        <b-row cols="12">
                            <!-- LEFT CONTENT -->
                            <b-col md="8">
                                <b-row class="px-1">
                                    <b-col md="12">
                                        <validation-provider
                                            #default="{ errors }"
                                            name="Staff Member Completing Form"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Staff Member Completing Form"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                Staff Member Completing Form <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="staffMemberCompletingFormVSE"
                                                    placeholder="Staff Member Completing Form"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsStaffMemberCompletingFormVSE"
                                                    label="name"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>

                                    <b-col md="6">
                                        <b-form-group
                                            label-for="Contact Date"
                                        >
                                        <template v-slot:label>
                                            Contact Date <span class="text-danger">*</span>
                                        </template>
                                            <validation-provider
                                                #default="{ errors }"
                                                name="Contact Date"
                                                rules="required"
                                            >
                                                <flat-pickr
                                                    v-model="contactDateVSE"
                                                    class="form-control"
                                                    placeholder="Select a Date"
                                                    :config="{ altInput: true, altFormat: 'F j, Y', dateFormat: 'm-d-Y',}"
                                                    :state="errors.length > 0 ? false:null"
                                                    :style="errors.length > 0 ? 'border: 1px solid #ea5455 !important;' : ''"
                                                />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>
                                    </b-col>

                                    <b-col md="12">
                                        <validation-provider
                                            #default="{ errors }"
                                            name="Gender"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Gender"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                Gender <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="genderVSE"
                                                    placeholder="Gender"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsGenderVSE"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>

                                    <!-- <b-row class="px-1"> -->
                                        <b-col :md="referredByVSE === 'Family member/Self' || referredByVSE === 'Problem Gambling Treatment Services' || referredByVSE === 'Problem Gambling Self-Help Group Meetings' || referredByVSE === 'Substance Use Treatment Services' || referredByVSE === 'Recovery Support Services' || referredByVSE === 'Other' || referredByVSE === 'HOPEline' ? '6' : '12'">
                                            <validation-provider
                                                #default="{ errors }"
                                                name="Referral Source"
                                                rules="required"
                                            >
                                                <b-form-group
                                                    label-for="Referral Source"
                                                    :state="errors.length > 0 ? false:null"
                                                >
                                                <template v-slot:label>
                                                    Referral Source <span class="text-danger">*</span>
                                                </template>
                                                    <v-select
                                                        v-model="referredByVSE"
                                                        placeholder="Referral Source"
                                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                        :options="optionsReferredByVSE"
                                                    />
                                                    <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                        {{ errors[0] }}
                                                    </b-form-invalid-feedback>
                                                </b-form-group>
                                            </validation-provider>
                                        </b-col>

                                        <b-col md="6" v-if="referredByVSE === 'Family member/Self'">
                                                <b-form-group
                                                    label-for="Family member/Self"
                                                >
                                                <template v-slot:label>
                                                    Family member/Self
                                                </template>
                                                    <v-select
                                                        v-model="familyMemberSelfVSE"
                                                        placeholder="Family member/Self"
                                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                        :options="optionsFamilyMemberSelf"
                                                        style=""
                                                    />
                                                </b-form-group>
                                        </b-col>
                                        <b-col md="6" v-if="referredByVSE === 'Problem Gambling Treatment Services'">
                                                <b-form-group
                                                    label-for="Problem Gambling Treatment Services"
                                                >
                                                <template v-slot:label>
                                                    Problem Gambling Treatment Services
                                                </template>
                                                    <v-select
                                                        v-model="problemGamblingTreatmentServicesVSE"
                                                        placeholder="Problem Gambling Treatment Services"
                                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                        :options="optionsProblemGamblingTreatmentServices"
                                                        style=""
                                                    />
                                                </b-form-group>
                                        </b-col>
                                        <b-col md="6" v-if="referredByVSE === 'Problem Gambling Self-Help Group Meetings'">
                                                <b-form-group
                                                    label-for="Problem Gambling Self-Help Group Meetings"
                                                >
                                                <template v-slot:label>
                                                    Problem Gambling Self-Help Group Meetings
                                                </template>
                                                    <v-select
                                                        v-model="problemGamblingSelfHelpGroupMeetingsVSE"
                                                        placeholder="Problem Gambling Self-Help Group Meetings"
                                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                        :options="optionsProblemGamblingSelfHelpGroupMeetings"
                                                        style=""
                                                    />
                                                </b-form-group>
                                        </b-col>
                                        <b-col md="6" v-if="referredByVSE === 'Substance Use Treatment Services'">
                                                <b-form-group
                                                    label-for="Substance Use Treatment Services"
                                                >
                                                <template v-slot:label>
                                                    Substance Use Treatment Services
                                                </template>
                                                    <v-select
                                                        v-model="substanceUseTreatmentServicesVSE"
                                                        placeholder="Substance Use Treatment Services"
                                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                        :options="optionsSubstanceUseTreatmentServices"
                                                        style=""
                                                    />
                                                </b-form-group>
                                        </b-col>
                                        <b-col md="6" v-if="referredByVSE === 'Recovery Support Services'">
                                                <b-form-group
                                                    label-for="Recovery Support Services"
                                                >
                                                <template v-slot:label>
                                                    Recovery Support Services
                                                </template>
                                                    <v-select
                                                        v-model="recoverySupportServicesVSE"
                                                        placeholder="Recovery Support Services"
                                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                        :options="optionsRecoverySupportServices"
                                                        style=""
                                                    />
                                                </b-form-group>
                                        </b-col>
                                        <b-col md="6" v-if="referredByVSE === 'Other'">
                                            <b-form-group
                                                label-for="Other"
                                            >
                                            <template v-slot:label>
                                                Other
                                            </template>
                                                    <b-form-textarea
                                                        placeholder="Other"
                                                        rows="3"
                                                        v-model="otherReferredByVSE"
                                                        style=""
                                                    />
                                            </b-form-group>
                                        </b-col>
                                        <b-col md="6" v-if="referredByVSE === 'HOPEline'">
                                            <b-form-group
                                                label-for="Warm Transfer"
                                            >
                                            <template v-slot:label>
                                                Warm Transfer
                                            </template>
                                                <v-select
                                                    v-model="warmTransferVSE"
                                                    placeholder="Warm Transfer"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsWarmTransfer"
                                                    style=""
                                                />
                                            </b-form-group>
                                        </b-col>
                                        <b-col md="6" v-if="referredByVSE === 'PGRC PM'">
                                            <b-form-group
                                                label-for="PGRC PM"
                                            >
                                            <template v-slot:label>
                                                PGRC PM <span class="text-danger">*</span>
                                            </template>
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="PGRC PM"
                                                    rules="required"
                                                >
                                                    <b-form-textarea
                                                        placeholder="PGRC PM"
                                                        rows="3"
                                                        v-model="pgrcPmSE"
                                                        style=""
                                                        :state="errors.length > 0 ? false:null"
                                                    />
                                                    <small class="text-danger">{{ errors[0] }}</small>
                                                </validation-provider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col md="6" v-if="referredByVSE === 'PGRC Private Practitioner'">
                                            <b-form-group
                                                label-for="PGRC Private Practitioner"
                                            >
                                            <template v-slot:label>
                                                PGRC Private Practitioner <span class="text-danger">*</span>
                                            </template>
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="PGRC Private Practitioner"
                                                    rules="required"
                                                >
                                                    <b-form-textarea
                                                        placeholder="PGRC Private Practitioner"
                                                        rows="3"
                                                        v-model="PGRCPrivatePractitionerVSE"
                                                        style=""
                                                        :state="errors.length > 0 ? false:null"
                                                    />
                                                    <small class="text-danger">{{ errors[0] }}</small>
                                                </validation-provider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col md="6" v-if="referredByVSE === 'OASAS Program'">
                                            <b-form-group
                                                label-for="OASAS Program"
                                            >
                                            <template v-slot:label>
                                                OASAS Program <span class="text-danger">*</span>
                                            </template>
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="OASAS Program"
                                                    rules="required"
                                                >
                                                    <b-form-textarea
                                                        placeholder="OASAS Program"
                                                        rows="3"
                                                        v-model="OASASProgramVSE"
                                                        style=""
                                                        :state="errors.length > 0 ? false:null"
                                                    />
                                                    <small class="text-danger">{{ errors[0] }}</small>
                                                </validation-provider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col md="6" v-if="referredByVSE === 'Gaming Facility'">
                                            <b-form-group
                                                label-for="Gaming Facility"
                                            >
                                            <template v-slot:label>
                                                Gaming Facility <span class="text-danger">*</span>
                                            </template>
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="Gaming Facility"
                                                    rules="required"
                                                >
                                                    <b-form-textarea
                                                        placeholder="Gaming Facility"
                                                        rows="3"
                                                        v-model="GamingFacilityVSE"
                                                        style=""
                                                        :state="errors.length > 0 ? false:null"
                                                    />
                                                    <small class="text-danger">{{ errors[0] }}</small>
                                                </validation-provider>
                                            </b-form-group>
                                        </b-col>
                                    <!-- </b-row> -->

                                    <b-col md="12">
                                        <validation-provider
                                            #default="{ errors }"
                                            name="Connected to PGRC"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Connected to PGRC"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                Connected to PGRC <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="connectedToPGRCVSE"
                                                    placeholder="Connected to PGRC"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsConnectedToPGRCVSE"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>

                                    <b-col md="12">
                                        <validation-provider
                                            #default="{ errors }"
                                            name="Connected to Peer Advocate"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Connected to Peer Advocate"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                Connected to Peer Advocate <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="connectedToPeerAdvocateVSE"
                                                    placeholder="Connected to Peer Advocate"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsYesNoSurvey"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>

                                    <b-col md="12">
                                        <validation-provider
                                            #default="{ errors }"
                                            name="Connected to NYS Gaming Commission"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Connected to NYS Gaming Commission"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                Connected to NYS Gaming Commission <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="connectedtoNYSGamingCommissionVSE"
                                                    placeholder="Connected to NYS Gaming Commission"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsYesNoSurvey"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>

                                    <b-col md="12">
                                        <validation-provider
                                            #default="{ errors }"
                                            name="Types of Gambling Engaged In"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Types of Gambling Engaged In"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                Types of Gambling Engaged In <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="typesofGamblingEngagedInVSE"
                                                    placeholder="Types of Gambling Engaged In"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsGamblingTypesVSE"
                                                    multiple
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>

                                    <!-- <b-row class="px-1"> -->
                                        <b-col :md="interventionStatusVSE === 'Pending' ? '6' : '12'">
                                            <validation-provider
                                                #default="{ errors }"
                                                name="Intervention Status"
                                                rules="required"
                                            >
                                                <b-form-group
                                                    label-for="Intervention Status"
                                                    :state="errors.length > 0 ? false:null"
                                                >
                                                <template v-slot:label>
                                                    Intervention Status <span class="text-danger">*</span>
                                                </template>
                                                    <v-select
                                                        v-model="interventionStatusVSE"
                                                        placeholder="Intervention Status"
                                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                        :options="optionsInterventionStatusVSE"
                                                    />
                                                    <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                        {{ errors[0] }}
                                                    </b-form-invalid-feedback>
                                                </b-form-group>
                                            </validation-provider>
                                        </b-col>

                                        <b-col md="6" v-if="interventionStatusVSE === 'Pending'">
                                            <validation-provider
                                                #default="{ errors }"
                                                name="Pending"
                                                rules="required"
                                            >
                                                <b-form-group
                                                    label-for="Pending"
                                                >
                                                <template v-slot:label>
                                                    Pending <span class="text-danger">*</span>
                                                </template>
                                                    <v-select
                                                        v-model="pendingVSE"
                                                        placeholder="Pending"
                                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                        :options="optionsPendingVSE"
                                                        style=""
                                                    />
                                                    <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                        {{ errors[0] }}
                                                    </b-form-invalid-feedback>
                                                </b-form-group>
                                            </validation-provider>
                                        </b-col>
                                    <!-- </b-row> -->

                                    <b-col md="6">
                                        <b-form-group
                                            label-for="Appointment Date"
                                        >
                                        <template v-slot:label>
                                            Appointment Date
                                        </template>
                                                <flat-pickr
                                                    v-model="appointmentDateVSE"
                                                    class="form-control"
                                                    placeholder="Select a Date"
                                                    :config="{ altInput: true, altFormat: 'F j, Y', dateFormat: 'm-d-Y',}"
                                                />
                                        </b-form-group>
                                    </b-col>

                                    <b-col md="12">
                                        <b-form-group
                                            label-for="VSE Timeframe"
                                        >
                                        <template v-slot:label>
                                            VSE Timeframe
                                        </template>
                                            <v-select
                                                v-model="VSETimeframe"
                                                placeholder="VSE Timeframe"
                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                :options="optionsVSETimeframe"
                                                style=""
                                            />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>

                            <!-- RIGHT CONTENT -->
                            <b-col md="4">
                                <!-- Final Status -->
                                <b-form-group
                                    label-for="Final Status"
                                >
                                <template v-slot:label>
                                    Final Status
                                </template>
                                    <v-select
                                        v-model="finalStatusVSE"
                                        placeholder="Final Status"
                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                        :options="optionsFinalStatusVSE"
                                        :clearable="true"
                                    />
                                </b-form-group>

                                <b-form-group
                                    label-for="Follow Up Date"
                                >
                                <template v-slot:label>
                                    Follow Up Date
                                </template>
                                        <flat-pickr
                                            v-model="followUpDateVSE"
                                            class="form-control"
                                            placeholder="Select a Date"
                                            :config="{ altInput: true, altFormat: 'F j, Y', dateFormat: 'm-d-Y',}"
                                        />
                                </b-form-group>

                                <b-form-group
                                    label="Notes"
                                >
                                    <b-form-textarea
                                        id="textarea-default"
                                        placeholder="Notes"
                                        rows="3"
                                        v-model="notesVSE"
                                    />
                                </b-form-group>
                            </b-col>

                            <!-- Form Actions -->
                            <div class="d-flex mt-2 float-right" style="width: 100%; justify-content: right;">
                                <b-button
                                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                    variant="flat-primary"
                                    @click="backList"
                                >
                                Back to list
                                </b-button>
                                <b-button
                                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                    variant="primary"
                                    class="mr-2"
                                    type="submit"
                                    @click.prevent="validationFormVSE"
                                >
                                Save
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </validation-observer>
            </div>
        </div>

        <div v-else>
            <!-- Edit client activity -->
                <h3 class="mb-2 px-2" v-if="clinicianUsers">Client Activity <span style="color: #476282; font-size: 1.2rem;">· {{ nameClient }}</span></h3>
                <validation-observer ref="editClinicianRules">
                    <b-form
                        class="px-2"
                    >
                        <h4>Engagement</h4>
                        <hr>
                        <b-row cols="12">
                            <b-col md="8">
                                <b-col md="12" class="mb-1" v-if="activityStatus === 'Closed - Referred to OASAS Program' || activityStatus === 'External Referral' || activityStatus === 'Closed - Received information'">
                                    <b-alert
                                        variant="danger"
                                        class="mb-0"
                                        show
                                    >
                                        <div class="alert-body">
                                            <feather-icon
                                                icon="InfoIcon"
                                                class="mr-50"
                                            />
                                            Clinician and Initial Appointment Date/Time will be disabled if Activity Status is Closed - Referred to OASAS Program, External Referral or Closed - Received information.
                                        </div>
                                    </b-alert>
                                </b-col>
                                <b-col md="12" v-if="activityStatus === 'Closed - Attended First Session' || activityStatus === 'Closed - Did not attend first session'">
                                    <validation-provider
                                        #default="{ errors }"
                                        name="Clinician"
                                        rules="required"
                                    >
                                        <b-form-group
                                            label-for="Clinician"
                                        >
                                        <template v-slot:label>
                                            Clinician 
                                            <span class="text-danger">*</span>
                                        </template>
                                            <v-select
                                                v-model="clinician"
                                                placeholder="Clinician"
                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                :options="optionsClinician"
                                                label="agencyAndName"
                                                multiple
                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                            />
                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                </b-col>
                                <b-col md="12" v-else-if="activityStatus !== 'Closed - Referred to OASAS Program' && activityStatus !== 'External Referral' && activityStatus !== 'Closed - Received information'">
                                    <b-form-group
                                        label-for="Clinician"
                                    >
                                    <template v-slot:label>
                                        Clinician
                                    </template>
                                        <v-select
                                            v-model="clinician"
                                            placeholder="Clinician"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            :options="optionsClinician"
                                            item-text="uid"
                                            item-value="uid"
                                            name="uid"
                                            label="agencyAndName"
                                            multiple
                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group
                                        label-for="Date of Contact"
                                    >
                                    <template v-slot:label>
                                        Date of Contact <span class="text-danger">*</span>
                                    </template>
                                        <validation-provider
                                            #default="{ errors }"
                                            name="Date of Contact"
                                            rules="required"
                                        >
                                            <flat-pickr
                                                v-model="dateOfContact"
                                                class="form-control"
                                                placeholder="Select a Date"
                                                :config="{ altInput: true, altFormat: 'F j, Y', dateFormat: 'm-d-Y',}"
                                                :state="errors.length > 0 ? false:null"
                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                            />
                                            <small class="text-danger">{{ errors[0] }}</small>
                                        </validation-provider>
                                    </b-form-group>
                                </b-col>
                                <b-col md="12">
                                    <b-form-group
                                        label="Method of Contact"
                                    >
                                        <v-select
                                            v-model="methodOfContact"
                                            placeholder="Method of Contact"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            :options="optionsMethodOfContact"
                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="12">
                                    <b-form-group
                                        label="Caller Type"
                                    >
                                        <v-select
                                            v-model="contactStatus"
                                            placeholder="Caller Type"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            :options="optionsContactStatus"
                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-row class="px-1" v-if="activityStatus === 'Closed - Attended First Session' || activityStatus === 'Closed - Did not attend first session'">
                                    <b-col md="8">
                                        <b-form-group
                                            label-for="Initial Appointment Date"
                                        >
                                        <template v-slot:label>
                                            Initial Appointment Date <span class="text-danger">*</span>
                                        </template>
                                            <validation-provider
                                                #default="{ errors }"
                                                name="Initial Appointment Date"
                                                rules="required"
                                            >
                                                <flat-pickr
                                                    v-model="initialAppointmentDate"
                                                    class="form-control"
                                                    placeholder="Initial Appointment Date"
                                                    :config="{ altInput: true, altFormat: 'F j, Y', dateFormat: 'm-d-Y',}"
                                                    :state="errors.length > 0 ? false:null"
                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="4">
                                        <validation-provider
                                            #default="{ errors }"
                                            name="Time"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Time"
                                            >
                                            <template v-slot:label>
                                                Time <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="time"
                                                    placeholder="Time"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsTime"
                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>
                                </b-row>
                                <b-row class="px-1" v-else-if="activityStatus !== 'Closed - Referred to OASAS Program' && activityStatus !== 'External Referral' && activityStatus !== 'Closed - Received information'">
                                    <b-col md="8">
                                        <b-form-group
                                            label="Initial Appointment Date"
                                            class="pb-0"
                                        >
                                            <flat-pickr
                                                v-model="initialAppointmentDate"
                                                class="form-control pb-0"
                                                placeholder="Initial Appointment Date"
                                                :config="{ altInput: true, altFormat: 'F j, Y', dateFormat: 'm-d-Y H:i',}"
                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                            />
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="4">
                                        <b-form-group
                                            label="Time"
                                        >
                                            <v-select
                                                v-model="time"
                                                placeholder="Time"
                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                :options="optionsTime"
                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                            />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row class="px-1">
                                    <b-col :md="referredBy === 'Family member/Self' || referredBy === 'Problem Gambling Treatment Services' || referredBy === 'Problem Gambling Self-Help Group Meetings' || referredBy === 'Substance Use Treatment Services' || referredBy === 'Recovery Support Services' || referredBy === 'Other' || referredBy === 'HOPEline' ? '6' : '12'">
                                        <validation-provider
                                            #default="{ errors }"
                                            name="How was client referred for services?"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="How was client referred for services?"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                How was client referred for services? <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="referredBy"
                                                    placeholder="How was client referred for services?"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsReferredBy"
                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>

                                    <b-col md="6" v-if="referredBy === 'Family member/Self'">
                                        <validation-provider
                                            #default="{ errors }"
                                            name="Family member/Self"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Family member/Self"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                <b>Family member/Self</b> <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="familyMemberSelf"
                                                    placeholder="Family member/Self"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsFamilyMemberSelf"
                                                    style=""
                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>
                                    <b-col md="6" v-if="referredBy === 'Problem Gambling Treatment Services'">
                                        <validation-provider
                                            #default="{ errors }"
                                            name="Problem Gambling Treatment Services"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Problem Gambling Treatment Services"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                <b>Problem Gambling Treatment Services</b> <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="problemGamblingTreatmentServices"
                                                    placeholder="Problem Gambling Treatment Services"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsProblemGamblingTreatmentServices"
                                                    style=""
                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>
                                    <b-col md="6" v-if="referredBy === 'Problem Gambling Self-Help Group Meetings'">
                                        <validation-provider
                                            #default="{ errors }"
                                            name="Problem Gambling Self-Help Group Meetings"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Problem Gambling Self-Help Group Meetings"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                <b>Problem Gambling Self-Help Group Meetings</b> <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="problemGamblingSelfHelpGroupMeetings"
                                                    placeholder="Problem Gambling Self-Help Group Meetings"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsProblemGamblingSelfHelpGroupMeetings"
                                                    style=""
                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>
                                    <b-col md="6" v-if="referredBy === 'Substance Use Treatment Services'">
                                        <validation-provider
                                            #default="{ errors }"
                                            name="Substance Use Treatment Services"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Substance Use Treatment Services"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                <b>Substance Use Treatment Services</b> <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="substanceUseTreatmentServices"
                                                    placeholder="Substance Use Treatment Services"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsSubstanceUseTreatmentServices"
                                                    style=""
                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>
                                    <b-col md="6" v-if="referredBy === 'Recovery Support Services'">
                                        <validation-provider
                                            #default="{ errors }"
                                            name="Recovery Support Services"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Recovery Support Services"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                <b>Recovery Support Services</b> <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="recoverySupportServices"
                                                    placeholder="Recovery Support Services"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsRecoverySupportServices"
                                                    style=""
                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>
                                    <b-col md="6" v-if="referredBy === 'Other'">
                                        <b-form-group
                                            label-for="Other"
                                        >
                                        <template v-slot:label>
                                            <b>Other</b> <span class="text-danger">*</span>
                                        </template>
                                            <validation-provider
                                                #default="{ errors }"
                                                name="Other"
                                                rules="required"
                                            >
                                                <b-form-textarea
                                                    placeholder="Other"
                                                    rows="3"
                                                    v-model="otherReferredBy"
                                                    style=""
                                                    :state="errors.length > 0 ? false:null"
                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6" v-if="referredBy === 'HOPEline'">
                                        <validation-provider
                                            #default="{ errors }"
                                            name="Warm Transfer"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Warm Transfer"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                <b>Warm Transfer</b> <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="warmTransfer"
                                                    placeholder="Warm Transfer"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsWarmTransfer"
                                                    style=""
                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>
                                </b-row>
                                <b-row class="px-1">
                                    <b-col :md="informationKitAccepted === 'Yes' ? '12' : '12'">
                                        <b-form-group
                                            label="Information Kit Accepted"
                                        >
                                            <v-select
                                                v-model="informationKitAccepted"
                                                placeholder="Information Kit Accepted"
                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                :options="optionsInformationKitAccepted"
                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                            />
                                        </b-form-group>
                                    </b-col>
                                    <!-- <b-col :md="informationKitAccepted === 'Yes' ? '6' : '12'" v-if="informationKitAccepted === 'Yes'">
                                        <b-form-group
                                            label="Information Kit Option"
                                        >
                                            <v-select
                                                v-model="informationKitOption"
                                                placeholder="Information Kit Option"
                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                :options="optionsInformationKitOption"
                                                multiple
                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                            />
                                        </b-form-group>
                                    </b-col> -->
                                </b-row>
                                <b-row class="px-1">
                                    <b-col :md="regionalCFEReceivingTheCall === 'NYC' ? '6' : '12'">
                                        <b-form-group
                                            label="Regional PGRC Receiving the Call"
                                        >
                                            <v-select
                                                v-model="regionalCFEReceivingTheCall"
                                                placeholder="Regional PGRC Receiving the Call"
                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                :options="optionsRegionalCFEReceivingTheCall"
                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                            />
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6" v-if="regionalCFEReceivingTheCall === 'NYC'">
                                        <b-form-group
                                            label="Borough"
                                        >
                                            <v-select
                                                v-model="borough"
                                                placeholder="Borough"
                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                :options="optionsBorough"
                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                            />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-col md="12">
                                    <b-form-group
                                        label="Readmission"
                                    >
                                        <v-select
                                            v-model="readmission"
                                            placeholder="Readmission"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            :options="optionsReadmission"
                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="12">
                                    <!-- Connected to Peer Advocate -->
                                    <b-form-group
                                        label="Connected to Peer Advocate"
                                        label-for="Connected to Peer Advocate"
                                    >
                                        <v-select
                                            v-model="connectedToPeerAdvocate"
                                            placeholder="Connected to Peer Advocate"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            :options="optionsConnectedToPeerAdvocate"
                                            :disabled="true"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="12">
                                    <!-- Connected to VSE -->
                                    <b-form-group
                                        label="Connected to VSE"
                                        label-for="Connected to VSE"
                                    >
                                        <v-select
                                            v-model="connectedToVSE"
                                            placeholder="Connected to VSE"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            :options="optionsConnected"
                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="12">
                                    <!-- Connected to peer education group -->
                                    <b-form-group
                                        label="Connected to peer education group"
                                        label-for="Connected to peer education group"
                                    >
                                        <v-select
                                            v-model="connectedToPeerEducationGroup"
                                            placeholder="Connected to peer education group"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            :options="optionsConnected"
                                            :disabled="true"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="12">
                                    <!-- Connected to family education group -->
                                    <b-form-group
                                        label="Connected to family education group"
                                        label-for="Connected to family education group"
                                    >
                                        <v-select
                                            v-model="connectedToFamilyEducationGroup"
                                            placeholder="Connected to family education group"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            :options="optionsConnected"
                                            :disabled="true"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="12">
                                    <!-- Connected to Asian Services Program -->
                                    <b-form-group
                                        label="Connected to Asian Services Program"
                                        label-for="Connected to Asian Services Program"
                                    >
                                        <v-select
                                            v-model="connectedToAsianServicesProgram"
                                            placeholder="Connected to Asian Services Program"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            :options="optionsConnected"
                                            :disabled="true"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="12">
                                    <!-- Connected to GamFin -->
                                    <b-form-group
                                        label="Connected to GamFin"
                                        label-for="Connected to GamFin"
                                    >
                                        <v-select
                                            v-model="connectedToGamFin"
                                            placeholder="Connected to GamFin"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            :options="optionsConnected"
                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="12">
                                    <b-form-group
                                        label-for="In the past few months, how often have you had 4 or more alcoholic drinks (woman)/5 or more drinks (man) on one occasion?"
                                    >
                                    <template v-slot:label>
                                        In the past few months, how often have you had 4 or more alcoholic drinks (woman)/5 or more drinks (man) on one occasion?
                                    </template>
                                            <b-form-textarea
                                                placeholder="In the past few months, how often have you had 4 or more alcoholic drinks (woman)/5 or more drinks (man) on one occasion?"
                                                rows="3"
                                                v-model="inThePastFewMonthsDrinks"
                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                            />
                                    </b-form-group>
                                </b-col>

                                <b-row class="px-1" :style="referralOptions ? 'background: #f3f2f7; border: 1px solid #9b9b9b; border-radius: 10px; padding-top: 15px; padding-bottom: 15px;' : ''">
                                    <b-col :md="referralOptions ? '12' : '12'">
                                        <b-form-group
                                            label="Referral Options"
                                            label-for="Referral Options"
                                        >
                                            <v-select
                                                v-model="referralOptions"
                                                placeholder="Referral Options"
                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                :options="optionsReferralOptions"
                                                style="background: #fff;"
                                                multiple
                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                            />
                                        </b-form-group>
                                    </b-col>

                                    <div :style="referralOptions.includes('OASAS Program') && OASASProgram.length >= 1 ? 'background: rgb(219, 219, 219); border: 1px solid #9b9b9b; border-radius: 10px; padding-top: 15px; padding-bottom: 15px; width: 100%; margin-left: 50px; margin-right: 15px; margin-bottom: 20px;' : 'width: 100%; padding-left: 2.5rem !important;'">
                                        <b-col md="12" v-if="referralOptions.includes('OASAS Program')">
                                            <b-form-group
                                                label="Please select OASAS Program"
                                                label-for="OASAS Program"
                                            >
                                                <v-select
                                                    v-model="OASASProgram"
                                                    placeholder="OASAS Program"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsOASASProgram"
                                                    style="background: #fff;"
                                                    multiple
                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                />
                                            </b-form-group>
                                        </b-col>
                                        <!-- <b-col md="6" v-if="referralOptions === 'OASAS Program' && OASASProgram">
                                        </b-col> -->
                                        <b-col md="12" v-if="referralOptions.includes('OASAS Program') && OASASProgram.includes('Inpatient')">
                                            <b-form-group
                                                label-for="Inpatient"
                                            >
                                            <template v-slot:label>
                                                Inpatient
                                            </template>
                                                    <b-form-textarea
                                                        placeholder="Inpatient"
                                                        rows="3"
                                                        v-model="OASASProgramOptInpatient"
                                                        style="background: #fff;"
                                                        :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                    />
                                            </b-form-group>
                                        </b-col>
                                        <b-col md="12" v-if="referralOptions.includes('OASAS Program') && OASASProgram.includes('Residential')">
                                            <b-form-group
                                                label-for="Residential"
                                            >
                                            <template v-slot:label>
                                                Residential
                                            </template>
                                                    <b-form-textarea
                                                        placeholder="Residential"
                                                        rows="3"
                                                        v-model="OASASProgramOptResidential"
                                                        style="background: #fff;"
                                                        :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                    />
                                            </b-form-group>
                                        </b-col>
                                        <b-col md="12" v-if="referralOptions.includes('OASAS Program') && OASASProgram.includes('Outpatient')">
                                            <b-form-group
                                                label-for="Outpatient"
                                            >
                                            <template v-slot:label>
                                                Outpatient
                                            </template>
                                                    <b-form-textarea
                                                        placeholder="Outpatient"
                                                        rows="3"
                                                        v-model="OASASProgramOptOutpatient"
                                                        style="background: #fff;"
                                                        :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                    />
                                            </b-form-group>
                                        </b-col>
                                    </div>

                                    <b-col md="12" v-if="referralOptions.includes('Private Practitioner')" class="pl-4">
                                        <b-form-group
                                            label-for="Private practitioner"
                                        >
                                        <template v-slot:label>
                                            Private practitioner
                                        </template>
                                                <b-form-input
                                                    placeholder="Private practitioner"
                                                    rows="3"
                                                    v-model="privatePractitioner"
                                                    style="background: #fff;"
                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                />
                                        </b-form-group>
                                    </b-col>

                                    <div :style="referralOptions.includes('Recovery Support Services') && referralrecoverySupportServices.length >= 1 ? 'background: rgb(219, 219, 219); border: 1px solid #9b9b9b; border-radius: 10px; padding-top: 15px; padding-bottom: 15px; width: 100%; margin-left: 50px; margin-right: 15px; margin-bottom: 20px;' : 'width: 100%; padding-left: 2.5rem !important;'">
                                        <b-col md="12" v-if="referralOptions.includes('Recovery Support Services')">
                                            <b-form-group
                                                label="Recovery Support Services"
                                                label-for="Recovery Support Services"
                                            >
                                                <v-select
                                                    v-model="referralrecoverySupportServices"
                                                    placeholder="Recovery Support Services"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsRecoverySupportServices"
                                                    style="background: #fff;"
                                                    multiple
                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                />
                                            </b-form-group>
                                        </b-col>

                                        <b-col md="12" v-if="referralOptions.includes('Recovery Support Services') && referralrecoverySupportServices.includes('Recovery Community and Outreach Center')">
                                            <b-form-group
                                                label-for="Recovery Community and Outreach Center"
                                            >
                                            <template v-slot:label>
                                                Recovery Community and Outreach Center
                                            </template>
                                                    <b-form-textarea
                                                        placeholder="Recovery Community and Outreach Center"
                                                        rows="3"
                                                        v-model="recoveryCommunityOutreachCenter"
                                                        style="background: #fff;"
                                                        :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                    />
                                            </b-form-group>
                                        </b-col>
                                        <b-col md="12" v-if="referralOptions.includes('Recovery Support Services') && referralrecoverySupportServices.includes('Youth Clubhouse')">
                                            <b-form-group
                                                label-for="Youth Clubhouse"
                                            >
                                            <template v-slot:label>
                                                Youth Clubhouse
                                            </template>
                                                    <b-form-textarea
                                                        placeholder="Youth Clubhouse"
                                                        rows="3"
                                                        v-model="youthClubhouse"
                                                        style="background: #fff;"
                                                        :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                    />
                                            </b-form-group>
                                        </b-col>
                                        <b-col md="12" v-if="referralOptions.includes('Recovery Support Services') && referralrecoverySupportServices.includes('Peer Advocate')">
                                            <b-form-group
                                                label-for="Peer Advocate"
                                            >
                                            <template v-slot:label>
                                                Peer Advocate
                                            </template>
                                                    <b-form-textarea
                                                        placeholder="Peer Advocate"
                                                        rows="3"
                                                        v-model="peerAdvocate"
                                                        style="background: #fff;"
                                                        :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                    />
                                            </b-form-group>
                                        </b-col>
                                        <b-col md="12" v-if="referralOptions.includes('Recovery Support Services') && referralrecoverySupportServices.includes('Open Access Center')">
                                            <b-form-group
                                                label-for="Open Access Center"
                                            >
                                            <template v-slot:label>
                                                Open Access Center
                                            </template>
                                                    <b-form-textarea
                                                        placeholder="Open Access Center"
                                                        rows="3"
                                                        v-model="openAccessCenter"
                                                        style="background: #fff;"
                                                        :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                    />
                                            </b-form-group>
                                        </b-col>
                                        <b-col md="12" v-if="referralOptions.includes('Recovery Support Services') && referralrecoverySupportServices.includes('Family Navigator')">
                                            <b-form-group
                                                label-for="Family Navigator"
                                            >
                                            <template v-slot:label>
                                                Family Navigator
                                            </template>
                                                    <b-form-textarea
                                                        placeholder="Family Navigator"
                                                        rows="3"
                                                        v-model="familyNavigator"
                                                        style="background: #fff;"
                                                        :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                    />
                                            </b-form-group>
                                        </b-col>
                                        <b-col md="12" v-if="referralOptions.includes('Recovery Support Services') && referralrecoverySupportServices.includes('Regional Addiction Resource Center')">
                                            <b-form-group
                                                label-for="Regional Addiction Resource Center"
                                            >
                                            <template v-slot:label>
                                                Regional Addiction Resource Center
                                            </template>
                                                    <b-form-textarea
                                                        placeholder="Regional Addiction Resource Center"
                                                        rows="3"
                                                        v-model="regionalAddictionResourceCenter"
                                                        style="background: #fff;"
                                                        :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                    />
                                            </b-form-group>
                                        </b-col>
                                    </div>
                                </b-row>
                            </b-col>

                            <!-- RIGHT CONTENT -->
                            <b-col md="4">
                                <b-form-group
                                    label="Special Issues or Other Comments"
                                >
                                    <b-form-textarea
                                        id="textarea-default"
                                        placeholder="Special Issues or Other Comments"
                                        rows="3"
                                        v-model="specialIssuesOrOtherComments"
                                        :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                    />
                                </b-form-group>
                                <b-form-group
                                    label="Call Notes"
                                >
                                    <b-form-textarea
                                        id="textarea-default"
                                        placeholder="Call Notes"
                                        rows="3"
                                        v-model="callNotes"
                                        :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                    />
                                </b-form-group>

                                <!-- Activity Status -->
                                <validation-provider
                                    #default="{ errors }"
                                    name="Activity Status"
                                    rules="required"
                                >
                                    <b-form-group
                                        label-for="Activity Status"
                                        :state="errors.length > 0 ? false:null"
                                    >
                                    <template v-slot:label>
                                        Activity Status <span class="text-danger">*</span>
                                    </template>
                                        <v-select
                                            v-model="activityStatus"
                                            placeholder="Activity Status"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            :options="optionsActivityStatus"
                                            :clearable="false"
                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                        />
                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </validation-provider>

                                <validation-provider
                                    #default="{ errors }"
                                    name="Engaged Status"
                                    rules="required"
                                    v-if="activityStatus === 'Engaged'"
                                >
                                    <b-form-group
                                        label-for="Engaged Status"
                                        :state="errors.length > 0 ? false:null"
                                    >
                                    <template v-slot:label>
                                        Engaged Status <span class="text-danger">*</span>
                                    </template>
                                        <v-select
                                            v-model="engagedStatus"
                                            placeholder="Engaged Status"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            :options="optionsEngagedStatus"
                                            :clearable="false"
                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                        />
                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </validation-provider>

                                <validation-provider
                                    #default="{ errors }"
                                    name="Referred to Peer Advocate"
                                    rules="required"
                                    v-if="activityStatus === 'Closed - Referred to OASAS Program'"
                                >
                                    <b-form-group
                                        label-for="Referred to Peer Advocate"
                                    >
                                    <template v-slot:label>
                                        Referred to Peer Advocate 
                                        <span class="text-danger">*</span>
                                    </template>
                                        <v-select
                                            v-model="referredToPeerAdvocate"
                                            placeholder="Referred to Peer Advocate"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            :options="optionsConnected"
                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                        />
                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </validation-provider>

                                <b-form-group
                                    label="Close Notes"
                                    v-if="activityStatus && activityStatus.includes('Closed')"
                                >
                                    <b-form-textarea
                                        id="textarea-default"
                                        placeholder="Close Notes"
                                        rows="3"
                                        v-model="closeNotes"
                                        :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        
                        <b-row cols="12" class="mt-2" v-if="!managerPA && !managerPeerSupervisor && ((activityStatus.includes('Engaged') || activityStatus === 'Engaged' || activityStatus.includes('Admitted')) && (engagedStatus === 'Referred to Clinician' || engagedStatus === 'Referred to Clinician and Peer Advocate' || !engagedStatus))">
                            <!-- Admission -->
                            <b-col md="12" v-if="activityStatus.includes('Engaged')">
                                <b-button
                                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                                    :variant="enterAdmissionInformation ? 'outline-primary' : 'outline-success'"
                                    @click="enterAdmissionInformation ? enterAdmissionInformation = false : enterAdmissionInformation = true"
                                    class="p-50"
                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                >
                                Enter Admission information
                                </b-button>
                            </b-col>

                            <b-col md="12" v-if="enterAdmissionInformation && activityStatus.includes('Engaged') || activityStatus.includes('Admitted')">
                                <b-button
                                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                                    variant="flat-danger"
                                    class="float-right p-0"
                                    v-if="!clinicianOrClinicianViewer && !removeRecordAdmissionData && !clinicianUsers"
                                    @click="removeRecordAdmission"
                                    :disabled="staffOrClinician ? true : dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                >
                                    <feather-icon
                                        icon="XIcon"
                                        class="mr-50"
                                    />
                                    <span class="align-middle">Remove Record</span>
                                </b-button>
                                <h4 class="mt-2" v-if="!removeRecordAdmissionData">Admission</h4>
                                <hr v-if="!removeRecordAdmissionData">
                                <b-row v-if="!removeRecordAdmissionData">
                                    <b-col md="8">
                                        <b-col md="12">
                                            <b-col md="6">
                                                <b-form-group
                                                    label-for="Date of Admission"
                                                >
                                                <template v-slot:label>
                                                    Date of Admission <span class="text-danger">*</span>
                                                </template>
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Date of Admission"
                                                        rules="required"
                                                    >
                                                        <flat-pickr
                                                            v-model="dateOfAdmission"
                                                            class="form-control"
                                                            placeholder="Select a Date"
                                                            :config="{ altInput: true, altFormat: 'F j, Y', dateFormat: 'm-d-Y',}"
                                                            :state="errors.length > 0 ? false:null"
                                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                        />
                                                        <small class="text-danger">{{ errors[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>
                                            </b-col>
                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="New or Returning Client"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="New or Returning Client"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            New or Returning Client <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="newOrReturningClient"
                                                                placeholder="New or Returning Client"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsNewOrReturningClient"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Client Status"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Client Status"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Client Status <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="clientStatusAdmission"
                                                                placeholder="Client Status"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsClientStatusAdmission"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>
                                            <b-col md="12">
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="Presenting Problems at Admission"
                                                    rules="required"
                                                >
                                                    <b-form-group
                                                        label-for="Presenting Problems at Admission"
                                                        :state="errors.length > 0 ? false:null"
                                                    >
                                                    <template v-slot:label>
                                                        Presenting Problems at Admission <span class="text-danger">*</span>
                                                    </template>
                                                        <v-select
                                                            v-model="presentingProblemsAtAdmission"
                                                            placeholder="Presenting Problems at Admission"
                                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                            :options="optionsPresentingProblemsAtAdmission"
                                                            multiple
                                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                        />
                                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                            {{ errors[0] }}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </validation-provider>
                                            </b-col>
                                            <b-col md="12">
                                                <b-form-group
                                                    label="Other Problems"
                                                >
                                                <template v-slot:label>
                                                    Other Problems <span class="text-danger">*</span>
                                                    <feather-icon
                                                        icon="HelpCircleIcon"
                                                        size="16"
                                                        style="color: #656b85 !important;"
                                                        class="ml-75"
                                                        v-b-tooltip.hover.right="'Please write N/A if it doesn´t apply'"
                                                    />
                                                </template>
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Other Problems"
                                                        rules="required"
                                                    >
                                                        <b-form-input
                                                            v-model="otherProblemsAdmission"
                                                            trim
                                                            placeholder="Other Problems"
                                                            :state="errors.length > 0 ? false:null"
                                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                        />
                                                        <small class="text-danger">{{ errors[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>
                                            </b-col>
                                            <b-col md="12">
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="Diagnostic Criteria Met at Admission"
                                                    rules="required"
                                                >
                                                    <b-form-group
                                                        label-for="Diagnostic Criteria Met at Admission"
                                                        :state="errors.length > 0 ? false:null"
                                                    >
                                                    <template v-slot:label>
                                                        Diagnostic Criteria Met at Admission <span class="text-danger">*</span>
                                                    </template>
                                                        <v-select
                                                            v-model="diagnosticCriteriaMetAtAdmission"
                                                            placeholder="Diagnostic Criteria Met at Admission"
                                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                            :options="optionsDiagnosticCriteriaMetAtAdmission"
                                                            multiple
                                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                        />
                                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                            {{ errors[0] }}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </validation-provider>
                                            </b-col>
                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Client Involved with Legal System"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Client Involved with Legal System"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Client Involved with Legal System <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="clientInvolvedWithLegalSystem"
                                                                placeholder="Client Involved with Legal System"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsClientInvolvedWithLegalSystem"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col md="6" v-if="clientInvolvedWithLegalSystem === 'Yes'">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Legal System"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Legal System"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Legal System <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="legalSystem"
                                                                placeholder="Legal System"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsLegalSystem"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col :md="clientInvolvedWithLegalSystem === 'Yes' ? '12' : '6'">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Client Release Signed"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Client Release Signed"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Client Release Signed <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="clientReleaseSigned"
                                                                placeholder="Client Release Signed"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsClientReleaseSigned"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>

                                            <!-- race and household income -->
                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Race"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Race"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Race <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="race"
                                                                placeholder="Race"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsRace"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>

                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Hispanic Origin"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Hispanic Origin"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Hispanic Origin <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="ethnicity"
                                                                placeholder="Hispanic Origin"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsEthnicity"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>

                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Asian Origin"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Asian Origin"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Asian Origin <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="asianOrigin"
                                                                placeholder="Asian Origin"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsAsianOrigin"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>

                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Pacific Islander Origin"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Pacific Islander Origin"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Pacific Islander Origin <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="pacificIslanderOrigin"
                                                                placeholder="Pacific Islander Origin"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsPacificIslanderOrigin"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>

                                            <b-row class="px-1">
                                                <b-col md="12">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Household Income"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Household Income"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Household Income <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="householdIncome"
                                                                placeholder="Household Income"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsHouseholdIncome"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>

                                            <!-- Primary Gambling Type and Employment Status -->
                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Types of Gambling Engaged In"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Types of Gambling Engaged In"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Types of Gambling Engaged In <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="gamblingTypes"
                                                                placeholder="Types of Gambling Engaged In"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsGamblingTypes"
                                                                multiple
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>

                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Employment Status"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Employment Status"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Employment Status <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="employmentStatus"
                                                                placeholder="Employment Status"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsEmploymentStatus"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>

                                            <!-- Education Levels and Involved With Recovery Groups? -->
                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Highest Grade Completed"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Highest Grade Completed"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Highest Grade Completed <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="educationLevels"
                                                                placeholder="Highest Grade Completed"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsEducationLevels"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>

                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Veteran"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Veteran"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Veteran <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="veteran"
                                                                placeholder="Veteran"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsVeteran"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>

                                            <!-- Ethnicity and veteran  -->
                                            <!-- <b-row class="px-1">
                                            </b-row> -->

                                            <!-- Zip code and Industry of employment  -->
                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <!-- Zip code -->
                                                    <b-form-group
                                                        label-for="Zip code"
                                                    >
                                                    <template v-slot:label>
                                                        Zip code <span class="text-danger">*</span>
                                                        <feather-icon
                                                            icon="HelpCircleIcon"
                                                            size="16"
                                                            style="color: #656b85 !important;"
                                                            class="ml-75"
                                                            v-b-tooltip.hover.right="'Please write N/A if it doesn´t apply'"
                                                        />
                                                    </template>
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="Zip code"
                                                            rules="required"
                                                        >
                                                            <b-form-input
                                                                v-model="zipCode"
                                                                trim
                                                                placeholder="Zip code"
                                                                :state="errors.length > 0 ? false:null"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                        </validation-provider>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Industry of employment"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Industry of employment"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Industry of employment <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="industryOfEmployment"
                                                                placeholder="Industry of employment"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsIndustryOfEmployment"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>

                                            <!-- Marital status and Religious preference  -->
                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Marital status"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Marital status"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Marital status <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="maritalStatus"
                                                                placeholder="Marital status"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsMaritalStatus"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>

                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Religious preference"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Religious preference"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Religious preference <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="religiousPreference"
                                                                placeholder="Religious preference"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsReligiousPreference"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>

                                            <b-row class="px-1">
                                                <b-col :md="primaryICD10 === 'Z72.6 Gambling and Betting' ? '6' : '12'">
                                                    <b-form-group
                                                        label-for="Primary ICD-10 Diagnosis Code"
                                                        v-if="clientStatusAdmission === 'Family Member'"
                                                    >
                                                    <template v-slot:label>
                                                        Primary ICD-10 Diagnosis Code
                                                    </template>
                                                        <v-select
                                                            v-model="primaryICD10"
                                                            placeholder="Primary ICD-10 Diagnosis Code"
                                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                            :options="optionsPrimaryICD10"
                                                            :disabled="true"
                                                        />
                                                    </b-form-group>
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Primary ICD-10 Diagnosis Code"
                                                        rules="required"
                                                        v-else
                                                    >
                                                        <b-form-group
                                                            label-for="Primary ICD-10 Diagnosis Code"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Primary ICD-10 Diagnosis Code <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="primaryICD10"
                                                                placeholder="Primary ICD-10 Diagnosis Code"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsPrimaryICD10"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col md="6" v-if="primaryICD10 === 'Z72.6 Gambling and Betting'">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Z72.6 Gambling and Betting"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Z72.6 Gambling and Betting"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Z72.6 Gambling and Betting <span class="text-danger">*</span>
                                                        </template>
                                                            <b-form-textarea
                                                                v-model="Z72GamblingAndBetting"
                                                                id="textarea-default"
                                                                placeholder="Z72.6 Gambling and Betting"
                                                                rows="3"
                                                                :state="errors.length > 0 ? false:null"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>

                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <b-form-group
                                                        label="Number of Assessment Visits"
                                                    >
                                                    <template v-slot:label>
                                                        Number of Assessment Visits <span class="text-danger">*</span>
                                                    </template>
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="Number of Assessment Visits"
                                                            rules="required"
                                                        >
                                                            <b-form-input
                                                                v-model="numberofAssessmentVisits"
                                                                trim
                                                                placeholder="Number of Assessment Visits"
                                                                :state="errors.length > 0 ? false:null"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                        </validation-provider>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Age"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Age"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Age <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="age"
                                                                placeholder="Age"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsAge"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>

                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Sexual Orientation"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Sexual Orientation"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Sexual Orientation <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="sexualOrientation"
                                                                placeholder="Sexual Orientation"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsSexualOrientation"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>

                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Gender Identity"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Gender Identity"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Gender Identity <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="genderIdentity"
                                                                placeholder="Gender Identity"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsGenderIdentity"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>

                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Transgender"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Transgender"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Transgender <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="transgender"
                                                                placeholder="Transgender"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsTransgender"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>

                                            <b-row class="px-1">
                                                <b-col :md="referredByAdmission === 'Other' || referredByAdmission === 'HOPEline' || referredByAdmission === 'Family member/Self' || referredByAdmission === 'Problem Gambling Treatment Services' || referredByAdmission === 'Substance Use Treatment Services' || referredByAdmission === 'Recovery Support Services' ? '12' : '12'">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="How was client referred for services?"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="How was client referred for services?"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            How was client referred for services? <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="referredByAdmission"
                                                                placeholder="How was client referred for services?"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsReferredBy"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>

                                            <b-row class="px-1">
                                                <b-col md="6" v-if="referredByAdmission === 'Family member/Self'">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Family member/Self"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Family member/Self"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            <b>Family member/Self</b> <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="familyMemberSelfAdmission"
                                                                placeholder="Family member/Self"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsFamilyMemberSelf"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col md="6" v-if="referredByAdmission === 'Problem Gambling Treatment Services'">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Problem Gambling Treatment Services"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Problem Gambling Treatment Services"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            <b>Problem Gambling Treatment Services</b> <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="problemGamblingTreatmentServicesAdmission"
                                                                placeholder="Problem Gambling Treatment Services"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsProblemGamblingTreatmentServices"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col md="6" v-if="referredByAdmission === 'Problem Gambling Self-Help Group Meetings'">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Problem Gambling Self-Help Group Meetings"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Problem Gambling Self-Help Group Meetings"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            <b>Problem Gambling Self-Help Group Meetings</b> <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="problemGamblingSelfHelpGroupMeetingsAdmission"
                                                                placeholder="Problem Gambling Self-Help Group Meetings"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsProblemGamblingSelfHelpGroupMeetings"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col md="6" v-if="referredByAdmission === 'Substance Use Treatment Services'">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Substance Use Treatment Services"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Substance Use Treatment Services"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            <b>Substance Use Treatment Services</b> <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="substanceUseTreatmentServicesAdmission"
                                                                placeholder="Substance Use Treatment Services"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsSubstanceUseTreatmentServices"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col md="6" v-if="referredByAdmission === 'Recovery Support Services'">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Recovery Support Services"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Recovery Support Services"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            <b>Recovery Support Services</b> <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="recoverySupportServicesAdmission"
                                                                placeholder="Recovery Support Services"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsRecoverySupportServices"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col md="6" v-if="referredByAdmission === 'Other'">
                                                    <b-form-group
                                                        label-for="Other"
                                                    >
                                                    <template v-slot:label>
                                                        <b>Other</b> <span class="text-danger">*</span>
                                                    </template>
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="Other"
                                                            rules="required"
                                                        >
                                                            <b-form-textarea
                                                                placeholder="Other"
                                                                rows="3"
                                                                v-model="otherReferredByAdmission"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                                :state="errors.length > 0 ? false:null"
                                                            />
                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                        </validation-provider>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col md="6" v-if="referredByAdmission === 'HOPEline'">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Warm Transfer"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Warm Transfer"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            <b>Warm Transfer</b> <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="warmTransferAdmission"
                                                                placeholder="Warm Transfer"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsWarmTransfer"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>

                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Intellectual Disability/Developmental Disability"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Intellectual Disability/Developmental Disability"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Intellectual Disability/Developmental Disability <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="developmentalDisability"
                                                                placeholder="Intellectual Disability/Developmental Disability"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsYesNoPreferNotToAnswer"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>

                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Co-existing Psychiatric Disorder"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Co-existing Psychiatric Disorder"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Co-existing Psychiatric Disorder <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="coexistingPsychiatricDisorder"
                                                                placeholder="Co-existing Psychiatric Disorder"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsYesNoPreferNotToAnswer"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Treated for Mental Illness"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Treated for Mental Illness"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Treated for Mental Illness <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="treatedForMentalIllness"
                                                                placeholder="Treated for Mental Illness"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsYesNoPreferNotToAnswer"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>

                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Hospitalized for Mental Illness"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Hospitalized for Mental Illness"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Hospitalized for Mental Illness <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="hospitalizedForMentalIllness"
                                                                placeholder="Hospitalized for Mental Illness"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsYesNoPreferNotToAnswer"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Hospitalized 30 or more days for Mental Illness"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Hospitalized 30 or more days for Mental Illness"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Hospitalized 30 or more days for Mental Illness <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="hospitalized30OrMoreDaysForMentalIllness"
                                                                placeholder="Hospitalized 30 or more days for Mental Illness"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsYesNoPreferNotToAnswer"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>

                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Smoked tobacco in the past week"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Smoked tobacco in the past week"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Smoked tobacco in the past week <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="smokedTobaccoInThePastWeek"
                                                                placeholder="Smoked tobacco in the past week"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsYesNoPreferNotToAnswer"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Used smokeless tobacco in the past week"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Used smokeless tobacco in the past week"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Used smokeless tobacco in the past week <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="usedSmokelessTobaccoInThePastWeek"
                                                                placeholder="Used smokeless tobacco in the past week"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsYesNoPreferNotToAnswer"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>

                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Substances Used"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Substances Used"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Substances Used <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="substancesUsed"
                                                                placeholder="Substances Used"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsSubstancesUsed"
                                                                multiple
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Substance Use Route of Administration"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Substance Use Route of Administration"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Substance Use Route of Administration <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="substanceUseRouteOfAdministration"
                                                                placeholder="Substance Use Route of Administration"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsSubstanceUseRouteOfAdministration"
                                                                multiple
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>

                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Frequency of Substance Use"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Frequency of Substance Use"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Frequency of Substance Use <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="frequencyOfSubstanceUse"
                                                                placeholder="Frequency of Substance Use"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsFrequencyOfSubstanceUse"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col md="6">
                                                    <b-form-group
                                                        label-for="Age of First Substance Use"
                                                    >
                                                    <template v-slot:label>
                                                        Age of First Substance Use <span class="text-danger">*</span>
                                                    </template>
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="Age of First Substance Use"
                                                            rules="required"
                                                        >
                                                            <b-form-textarea
                                                                placeholder="Age of First Substance Use"
                                                                rows="3"
                                                                v-model="ageOfFirstSubstanceUse"
                                                                :state="errors.length > 0 ? false:null"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                        </validation-provider>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>

                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Frequency of Gambling"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Frequency of Gambling"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Frequency of Gambling <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="frequencyofGambling"
                                                                placeholder="Frequency of Gambling"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsFrequencyofGambling"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group
                                                        label-for="Age First Gambled"
                                                    >
                                                    <template v-slot:label>
                                                        Age First Gambled <span class="text-danger">*</span>
                                                    </template>
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="Age First Gambled"
                                                            rules="required"
                                                        >
                                                            <b-form-input
                                                                v-model="ageFirstGambled"
                                                                trim
                                                                placeholder="Age First Gambled"
                                                                :state="errors.length > 0 ? false:null"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                        </validation-provider>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>

                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <b-form-group
                                                        label-for="During the past 30 days, what amount of money did you spend on a typical day of gambling?"
                                                    >
                                                    <template v-slot:label>
                                                        During the past 30 days, what amount of money did you spend on a typical day of gambling? <span class="text-danger">*</span>
                                                    </template>
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="During the past 30 days, what amount of money did you spend on a typical day of gambling?"
                                                            rules="required"
                                                        >
                                                            <b-form-input
                                                                v-model="past30DaysAmountOfMoney"
                                                                trim
                                                                placeholder="During the past 30 days, what amount of money did you spend on a typical day of gambling?"
                                                                :state="errors.length > 0 ? false:null"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                        </validation-provider>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group
                                                        label-for="During the past 30 days, how much time did you usually spend on a typical day of gambling?"
                                                    >
                                                    <template v-slot:label>
                                                        During the past 30 days, how much time did you usually spend on a typical day of gambling? <span class="text-danger">*</span>
                                                    </template>
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="During the past 30 days, how much time did you usually spend on a typical day of gambling?"
                                                            rules="required"
                                                        >
                                                            <b-form-input
                                                                v-model="past30DaysHowMuchTime"
                                                                trim
                                                                placeholder="During the past 30 days, how much time did you usually spend on a typical day of gambling?"
                                                                :state="errors.length > 0 ? false:null"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                        </validation-provider>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>

                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <b-form-group
                                                        label-for="During the past 30 days, on how many days did you gamble?"
                                                    >
                                                    <template v-slot:label>
                                                        During the past 30 days, on how many days did you gamble? <span class="text-danger">*</span>
                                                    </template>
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="During the past 30 days, on how many days did you gamble?"
                                                            rules="required"
                                                        >
                                                            <b-form-input
                                                                v-model="past30DaysHowManyDays"
                                                                trim
                                                                placeholder="During the past 30 days, on how many days did you gamble?"
                                                                :state="errors.length > 0 ? false:null"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                        </validation-provider>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Gambling locations during the past 12 months"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Gambling locations during the past 12 months"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Gambling locations during the past 12 months <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="gamblinglocationspast12months"
                                                                placeholder="Gambling locations during the past 12 months"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsGamblinglocationspast12months"
                                                                multiple
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>

                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Has client attended or received services for any reason from"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Has client attended or received services for any reason from"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Has client attended or received services for any reason from <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="hasClientAttendedReceivedServices"
                                                                placeholder="Has client attended or received services for any reason from"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsHasClientAttendedReceivedServices"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                            </b-row>

                                            <hr>

                                            <b-row class="px-1" v-if="clientStatusAdmission === 'Family Member'">
                                                <b-col md="6">
                                                    <b-form-group
                                                        label-for="LOCADTR-G Completed"
                                                    >
                                                    <template v-slot:label>
                                                        LOCADTR-G Completed
                                                    </template>
                                                        <date-picker
                                                            v-model="locadtrg"
                                                            placeholder="Select a Date"
                                                            type="date"
                                                            format="MMM DD, Y"
                                                            value-type="MM-DD-YYYY"
                                                            style="max-width: 100% !important; width: 100% !important;"
                                                            :disabled="true"
                                                        ></date-picker>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col md="6">
                                                    <b-form-group
                                                        label-for="LOCADTR-G Assessment ID"
                                                    >
                                                    <template v-slot:label>
                                                        LOCADTR-G Assessment ID
                                                    </template>
                                                        <b-form-input
                                                            v-model="LOCADTRAssessmentID"
                                                            trim
                                                            placeholder="LOCADTR-G Assessment ID"
                                                            style="cursor: not-allowed;"
                                                            :disabled="true"
                                                        />
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row class="px-1" v-else>
                                                <b-col md="6">
                                                    <b-form-group
                                                        label-for="LOCADTR-G Completed"
                                                    >
                                                    <template v-slot:label>
                                                        LOCADTR-G Completed <span class="text-danger">*</span>
                                                    </template>
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="LOCADTR-G Completed"
                                                            rules="required"
                                                        >
                                                            <date-picker
                                                                v-model="locadtrg"
                                                                placeholder="Select a Date"
                                                                type="date"
                                                                format="MMM DD, Y"
                                                                value-type="MM-DD-YYYY"
                                                                style="max-width: 100% !important; width: 100% !important;"
                                                                :state="errors.length > 0 ? false:null"
                                                            ></date-picker>
                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                        </validation-provider>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col md="6">
                                                    <b-form-group
                                                        label-for="LOCADTR-G Assessment ID"
                                                    >
                                                    <template v-slot:label>
                                                        LOCADTR-G Assessment ID <span class="text-danger">*</span>
                                                    </template>
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="LOCADTR-G Assessment ID"
                                                            rules="required"
                                                        >
                                                            <b-form-input
                                                                v-model="LOCADTRAssessmentID"
                                                                trim
                                                                placeholder="LOCADTR-G Assessment ID"
                                                                :state="errors.length > 0 ? false:null"
                                                            />
                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                        </validation-provider>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-col>

                                    <!-- RIGHT CONTENT -->
                                    <b-col md="4">
                                        <b-form-group
                                            label="Notes"
                                        >
                                            <b-form-textarea
                                                id="textarea-default"
                                                placeholder="Notes"
                                                rows="3"
                                                v-model="notesAdmission"
                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                            />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>

                        <b-row cols="12" class="mt-2" v-if="!managerPA && !managerPeerSupervisor && ((activityStatus.includes('Engaged') || activityStatus === 'Engaged') && (engagedStatus === 'Referred to Clinician' || engagedStatus === 'Referred to Clinician and Peer Advocate' || !engagedStatus))">
                            <!-- Discharge -->
                            <b-col md="12" v-if="activityStatus.includes('Engaged')">
                                <b-button
                                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                                    :variant="enterDischargeInformation ? 'outline-primary' : 'outline-success'"
                                    @click="enterDischargeInformation ? enterDischargeInformation = false : enterDischargeInformation = true"
                                    class="p-50"
                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                >
                                Enter Discharge information
                                </b-button>
                            </b-col>

                            <b-col md="12" v-if="enterDischargeInformation && activityStatus.includes('Engaged') || activityStatus.includes('Discharged')">
                                <b-button
                                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                                    variant="flat-danger"
                                    class="float-right p-0 mt-2"
                                    v-if="!clinicianOrClinicianViewer && !removeRecordDischargeData && !clinicianUsers"
                                    @click="removeRecordDischarge"
                                    :disabled="staffOrClinician ? true : dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                >
                                    <feather-icon
                                        icon="XIcon"
                                        class="mr-50"
                                    />
                                    <span class="align-middle">Remove Record</span>
                                </b-button>
                                <h4 class="mt-2" v-if="!removeRecordDischargeData">Discharge</h4>
                                <hr v-if="!removeRecordDischargeData">
                                <b-row v-if="!removeRecordDischargeData">
                                    <b-col md="8">
                                        <b-col md="12">
                                            <b-col md="6">
                                                <b-form-group
                                                    label-for="Date of Discharge"
                                                >
                                                <template v-slot:label>
                                                    Date of Discharge <span class="text-danger">*</span>
                                                </template>
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Date of Discharge"
                                                        rules="required"
                                                    >
                                                        <b-form-input
                                                            v-model="dateOfDischarge"
                                                            :state="errors.length > 0 ? false:null"
                                                            placeholder="Select a Date"
                                                            class="form-control"
                                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            v-if="dateOfDischarge === 'N/A'"
                                                        />
                                                        <flat-pickr
                                                            v-model="dateOfDischarge"
                                                            class="form-control"
                                                            placeholder="Select a Date"
                                                            :config="{ altInput: true, altFormat: 'F j, Y', dateFormat: 'm-d-Y', allowInput: true, onKeyDown: (selectedDates, dateStr, instance, event) => {
                                                                filtChange(event)
                                                            }}"
                                                            :state="errors.length > 0 ? false:null"
                                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            v-else
                                                        />
                                                        <small class="text-danger">{{ errors[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>
                                            </b-col>

                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Discharge Status"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Discharge Status"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Discharge Status <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="dischargeStatus"
                                                                placeholder="Discharge Status"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsDischargeStatus"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col md="6" v-if="dischargeStatus">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Planned discharge reasons"
                                                        rules="required"
                                                        v-if="dischargeStatus === 'Planned'"
                                                    >
                                                        <b-form-group
                                                            label-for="Planned discharge reasons"
                                                            v-if="dischargeStatus === 'Planned'"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Planned discharge reasons <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="plannedDischargeReasons"
                                                                placeholder="Planned discharge reasons"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsPlannedDischargeReasons"
                                                                multiple
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>

                                                    <b-form-group
                                                        label-for="Unplanned discharge reason"
                                                        v-else-if="dischargeStatus === 'Dropout'"
                                                    >
                                                    <template v-slot:label>
                                                        Unplanned discharge reason <span class="text-danger">*</span>
                                                    </template>
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="Unplanned discharge reason"
                                                            rules="required"
                                                        >
                                                            <b-form-textarea
                                                                placeholder="Unplanned discharge reason"
                                                                rows="3"
                                                                v-model="unplannedDischargeReason"
                                                                :state="errors.length > 0 ? false:null"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                        </validation-provider>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-col md="12">
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="Discharge Disposition"
                                                    rules="required"
                                                >
                                                    <b-form-group
                                                        label-for="Discharge Disposition"
                                                        :state="errors.length > 0 ? false:null"
                                                    >
                                                    <template v-slot:label>
                                                        Discharge Disposition <span class="text-danger">*</span>
                                                    </template>
                                                        <v-select
                                                            v-model="dischargeDisposition"
                                                            placeholder="Discharge Disposition"
                                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                            :options="optionsDischargeDisposition"
                                                            multiple
                                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                        />
                                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                            {{ errors[0] }}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </validation-provider>
                                            </b-col>
                                            <b-col md="12">
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="Referral Disposition"
                                                    rules="required"
                                                >
                                                    <b-form-group
                                                        label-for="Referral Disposition"
                                                        :state="errors.length > 0 ? false:null"
                                                    >
                                                    <template v-slot:label>
                                                        Referral Disposition <span class="text-danger">*</span>
                                                    </template>
                                                        <v-select
                                                            v-model="referralDisposition"
                                                            placeholder="Referral Disposition"
                                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                            :options="optionsReferralDisposition"
                                                            multiple
                                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                        />
                                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                            {{ errors[0] }}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </validation-provider>
                                            </b-col>
                                            <b-col md="12">
                                                <b-form-group
                                                    label-for="Number of Sessions Attended"
                                                >
                                                <template v-slot:label>
                                                    Number of Sessions Attended <span class="text-danger">*</span>
                                                </template>
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Number of Sessions Attended"
                                                        rules="required"
                                                    >
                                                        <b-form-input
                                                            v-model="numberOfSessionsAttended"
                                                            :state="errors.length > 0 ? false:null"
                                                            placeholder="Number of Sessions Attended"
                                                            class="form-control"
                                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            v-if="optionsStringsNumberSessions.includes(numberOfSessionsAttended)"
                                                        />
                                                        <cleave
                                                            v-model="numberOfSessionsAttended"
                                                            class="form-control"
                                                            :raw="false"
                                                            :options="options.block"
                                                            placeholder="Number of Sessions Attended"
                                                            :state="errors.length > 0 ? false:null"
                                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            v-else
                                                        />
                                                        <small class="text-danger">{{ errors[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>
                                            </b-col>
                                            <b-col md="12">
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="Diagnostic Criteria Met at Admission was Reduced"
                                                    rules="required"
                                                >
                                                    <b-form-group
                                                        label-for="Diagnostic Criteria Met at Admission was Reduced"
                                                        :state="errors.length > 0 ? false:null"
                                                    >
                                                    <template v-slot:label>
                                                        Diagnostic Criteria Met at Admission was Reduced <span class="text-danger">*</span>
                                                    </template>
                                                        <v-select
                                                            v-model="diagnosticCriteriaMetAtAdmissionWasReduced"
                                                            placeholder="Diagnostic Criteria Met at Admission was Reduced"
                                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                            :options="optionsDiagnosticCriteriaMetAtAdmissionWasReduced"
                                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                        />
                                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                            {{ errors[0] }}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </validation-provider>
                                            </b-col>
                                            <b-col md="12" v-if="diagnosticCriteriaMetAtAdmissionWasReduced === 'Yes'">
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="Diagnostic Criteria Met at Discharge"
                                                    rules="required"
                                                >
                                                    <b-form-group
                                                        label-for="Diagnostic Criteria Met at Discharge"
                                                        :state="errors.length > 0 ? false:null"
                                                    >
                                                    <template v-slot:label>
                                                        Diagnostic Criteria Met at Discharge <span class="text-danger">*</span>
                                                    </template>
                                                        <v-select
                                                            v-model="diagnosticCriteriaMetAtDischarge"
                                                            placeholder="Diagnostic Criteria Met at Discharge"
                                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                            :options="optionsDiagnosticCriteriaMetAtAdmission"
                                                            multiple
                                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                        />
                                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                            {{ errors[0] }}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </validation-provider>
                                            </b-col>
                                            <b-col md="12">
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="Current Gambling Compared to Admission"
                                                    rules="required"
                                                >
                                                    <b-form-group
                                                        label-for="Current Gambling Compared to Admission"
                                                        :state="errors.length > 0 ? false:null"
                                                    >
                                                    <template v-slot:label>
                                                        Current Gambling Compared to Admission <span class="text-danger">*</span>
                                                    </template>
                                                        <v-select
                                                            v-model="currentGamblingComparedToAdmission"
                                                            placeholder="Current Gambling Compared to Admission"
                                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                            :options="optionsCurrentGamblingComparedToAdmission"
                                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                        />
                                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                            {{ errors[0] }}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </validation-provider>
                                            </b-col>
                                            <b-col md="12">
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="Client Involved with Self-Help at Discharge"
                                                    rules="required"
                                                >
                                                    <b-form-group
                                                        label-for="Client Involved with Self-Help at Discharge"
                                                        :state="errors.length > 0 ? false:null"
                                                    >
                                                    <template v-slot:label>
                                                        Client Involved with Self-Help at Discharge <span class="text-danger">*</span>
                                                    </template>
                                                        <v-select
                                                            v-model="clientInvolvedWithSelfHelpAtDischarge"
                                                            placeholder="Client Involved with Self-Help at Discharge"
                                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                            :options="optionsClientInvolvedWithSelfHelpAtDischarge"
                                                            :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                        />
                                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                            {{ errors[0] }}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </validation-provider>
                                            </b-col>
                                            <b-row class="px-1">
                                                <b-col :md="clientReferredForContinuedServices === 'Problem Gambling Treatment Services' || clientReferredForContinuedServices === 'Substance Use Treatment Services' || clientReferredForContinuedServices === 'Recovery Support Services' || clientReferredForContinuedServices === 'Other' ? '6' : '12'">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Client Referred for Continued Services"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Client Referred for Continued Services"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Client Referred for Continued Services <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="clientReferredForContinuedServices"
                                                                placeholder="Client Referred for Continued Services"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsClientReferredForContinuedServices"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col :md="'6'" v-if="clientReferredForContinuedServices === 'Problem Gambling Treatment Services'">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Problem Gambling Treatment Services"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Problem Gambling Treatment Services"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Problem Gambling Treatment Services <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="admissionproblemGamblingTreatmentServices"
                                                                placeholder="Problem Gambling Treatment Services"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsProblemGamblingTreatmentServices"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col :md="'6'" v-if="clientReferredForContinuedServices === 'Substance Use Treatment Services'">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Substance Use Treatment Services"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Substance Use Treatment Services"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Substance Use Treatment Services <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="admissionsubstanceUseTreatmentServices"
                                                                placeholder="Substance Use Treatment Services"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsSubstanceUseTreatmentServices"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col :md="'6'" v-if="clientReferredForContinuedServices === 'Recovery Support Services'">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Recovery Support Services"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Recovery Support Services"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Recovery Support Services <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="admissionrecoverySupportServices"
                                                                placeholder="Recovery Support Services"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsRecoverySupportServices"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col md="6" v-if="clientReferredForContinuedServices === 'Other'">
                                                    <b-form-group
                                                        label-for="Other (please describe)"
                                                    >
                                                    <template v-slot:label>
                                                        Other (please describe) <span class="text-danger">*</span>
                                                    </template>
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="Other Problems"
                                                            rules="required"
                                                        >
                                                            <b-form-input
                                                                v-model="otherClientReferredforContinuedServices"
                                                                placeholder="please describe"
                                                                trim
                                                                :state="errors.length > 0 ? false:null"
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                        </validation-provider>
                                                    </b-form-group>
                                                </b-col>

                                                <!-- <b-col :md="'6'" v-if="clientReferredForContinuedServices === 'Yes'">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="If so, what services were recommended"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="If so, what services were recommended"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            If so, what services were recommended <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="ifSoWhatServicesWereRecommended"
                                                                placeholder="If so, what services were recommended"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsIfSoWhatServicesWereRecommended"
                                                                multiple
                                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col> -->
                                            </b-row>

                                            <b-row class="px-1">
                                                <h6 class="mt-2">Status of Gambling Related Problems</h6>
                                                <hr style="width: 100%;">
                                                <b-row class="px-1">
                                                    <b-col :md="'6'">
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="Gambling"
                                                            rules="required"
                                                        >
                                                            <b-form-group
                                                                label-for="Gambling"
                                                                :state="errors.length > 0 ? false:null"
                                                            >
                                                            <template v-slot:label>
                                                                Gambling <span class="text-danger">*</span>
                                                            </template>
                                                                <v-select
                                                                    v-model="relatedProblemsGambling"
                                                                    placeholder="Gambling"
                                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                    :options="optionsGamblingRelatedProblems"
                                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                                />
                                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                    {{ errors[0] }}
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </validation-provider>
                                                    </b-col>
                                                    <b-col :md="'6'">
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="Drug Use"
                                                            rules="required"
                                                        >
                                                            <b-form-group
                                                                label-for="Drug Use"
                                                                :state="errors.length > 0 ? false:null"
                                                            >
                                                            <template v-slot:label>
                                                                Drug Use <span class="text-danger">*</span>
                                                            </template>
                                                                <v-select
                                                                    v-model="relatedProblemsDrugUse"
                                                                    placeholder="Drug Use"
                                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                    :options="optionsGamblingRelatedProblems"
                                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                                />
                                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                    {{ errors[0] }}
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </validation-provider>
                                                    </b-col>
                                                    <b-col :md="'6'">
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="Alcohol Use"
                                                            rules="required"
                                                        >
                                                            <b-form-group
                                                                label-for="Alcohol Use"
                                                                :state="errors.length > 0 ? false:null"
                                                            >
                                                            <template v-slot:label>
                                                                Alcohol Use <span class="text-danger">*</span>
                                                            </template>
                                                                <v-select
                                                                    v-model="relatedProblemsAlcoholUse"
                                                                    placeholder="Alcohol Use"
                                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                    :options="optionsGamblingRelatedProblems"
                                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                                />
                                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                    {{ errors[0] }}
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </validation-provider>
                                                    </b-col>
                                                    <b-col :md="'6'">
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="Financial"
                                                            rules="required"
                                                        >
                                                            <b-form-group
                                                                label-for="Financial"
                                                                :state="errors.length > 0 ? false:null"
                                                            >
                                                            <template v-slot:label>
                                                                Financial <span class="text-danger">*</span>
                                                            </template>
                                                                <v-select
                                                                    v-model="relatedProblemsFinancial"
                                                                    placeholder="Financial"
                                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                    :options="optionsGamblingRelatedProblems"
                                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                                />
                                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                    {{ errors[0] }}
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </validation-provider>
                                                    </b-col>
                                                    <b-col :md="'6'">
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="Legal"
                                                            rules="required"
                                                        >
                                                            <b-form-group
                                                                label-for="Legal"
                                                                :state="errors.length > 0 ? false:null"
                                                            >
                                                            <template v-slot:label>
                                                                Legal <span class="text-danger">*</span>
                                                            </template>
                                                                <v-select
                                                                    v-model="relatedProblemsLegal"
                                                                    placeholder="Legal"
                                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                    :options="optionsGamblingRelatedProblems"
                                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                                />
                                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                    {{ errors[0] }}
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </validation-provider>
                                                    </b-col>
                                                    <b-col :md="'6'">
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="Vocational/Educational"
                                                            rules="required"
                                                        >
                                                            <b-form-group
                                                                label-for="Vocational/Educational"
                                                                :state="errors.length > 0 ? false:null"
                                                            >
                                                            <template v-slot:label>
                                                                Vocational/Educational <span class="text-danger">*</span>
                                                            </template>
                                                                <v-select
                                                                    v-model="relatedProblemsVocationalEducational"
                                                                    placeholder="Vocational/Educational"
                                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                    :options="optionsGamblingRelatedProblems"
                                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                                />
                                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                    {{ errors[0] }}
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </validation-provider>
                                                    </b-col>
                                                    <b-col :md="'6'">
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="Medical/Health"
                                                            rules="required"
                                                        >
                                                            <b-form-group
                                                                label-for="Medical/Health"
                                                                :state="errors.length > 0 ? false:null"
                                                            >
                                                            <template v-slot:label>
                                                                Medical/Health <span class="text-danger">*</span>
                                                            </template>
                                                                <v-select
                                                                    v-model="relatedProblemsMedicalHealth"
                                                                    placeholder="Medical/Health"
                                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                    :options="optionsGamblingRelatedProblems"
                                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                                />
                                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                    {{ errors[0] }}
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </validation-provider>
                                                    </b-col>
                                                    <b-col :md="'6'">
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="Lethality: Self"
                                                            rules="required"
                                                        >
                                                            <b-form-group
                                                                label-for="Lethality: Self"
                                                                :state="errors.length > 0 ? false:null"
                                                            >
                                                            <template v-slot:label>
                                                                Lethality: Self <span class="text-danger">*</span>
                                                            </template>
                                                                <v-select
                                                                    v-model="relatedProblemsLethalitySelf"
                                                                    placeholder="Lethality: Self"
                                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                    :options="optionsGamblingRelatedProblems"
                                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                                />
                                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                    {{ errors[0] }}
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </validation-provider>
                                                    </b-col>
                                                    <b-col :md="'6'">
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="Lethality: Other"
                                                            rules="required"
                                                        >
                                                            <b-form-group
                                                                label-for="Lethality: Other"
                                                                :state="errors.length > 0 ? false:null"
                                                            >
                                                            <template v-slot:label>
                                                                Lethality: Other <span class="text-danger">*</span>
                                                            </template>
                                                                <v-select
                                                                    v-model="relatedProblemsLethalityOther"
                                                                    placeholder="Lethality: Other"
                                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                    :options="optionsGamblingRelatedProblems"
                                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                                />
                                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                    {{ errors[0] }}
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </validation-provider>
                                                    </b-col>
                                                    <b-col :md="'6'">
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="Mental Health"
                                                            rules="required"
                                                        >
                                                            <b-form-group
                                                                label-for="Mental Health"
                                                                :state="errors.length > 0 ? false:null"
                                                            >
                                                            <template v-slot:label>
                                                                Mental Health <span class="text-danger">*</span>
                                                            </template>
                                                                <v-select
                                                                    v-model="relatedProblemsMentalHealth"
                                                                    placeholder="Mental Health"
                                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                    :options="optionsGamblingRelatedProblems"
                                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                                />
                                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                    {{ errors[0] }}
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </validation-provider>
                                                    </b-col>
                                                    <b-col :md="'6'">
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="Family"
                                                            rules="required"
                                                        >
                                                            <b-form-group
                                                                label-for="Family"
                                                                :state="errors.length > 0 ? false:null"
                                                            >
                                                            <template v-slot:label>
                                                                Family <span class="text-danger">*</span>
                                                            </template>
                                                                <v-select
                                                                    v-model="relatedProblemsFamily"
                                                                    placeholder="Family"
                                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                    :options="optionsGamblingRelatedProblems"
                                                                    :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                                />
                                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                    {{ errors[0] }}
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </validation-provider>
                                                    </b-col>
                                                </b-row>
                                            </b-row>
                                        </b-col>
                                    </b-col>

                                    <!-- RIGHT CONTENT -->
                                    <b-col md="4">
                                        <b-form-group
                                            label="Notes"
                                        >
                                            <b-form-textarea
                                                id="textarea-default"
                                                placeholder="Notes"
                                                rows="3"
                                                v-model="notesDischarge"
                                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                            />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>

                        <b-row cols="12" class="mt-2" v-if="!managerPA && !managerPeerSupervisor && ((activityStatus.includes('Engaged') || activityStatus === 'Engaged' || activityStatus.includes('Admitted') || activityStatus.includes('Discharged')) && (engagedStatus === 'Referred to Clinician' || engagedStatus === 'Referred to Clinician and Peer Advocate' || !engagedStatus))">
                            <!-- Payment/Insurance Utilization Form -->
                            <b-col md="12" v-if="activityStatus.includes('Engaged')">
                                <b-button
                                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                                    :variant="enterSurveyInformation ? 'outline-primary' : 'outline-success'"
                                    @click="enterSurveyInformation ? enterSurveyInformation = false : enterSurveyInformation = true"
                                    class="p-50"
                                    :disabled="clinicianUsers ? false : managerPA ? false : managerPeerSupervisor ? false : isClinicianStaff || !adminOrManageUsers ? true : dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                >
                                Enter Payment/Insurance Utilization Form
                                </b-button>
                            </b-col>

                            <b-col md="12" v-if="enterSurveyInformation && activityStatus.includes('Engaged') || activityStatus.includes('Admitted') || activityStatus.includes('Discharged')">
                                <h4 class="mt-2">Payment/Insurance Utilization Form</h4>
                                <hr>
                                <b-form
                                    ref="formRepeaterSessionsEng"
                                    class="repeater-form"
                                    @submit.prevent="repeateAgain"
                                >
                                    <b-row style="display: block;">
                                        <b-button
                                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                            variant="outline-primary"
                                            class="mb-1 p-50"
                                            style="float: right; margin-right: 40px;"
                                            @click="repeateAgain"
                                            :disabled="clinicianUsers ? false : dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                        >
                                            <feather-icon
                                                icon="PlusIcon"
                                                class=""
                                            />
                                        </b-button>
                                        <b-col
                                            md="10"
                                            v-for="(item, index) in itemsFormRepeater"
                                            :id="item.id"
                                            :key="item.id"
                                            ref="row"
                                        >
                                            <b-row class="px-1">
                                                <b-col md="6">
                                                    <b-form-group
                                                        label-for="Payment Assessment Date"
                                                    >
                                                    <template v-slot:label>
                                                        Payment Assessment Date <span class="text-danger">*</span>
                                                    </template>
                                                        <validation-provider
                                                            #default="{ errors }"
                                                            name="Payment Assessment Date"
                                                            rules="required"
                                                        >
                                                            <date-picker
                                                                v-model="item.paymentAssessmentDate"
                                                                placeholder="Select a Date"
                                                                type="date"
                                                                format="MMM DD, Y"
                                                                value-type="MM-DD-YYYY"
                                                                style="max-width: 100% !important; width: 100% !important;"
                                                                :state="errors.length > 0 ? false:null"
                                                                :style="!validFormRepeater && !item.paymentAssessmentDate ? 'border: 1px solid #ea5455 !important; border-radius: 0.357rem !important; max-width: 100% !important; width: 100% !important;' : 'max-width: 100% !important; width: 100% !important;'"
                                                                :disabled="clinicianUsers ? false : dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            ></date-picker>
                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                        </validation-provider>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row class="px-1">
                                                <b-col md="12" class="mt-2 mb-75">
                                                    <span>Select the payment arrangement you and client have decided to utilize for treatment services. A text box is provided for a brief explanation. Should the payment arrangement need to be changed at any point in the treatment process, please update this form and include an explanation in the text box. A financial assessment should be completed every six months as part of the treatment process.</span>
                                                </b-col>
                                            </b-row>
                                            <b-row class="px-1">
                                                <b-col md="7" class="mt-2">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Payment Arrangement"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="Payment Arrangement"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            Payment Arrangement <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="item.paymentArrangement"
                                                                placeholder="Payment Arrangement"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                :options="optionsPaymentArrangement"
                                                                class="select-utilization-form"
                                                                :style="!validFormRepeater && !item.paymentArrangement ? 'border: 1px solid #ea5455 !important; border-radius: 0.357rem !important;' : ''"
                                                                :disabled="clinicianUsers ? false : dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col md="5" class="mt-2" v-if="item.paymentArrangement && item.paymentArrangement.includes('The client has insurance that I do not accept. I was provided with this referral due to the circumstances selected below. NYCPG will provide reimbursement.')">
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="The client has insurance that I do not accept"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            label-for="The client has insurance that I do not accept"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            The client has insurance that I do not accept <span class="text-danger">*</span>
                                                        </template>
                                                            <v-select
                                                                v-model="item.theClientInsuranceIdonotAccept"
                                                                placeholder="The client has insurance that I do not accept"
                                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                                class="select-utilization-form"
                                                                :options="optionsTheClientInsuranceIdonotAccept"
                                                                multiple
                                                                :style="!validFormRepeater && !item.theClientInsuranceIdonotAccept.length ? 'border: 1px solid #ea5455 !important; border-radius: 0.357rem !important;' : ''"
                                                                :disabled="clinicianUsers ? false : dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                                {{ errors[0] }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col md="5" class="mt-2" v-if="conditionsPArrangement.filter(ele => ele.cond === item.paymentArrangement).length">
                                                    <validation-provider
                                                        v-for="(itemCondition, index) in conditionsPArrangement.filter(ele => ele.cond === item.paymentArrangement)"
                                                        :key="index"
                                                        #default="{ errors }"
                                                        :name="itemCondition.label"
                                                        rules="required"
                                                    >
                                                        <b-form-group
                                                            :label-for="itemCondition.label"
                                                            :state="errors.length > 0 ? false:null"
                                                        >
                                                        <template v-slot:label>
                                                            {{ itemCondition.label }} <span class="text-danger">*</span>
                                                        </template>
                                                            <b-form-textarea
                                                                v-model="item.explanation"
                                                                id="textarea-default"
                                                                :placeholder="itemCondition.label"
                                                                rows="3"
                                                                :state="errors.length > 0 ? false:null"
                                                                :style="!item.explanation ? 'border: 1px solid #ea5455 !important; border-radius: 0.357rem !important;' : ''"
                                                                :disabled="clinicianUsers ? false : dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                            />
                                                            <small class="text-danger">{{ errors[0] }}</small>
                                                        </b-form-group>
                                                    </validation-provider>
                                                </b-col>
                                                <b-col md="12" class="mt-2 mb-2">
                                                    <b-form-checkbox
                                                        v-model="item.providingReimbursement"
                                                        :value="true"
                                                        class="custom-control-primary"
                                                        :disabled="clinicianUsers ? false : dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                    >
                                                    <b>(Check only if NYCPG will be providing reimbursement) I have worked with this client to determine financial payment for treatment and have determined that it is clinically appropriate to use NYS OASAS funding as a payor of last resort for services.</b>
                                                    </b-form-checkbox>
                                                </b-col>
                                                <!-- Remove Button -->
                                                <b-col
                                                    cols="12"
                                                    class="mb-1"
                                                >
                                                    <b-button
                                                        v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                                        variant="outline-danger"
                                                        class="mt-0 mt-md-2"
                                                        @click="removeItem(index)"
                                                        :disabled="staffOrClinician ? true : clinicianUsers ? false : dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                                    >
                                                        <feather-icon
                                                            icon="XIcon"
                                                            class="mr-25"
                                                        />
                                                        <span>Delete</span>
                                                    </b-button>
                                                </b-col>
                                                <b-col cols="12" style="" class="mt-2 mb-2">
                                                    <hr>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-col>
                        </b-row>

                        <div class="mt-1" v-if="(((userData.uid === (typeof peerAssignedSaved === 'object' && (peerAssignedSaved && peerAssignedSaved.uid) ? peerAssignedSaved.uid : '')) || (userData.uid === (typeof peerCompletingSaved === 'object' && (peerCompletingSaved && peerCompletingSaved.uid) ? peerCompletingSaved.uid : '')) || (isAdmin || managerPeerSupervisor) || ((isAdmin || managerPeerSupervisor || managerPA) && (!peerAssignedSaved && !peerCompletingSaved))) && (((managerPeerSupervisor || isAdmin) && (activityStatus === 'Engaged' && (engagedStatus === 'Referred to Peer Advocate' || engagedStatus === 'Referred to Clinician and Peer Advocate')) || (activityStatus === 'Closed - Referred to OASAS Program' && referredToPeerAdvocate === 'Yes')) || ((managerPeerSupervisor || managerPA || isAdmin) && (activityStatus === 'Engaged' && (engagedStatus === 'Referred to Peer Advocate' || engagedStatus === 'Referred to Clinician and Peer Advocate')) || (activityStatus === 'Closed - Referred to OASAS Program' && referredToPeerAdvocate === 'Yes')))) || (((userData.uid === (typeof peerAssignedSaved === 'object' && (peerAssignedSaved && peerAssignedSaved.uid) ? peerAssignedSaved.uid : '')) || (isAdmin || managerPeerSupervisor) || ((isAdmin || managerPeerSupervisor || managerPA) && (!peerAssignedSaved && !peerCompletingSaved))) && (((managerPeerSupervisor || isAdmin) && (activityStatus === 'Engaged' && (engagedStatus === 'Referred to Peer Advocate' || engagedStatus === 'Referred to Clinician and Peer Advocate')) || (activityStatus === 'Closed - Referred to OASAS Program' && referredToPeerAdvocate === 'Yes')) || ((managerPeerSupervisor || managerPA || isAdmin) && (activityStatus === 'Engaged' && (engagedStatus === 'Referred to Peer Advocate' || engagedStatus === 'Referred to Clinician and Peer Advocate')) || (activityStatus === 'Closed - Referred to OASAS Program' && referredToPeerAdvocate === 'Yes')))) || (((userData.uid === (typeof peerAssignedSaved === 'object' && (peerAssignedSaved && peerAssignedSaved.uid) ? peerAssignedSaved.uid : '')) || (isAdmin || managerPeerSupervisor) || ((isAdmin || managerPeerSupervisor || managerPA) && (!peerAssignedSaved && !peerCompletingSaved))) && (((managerPeerSupervisor || isAdmin) && (activityStatus === 'Engaged' && (engagedStatus === 'Referred to Peer Advocate' || engagedStatus === 'Referred to Clinician and Peer Advocate')) || (activityStatus === 'Closed - Referred to OASAS Program' && referredToPeerAdvocate === 'Yes')) || ((managerPeerSupervisor || managerPA || isAdmin) && (activityStatus === 'Engaged' && (engagedStatus === 'Referred to Peer Advocate' || engagedStatus === 'Referred to Clinician and Peer Advocate')) || (activityStatus === 'Closed - Referred to OASAS Program' && referredToPeerAdvocate === 'Yes')))) || (((userData.uid === (typeof peerAssignedSaved === 'object' && (peerAssignedSaved && peerAssignedSaved.uid) ? peerAssignedSaved.uid : '')) || (isAdmin || managerPeerSupervisor) || ((isAdmin || managerPeerSupervisor || managerPA) && (!peerAssignedSaved && !peerCompletingSaved))) && (((managerPeerSupervisor || isAdmin) && (activityStatus === 'Engaged' && (engagedStatus === 'Referred to Peer Advocate' || engagedStatus === 'Referred to Clinician and Peer Advocate')) || (activityStatus === 'Closed - Referred to OASAS Program' && referredToPeerAdvocate === 'Yes')) || ((managerPeerSupervisor || managerPA || isAdmin) && (activityStatus === 'Engaged' && (engagedStatus === 'Referred to Peer Advocate' || engagedStatus === 'Referred to Clinician and Peer Advocate')) || (activityStatus === 'Closed - Referred to OASAS Program' && referredToPeerAdvocate === 'Yes'))))">
                        <h4>Peer Services Forms</h4>
                        <hr>
                        <b-row cols="12">
                        <b-col md="8">

                        <b-row cols="12" class="mt-2" v-if="((userData.uid === (typeof peerAssignedSaved === 'object' && (peerAssignedSaved && peerAssignedSaved.uid) ? peerAssignedSaved.uid : '')) || (userData.uid === (typeof peerCompletingSaved === 'object' && (peerCompletingSaved && peerCompletingSaved.uid) ? peerCompletingSaved.uid : '')) || (isAdmin || managerPeerSupervisor) || ((isAdmin || managerPeerSupervisor || managerPA) && (!peerAssignedSaved && !peerCompletingSaved))) && (((managerPeerSupervisor || isAdmin) && (activityStatus === 'Engaged' && (engagedStatus === 'Referred to Peer Advocate' || engagedStatus === 'Referred to Clinician and Peer Advocate')) || (activityStatus === 'Closed - Referred to OASAS Program' && referredToPeerAdvocate === 'Yes')) || ((managerPeerSupervisor || managerPA || isAdmin) && (activityStatus === 'Engaged' && (engagedStatus === 'Referred to Peer Advocate' || engagedStatus === 'Referred to Clinician and Peer Advocate')) || (activityStatus === 'Closed - Referred to OASAS Program' && referredToPeerAdvocate === 'Yes')))">
                            <!-- Peer Services Intake Form -->
                            <b-col md="12" v-if="activityStatus === 'Engaged' || activityStatus === 'Closed - Referred to OASAS Program'">
                                <b-button
                                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                                    :variant="enterPeerServicesForm ? 'outline-primary' : 'outline-success'"
                                    @click="enterPeerServicesForm ? enterPeerServicesForm = false : enterPeerServicesForm = true"
                                    class="p-50"
                                    :disabled="clinicianUsers ? true : isAdmin ? false : managerPA ? false : managerPeerSupervisor ? false : isClinicianStaff || !adminOrManageUsers ? true : dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? true : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                >
                                Peer Services Intake Form
                                </b-button>
                            </b-col>

                            <b-col md="12" v-if="enterPeerServicesForm && (activityStatus.includes('Engaged') || activityStatus.includes('Admitted') || activityStatus.includes('Discharged') || activityStatus.includes('Closed - Referred to OASAS Program'))">
                                <h4 class="mt-2">Peer Services Intake Form</h4>
                                <hr>

                                <b-row>
                                    <b-col md="12">
                                        <b-col md="12">
                                            <b-col md="12">
                                                <b-form-group
                                                    label-for="Contact Date"
                                                >
                                                <template v-slot:label>
                                                    Contact Date <span class="text-danger">*</span>
                                                </template>
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        name="Contact Date"
                                                        rules="required"
                                                    >
                                                        <flat-pickr
                                                            v-model="contactDate"
                                                            class="form-control"
                                                            placeholder="Select a Date"
                                                            :config="{ altInput: true, altFormat: 'F j, Y', dateFormat: 'm-d-Y',}"
                                                            :state="errors.length > 0 ? false:null"
                                                            :style="errors.length > 0 ? 'border: 1px solid #ea5455 !important;' : ''"
                                                        />
                                                        <small class="text-danger">{{ errors[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12">
                                                <validation-provider name="Peer completing the form" rules="required" v-slot="{ errors }">
                                                <b-form-group label="Peer completing the form" label-for="peer-completing">
                                                    <v-select
                                                    id="peer-completing"
                                                    v-model="peerCompleting"
                                                    :options="peerStaffOptions"
                                                    placeholder="Select peer"
                                                    label="name"
                                                    :class="errors.length > 0 ? 'is-invalid' : ''"
                                                    ></v-select>
                                                    <b-form-invalid-feedback :state="errors.length === 0">{{ errors[0] }}</b-form-invalid-feedback>
                                                </b-form-group>
                                                </validation-provider>
                                            </b-col>

                                            <b-col md="12">
                                                <validation-provider name="Peer assigned to for services" rules="required" v-slot="{ errors }">
                                                <b-form-group label="Peer assigned to for services" label-for="peer-assigned">
                                                    <v-select
                                                    id="peer-assigned"
                                                    v-model="peerAssigned"
                                                    :options="peerStaffOptions"
                                                    placeholder="Select peer"
                                                    label="name"
                                                    :class="errors.length > 0 ? 'is-invalid' : ''"
                                                    ></v-select>
                                                    <b-form-invalid-feedback :state="errors.length === 0">{{ errors[0] }}</b-form-invalid-feedback>
                                                </b-form-group>
                                                </validation-provider>
                                            </b-col>

                                            <b-col md="12">
                                                <validation-provider name="New or Returning Client" rules="required" v-slot="{ errors }">
                                                <b-form-group label="New or Returning Client" label-for="client-type">
                                                    <v-select
                                                    id="client-type"
                                                    v-model="clientType"
                                                    :options="clientTypeOptions"
                                                    placeholder="Select option"
                                                    :class="errors.length > 0 ? 'is-invalid' : ''"
                                                    ></v-select>
                                                    <b-form-invalid-feedback :state="errors.length === 0">{{ errors[0] }}</b-form-invalid-feedback>
                                                </b-form-group>
                                                </validation-provider>
                                            </b-col>

                                            <b-col md="12">
                                                <validation-provider name="Client Status" rules="required" v-slot="{ errors }">
                                                <b-form-group label="Client Status" label-for="client-status">
                                                    <v-select
                                                    id="client-status"
                                                    v-model="pifClientStatus"
                                                    :options="clientStatusOptions"
                                                    placeholder="Select status"
                                                    :class="errors.length > 0 ? 'is-invalid' : ''"
                                                    ></v-select>
                                                    <b-form-invalid-feedback :state="errors.length === 0">{{ errors[0] }}</b-form-invalid-feedback>
                                                </b-form-group>
                                                </validation-provider>
                                            </b-col>

                                            <b-col md="12">
                                                <validation-provider name="How was client referred" rules="required" v-slot="{ errors }">
                                                <b-form-group label="How was client referred for services?" label-for="referral-source">
                                                    <v-select
                                                    id="referral-source"
                                                    v-model="referralSource"
                                                    :options="referralSourceOptions"
                                                    placeholder="Select referral source"
                                                    :class="errors.length > 0 ? 'is-invalid' : ''"
                                                    @input="handleReferralSourceChange"
                                                    ></v-select>
                                                    <b-form-invalid-feedback :state="errors.length === 0">{{ errors[0] }}</b-form-invalid-feedback>
                                                </b-form-group>
                                                </validation-provider>
                                            </b-col>

                                            <!-- Conditional fields based on referral source -->
                                            <b-col md="12" v-if="referralSource === 'Hopeline'">
                                                <b-form-group label="Warm transfer" label-for="warm-transfer">
                                                <v-select
                                                    id="warm-transfer"
                                                    v-model="warmTransferPeer"
                                                    :options="yesNoOptions"
                                                    placeholder="Select option"
                                                ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="referralSource === 'Family member/Self'">
                                                <b-form-group label="Family member/Self" label-for="family-referral-type">
                                                <v-select
                                                    id="family-referral-type"
                                                    v-model="familyReferralType"
                                                    :options="familyReferralTypeOptions"
                                                    placeholder="Select type"
                                                ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="referralSource === 'Problem Gambling Self-Help Group Meetings'">
                                                <b-form-group label="Problem Gambling Self-Help Group Meetings" label-for="self-help-group-type">
                                                <v-select
                                                    id="self-help-group-type"
                                                    v-model="selfHelpGroupType"
                                                    :options="selfHelpGroupOptions"
                                                    placeholder="Select group"
                                                ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="referralSource === 'Problem Gambling Treatment Services'">
                                                <b-form-group label="Problem Gambling Treatment Services" label-for="pg-treatment-type">
                                                <v-select
                                                    id="pg-treatment-type"
                                                    v-model="pgTreatmentType"
                                                    :options="treatmentTypeOptions"
                                                    placeholder="Select type"
                                                ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="referralSource === 'Substance Use Treatment Services'">
                                                <b-form-group label="Substance Use Treatment Services" label-for="sud-treatment-type">
                                                <v-select
                                                    id="sud-treatment-type"
                                                    v-model="sudTreatmentType"
                                                    :options="treatmentTypeOptions"
                                                    placeholder="Select type"
                                                ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="referralSource === 'Recovery Support Services'">
                                                <b-form-group label="Recovery Support Services" label-for="recovery-service-type">
                                                <v-select
                                                    id="recovery-service-type"
                                                    v-model="recoveryServiceType"
                                                    :options="recoveryServiceOptions"
                                                    placeholder="Select service"
                                                ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="recoveryServiceType === 'Recovery Community and Outreach Center' || recoveryServiceType === 'Other'">
                                                <b-form-group :label="recoveryServiceType === 'Other' ? 'Other Details' : 'RCOC Name'" label-for="recovery-service-details">
                                                <b-form-textarea
                                                    :placeholder="recoveryServiceType === 'Other' ? 'Other Details' : 'RCOC Name'"
                                                    rows="3"
                                                    v-model="recoveryServiceDetails"
                                                />
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12">
                                                <b-form-group label="Service Status" label-for="service-status">
                                                    <v-select
                                                    id="service-status"
                                                    v-model="serviceStatus"
                                                    :options="serviceStatusOptions"
                                                    placeholder="Select status"
                                                    multiple
                                                    ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <!-- Previously Attended Treatment -->
                                            <b-col md="12" v-if="serviceStatus.includes('Previously Attended Treatment')">
                                                <b-form-group label="Previously Attended Treatment" label-for="prev-attended-treatment">
                                                    <v-select
                                                    id="prev-attended-treatment"
                                                    v-model="previouslyAttendedTreatment"
                                                    :options="previouslyAttendedTreatmentOptions"
                                                    placeholder="Select treatment types"
                                                    multiple
                                                    ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="previouslyAttendedTreatment.includes('PG Inpatient')">
                                                <b-form-group label="PG Inpatient Details" label-for="prev-pg-inpatient">
                                                    <b-form-textarea
                                                    id="prev-pg-inpatient"
                                                    v-model="prevPgInpatient"
                                                    placeholder="Enter details"
                                                    rows="3"
                                                    ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="previouslyAttendedTreatment.includes('PG Outpatient')">
                                                <b-form-group label="PG Outpatient Details" label-for="prev-pg-outpatient">
                                                    <b-form-textarea
                                                    id="prev-pg-outpatient"
                                                    v-model="prevPgOutpatient"
                                                    placeholder="Enter details"
                                                    rows="3"
                                                    ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="previouslyAttendedTreatment.includes('PG Residential')">
                                                <b-form-group label="PG Residential Details" label-for="prev-pg-residential">
                                                    <b-form-textarea
                                                    id="prev-pg-residential"
                                                    v-model="prevPgResidential"
                                                    placeholder="Enter details"
                                                    rows="3"
                                                    ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="previouslyAttendedTreatment.includes('SUD Inpatient')">
                                                <b-form-group label="SUD Inpatient Details" label-for="prev-sud-inpatient">
                                                    <b-form-textarea
                                                    id="prev-sud-inpatient"
                                                    v-model="prevSudInpatient"
                                                    placeholder="Enter details"
                                                    rows="3"
                                                    ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="previouslyAttendedTreatment.includes('SUD Outpatient')">
                                                <b-form-group label="SUD Outpatient Details" label-for="prev-sud-outpatient">
                                                    <b-form-textarea
                                                    id="prev-sud-outpatient"
                                                    v-model="prevSudOutpatient"
                                                    placeholder="Enter details"
                                                    rows="3"
                                                    ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="previouslyAttendedTreatment.includes('SUD Residential')">
                                                <b-form-group label="SUD Residential Details" label-for="prev-sud-residential">
                                                    <b-form-textarea
                                                    id="prev-sud-residential"
                                                    v-model="prevSudResidential"
                                                    placeholder="Enter details"
                                                    rows="3"
                                                    ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <!-- Currently Attending Treatment -->
                                            <b-col md="12" v-if="serviceStatus.includes('Currently Attending Treatment')">
                                                <b-form-group label="Currently Attending Treatment" label-for="curr-attending-treatment">
                                                    <v-select
                                                    id="curr-attending-treatment"
                                                    v-model="currentlyAttendingTreatment"
                                                    :options="currentlyAttendingTreatmentOptions"
                                                    placeholder="Select treatment types"
                                                    multiple
                                                    ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="currentlyAttendingTreatment.includes('PG Inpatient')">
                                                <b-form-group label="Current PG Inpatient Details" label-for="curr-pg-inpatient">
                                                    <b-form-textarea
                                                    id="curr-pg-inpatient"
                                                    v-model="currPgInpatient"
                                                    placeholder="Enter details"
                                                    rows="3"
                                                    ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="currentlyAttendingTreatment.includes('PG Outpatient')">
                                                <b-form-group label="Current PG Outpatient Details" label-for="curr-pg-outpatient">
                                                    <b-form-textarea
                                                    id="curr-pg-outpatient"
                                                    v-model="currPgOutpatient"
                                                    placeholder="Enter details"
                                                    rows="3"
                                                    ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="currentlyAttendingTreatment.includes('PG Residential')">
                                                <b-form-group label="Current PG Residential Details" label-for="curr-pg-residential">
                                                    <b-form-textarea
                                                    id="curr-pg-residential"
                                                    v-model="currPgResidential"
                                                    placeholder="Enter details"
                                                    rows="3"
                                                    ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="currentlyAttendingTreatment.includes('SUD Inpatient')">
                                                <b-form-group label="Current SUD Inpatient Details" label-for="curr-sud-inpatient">
                                                    <b-form-textarea
                                                    id="curr-sud-inpatient"
                                                    v-model="currSudInpatient"
                                                    placeholder="Enter details"
                                                    rows="3"
                                                    ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="currentlyAttendingTreatment.includes('SUD Outpatient')">
                                                <b-form-group label="Current SUD Outpatient Details" label-for="curr-sud-outpatient">
                                                    <b-form-textarea
                                                    id="curr-sud-outpatient"
                                                    v-model="currSudOutpatient"
                                                    placeholder="Enter details"
                                                    rows="3"
                                                    ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="currentlyAttendingTreatment.includes('SUD Residential')">
                                                <b-form-group label="Current SUD Residential Details" label-for="curr-sud-residential">
                                                    <b-form-textarea
                                                    id="curr-sud-residential"
                                                    v-model="currSudResidential"
                                                    placeholder="Enter details"
                                                    rows="3"
                                                    ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <!-- Previously Utilized Recovery Services -->
                                            <b-col md="12" v-if="serviceStatus.includes('Previously Utilized Recovery Services')">
                                                <b-form-group label="Previously Utilized Recovery Services" label-for="prev-recovery-services">
                                                    <v-select
                                                    id="prev-recovery-services"
                                                    v-model="previouslyUtilizedRecoveryServices"
                                                    :options="previouslyUtilizedRecoveryServicesOptions"
                                                    placeholder="Select services"
                                                    multiple
                                                    ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="previouslyUtilizedRecoveryServices.includes('Recovery Community and Outreach Center')">
                                                <b-form-group label="RCOC Name" label-for="prev-recovery-rcoc">
                                                    <b-form-textarea
                                                    id="prev-recovery-rcoc"
                                                    v-model="prevRecoveryRcocName"
                                                    placeholder="Enter RCOC name"
                                                    rows="3"
                                                    ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="serviceStatus.includes('Text box to enter RCOC name')">
                                                <b-form-group label="Text box RCOC Name" label-for="curr-recovery-rcoc">
                                                    <b-form-textarea
                                                    id="curr-recovery-rcoc"
                                                    v-model="currRecoveryTxtBoxRcocName"
                                                    placeholder="Enter RCOC name"
                                                    rows="3"
                                                    ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <!-- Currently Utilizing Recovery Services -->
                                            <b-col md="12" v-if="serviceStatus.includes('Currently Utilizing Recovery Services')">
                                                <b-form-group label="Currently Utilizing Recovery Services" label-for="curr-recovery-services">
                                                    <v-select
                                                    id="curr-recovery-services"
                                                    v-model="currentlyUtilizingRecoveryServices"
                                                    :options="currentlyUtilizingRecoveryServicesOptions"
                                                    placeholder="Select services"
                                                    multiple
                                                    ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="currentlyUtilizingRecoveryServices.includes('Recovery Community and Outreach Center')">
                                                <b-form-group label="RCOC Name" label-for="curr-recovery-rcoc">
                                                    <b-form-textarea
                                                    id="curr-recovery-rcoc"
                                                    v-model="currRecoveryRcocName"
                                                    placeholder="Enter RCOC name"
                                                    rows="3"
                                                    ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <!-- Previously Utilized Financial/Credit Counseling Services -->
                                            <b-col md="12" v-if="serviceStatus.includes('Previously Utilized Financial/Credit Counseling Services')">
                                                <b-form-group label="Previously Utilized Financial/Credit Counseling Services" label-for="prev-financial-services">
                                                    <v-select
                                                    id="prev-financial-services"
                                                    v-model="previouslyUtilizedFinancialServices"
                                                    :options="previouslyUtilizedFinancialServicesOptions"
                                                    placeholder="Select services"
                                                    ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="previouslyUtilizedFinancialServices === 'Other'">
                                                <b-form-group label="Other Financial Service Details" label-for="prev-financial-other">
                                                    <b-form-textarea
                                                    id="prev-financial-other"
                                                    v-model="prevFinancialOther"
                                                    placeholder="Enter details"
                                                    rows="3"
                                                    ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <!-- Currently Utilizing Financial/Credit Counseling Services -->
                                            <b-col md="12" v-if="serviceStatus.includes('Currently Utilizing Financial/Credit Counseling Services')">
                                                <b-form-group label="Currently Utilizing Financial/Credit Counseling Services" label-for="curr-financial-services">
                                                    <v-select
                                                    id="curr-financial-services"
                                                    v-model="currentlyUtilizingFinancialServices"
                                                    :options="currentlyUtilizingFinancialServicesOptions"
                                                    placeholder="Select services"
                                                    ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="currentlyUtilizingFinancialServices === 'Other'">
                                                <b-form-group label="Other Financial Service Details" label-for="curr-financial-other">
                                                    <b-form-textarea
                                                    id="curr-financial-other"
                                                    v-model="currFinancialOther"
                                                    placeholder="Enter details"
                                                    rows="3"
                                                    ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12">
                                                <b-form-group label="Presenting Problems at admission" label-for="presenting-problems">
                                                <v-select
                                                    id="presenting-problems"
                                                    v-model="presentingProblems"
                                                    :options="presentingProblemsOptions"
                                                    placeholder="Select problems"
                                                    multiple
                                                ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12">
                                                <b-form-group label="Other Problems" label-for="other-problems">
                                                <b-form-textarea
                                                    id="other-problems"
                                                    v-model="otherProblems"
                                                    placeholder="Enter other problems"
                                                    rows="3"
                                                ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12">
                                                <validation-provider name="Client currently involved with legal system" rules="required" v-slot="{ errors }">
                                                <b-form-group label="Client currently involved with legal system" label-for="legal-involvement">
                                                    <v-select
                                                    id="legal-involvement"
                                                    v-model="legalInvolvement"
                                                    :options="yesNoOptions"
                                                    placeholder="Select option"
                                                    :class="errors.length > 0 ? 'is-invalid' : ''"
                                                    @input="handleLegalInvolvementChange"
                                                    ></v-select>
                                                    <b-form-invalid-feedback :state="errors.length === 0">{{ errors[0] }}</b-form-invalid-feedback>
                                                </b-form-group>
                                                </validation-provider>
                                            </b-col>

                                            <b-col md="12" v-if="legalInvolvement === 'Yes'">
                                                <b-form-group label="Legal System Type" label-for="legal-system-type">
                                                <v-select
                                                    id="legal-system-type"
                                                    v-model="legalSystemType"
                                                    :options="legalSystemTypeOptions"
                                                    placeholder="Select type"
                                                ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12">
                                                <validation-provider name="Client release signed" rules="required" v-slot="{ errors }">
                                                <b-form-group label="Client release signed" label-for="release-signed">
                                                    <v-select
                                                    id="release-signed"
                                                    v-model="releaseSigned"
                                                    :options="yesNoOptions"
                                                    placeholder="Select option"
                                                    :class="errors.length > 0 ? 'is-invalid' : ''"
                                                    ></v-select>
                                                    <b-form-invalid-feedback :state="errors.length === 0">{{ errors[0] }}</b-form-invalid-feedback>
                                                </b-form-group>
                                                </validation-provider>
                                            </b-col>

                                            <b-col md="12">
                                                <b-form-group label="Notes for additional relevant information" label-for="notes">
                                                <b-form-textarea
                                                    id="notes"
                                                    v-model="notes"
                                                    placeholder="Enter notes"
                                                    rows="4"
                                                ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <!-- Demographic Information Section -->
                                            <b-row class="mt-1">
                                                <h6 class="mt-2">Demographic Information</h6>
                                                <hr style="width: 100%;">

                                                <b-col md="6">
                                                    <b-form-group label="Race" label-for="race">
                                                    <v-select
                                                        id="race"
                                                        v-model="race"
                                                        :options="raceOptions"
                                                        placeholder="Select race"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Hispanic origin" label-for="hispanic-origin">
                                                    <v-select
                                                        id="hispanic-origin"
                                                        v-model="ethnicity"
                                                        :options="hispanicOriginOptions"
                                                        placeholder="Select origin"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Asian origin" label-for="asian-origin">
                                                    <v-select
                                                        id="asian-origin"
                                                        v-model="asianOrigin"
                                                        :options="asianOriginOptions"
                                                        placeholder="Select origin"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Pacific Islander origin" label-for="pacific-islander-origin">
                                                    <v-select
                                                        id="pacific-islander-origin"
                                                        v-model="pacificIslanderOrigin"
                                                        :options="pacificIslanderOriginOptions"
                                                        placeholder="Select origin"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Household income" label-for="household-income">
                                                    <v-select
                                                        id="household-income"
                                                        v-model="householdIncome"
                                                        :options="householdIncomeOptions"
                                                        placeholder="Select income range"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Types of gambling engaged in" label-for="gambling-types">
                                                    <v-select
                                                        id="gambling-types"
                                                        v-model="gamblingTypes"
                                                        :options="gamblingTypesOptions"
                                                        placeholder="Select types"
                                                        multiple
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Employment status" label-for="employment-status">
                                                    <v-select
                                                        id="employment-status"
                                                        v-model="employmentStatus"
                                                        :options="employmentStatusOptions"
                                                        placeholder="Select status"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Highest grade completed" label-for="highest-grade">
                                                    <v-select
                                                        id="highest-grade"
                                                        v-model="educationLevels"
                                                        :options="highestGradeOptions"
                                                        placeholder="Select grade"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Veteran" label-for="veteran">
                                                    <v-select
                                                        id="veteran"
                                                        v-model="veteran"
                                                        :options="yesNoOptions"
                                                        placeholder="Select option"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Zip code" label-for="zip-code">
                                                    <b-form-input
                                                        id="zip-code"
                                                        v-model="zipCode"
                                                        placeholder="Enter zip code"
                                                    ></b-form-input>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Industry of employment" label-for="industry">
                                                    <v-select
                                                        id="industry"
                                                        v-model="industryOfEmployment"
                                                        :options="industryOptions"
                                                        placeholder="Select industry"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Marital status" label-for="marital-status">
                                                    <v-select
                                                        id="marital-status"
                                                        v-model="maritalStatus"
                                                        :options="maritalStatusOptions"
                                                        placeholder="Select status"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Religious preference" label-for="religious-preference">
                                                    <v-select
                                                        id="religious-preference"
                                                        v-model="religiousPreference"
                                                        :options="religiousPreferenceOptions"
                                                        placeholder="Select preference"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Age" label-for="age">
                                                    <v-select
                                                        id="age"
                                                        v-model="age"
                                                        :options="ageOptions"
                                                        placeholder="Select age range"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Sexual Orientation" label-for="sexual-orientation">
                                                    <v-select
                                                        id="sexual-orientation"
                                                        v-model="sexualOrientation"
                                                        :options="sexualOrientationOptions"
                                                        placeholder="Select orientation"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Gender Identity" label-for="gender-identity">
                                                    <v-select
                                                        id="gender-identity"
                                                        v-model="genderIdentity"
                                                        :options="genderIdentityOptions"
                                                        placeholder="Select identity"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Transgender" label-for="transgender">
                                                    <v-select
                                                        id="transgender"
                                                        v-model="transgender"
                                                        :options="transgenderOptions"
                                                        placeholder="Select option"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>

                                            <!-- Gambling Behavior Section -->
                                            <b-row class="mt-1">
                                                <h6 class="mt-2">Gambling Behavior</h6>
                                                <hr style="width: 100%;">

                                                <b-col md="6">
                                                    <b-form-group label="Frequency of gambling" label-for="gambling-frequency">
                                                    <v-select
                                                        id="gambling-frequency"
                                                        v-model="frequencyofGambling"
                                                        :options="gamblingFrequencyOptions"
                                                        placeholder="Select frequency"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Age first gambled" label-for="age-first-gambled">
                                                    <b-form-input
                                                        id="age-first-gambled"
                                                        v-model="ageFirstGambled"
                                                        placeholder="Enter age"
                                                    ></b-form-input>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="During the past 30 days, what amount of money did you spend on a typical day of gambling?" label-for="typical-amount">
                                                    <b-form-textarea
                                                        id="typical-amount"
                                                        v-model="past30DaysAmountOfMoney"
                                                        rows="3"
                                                        placeholder="Amount spent on typical day (past 30 days)"
                                                    />
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="During the past 30 days, how much time did you usually spend on a typical day of gambling?" label-for="typical-time">
                                                    <b-form-textarea
                                                        id="typical-amount"
                                                        v-model="past30DaysHowMuchTime"
                                                        rows="3"
                                                        placeholder="Time spent on typical day (past 30 days)"
                                                    />
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="During the past 30 days, on how many days did you gamble?" label-for="days-gambled">
                                                    <b-form-textarea
                                                        id="typical-amount"
                                                        v-model="past30DaysHowManyDays"
                                                        rows="3"
                                                        placeholder="Number of days gambled (past 30 days)"
                                                    />
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Gambling locations during the past 12 months" label-for="gambling-locations">
                                                    <v-select
                                                        id="gambling-locations"
                                                        v-model="gamblinglocationspast12months"
                                                        :options="gamblingLocationsOptions"
                                                        placeholder="Select locations"
                                                        multiple
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6" v-if="gamblinglocationspast12months.includes('Other')">
                                                    <b-form-group label="Other Location Details" label-for="gambling-location-other">
                                                    <b-form-input
                                                        id="gambling-location-other"
                                                        v-model="gamblingLocationOther"
                                                        placeholder="Enter other location"
                                                    ></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-col>

                                    <b-col cols="12" style="" class="mt-2 mb-2">
                                        <hr>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>

                        <!-- Peer Goal Form -->
                        <b-row cols="12" class="mt-2" v-if="((userData.uid === (typeof peerAssignedSaved === 'object' && (peerAssignedSaved && peerAssignedSaved.uid) ? peerAssignedSaved.uid : '')) || (isAdmin || managerPeerSupervisor) || ((isAdmin || managerPeerSupervisor || managerPA) && (!peerAssignedSaved && !peerCompletingSaved))) && (((managerPeerSupervisor || isAdmin) && (activityStatus === 'Engaged' && (engagedStatus === 'Referred to Peer Advocate' || engagedStatus === 'Referred to Clinician and Peer Advocate')) || (activityStatus === 'Closed - Referred to OASAS Program' && referredToPeerAdvocate === 'Yes')) || ((managerPeerSupervisor || managerPA || isAdmin) && (activityStatus === 'Engaged' && (engagedStatus === 'Referred to Peer Advocate' || engagedStatus === 'Referred to Clinician and Peer Advocate')) || (activityStatus === 'Closed - Referred to OASAS Program' && referredToPeerAdvocate === 'Yes')))">
                            <b-col md="12" v-if="activityStatus === 'Engaged' || activityStatus === 'Closed - Referred to OASAS Program'">
                                <b-button
                                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                                    :variant="enterPeerGoalForm ? 'outline-primary' : 'outline-success'"
                                    @click="enterPeerGoalForm ? enterPeerGoalForm = false : enterPeerGoalForm = true"
                                    class="p-50"
                                    :disabled="clinicianUsers ? true : isAdmin ? false : managerPA ? false : managerPeerSupervisor ? false : isClinicianStaff || !adminOrManageUsers ? true : dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? true : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                >
                                Peer Goal Form
                                </b-button>
                            </b-col>

                            <b-col md="12" v-if="enterPeerGoalForm && (activityStatus.includes('Engaged') || activityStatus.includes('Admitted') || activityStatus.includes('Discharged') || activityStatus.includes('Closed - Referred to OASAS Program'))">
                                <h4 class="mt-2">Peer Goal Form</h4>
                                <hr>

                                <b-row>
                                    <b-col md="12">
                                        <b-col md="12">
                                            <b-col md="6">
                                                <b-form-group label="Date" label-for="pgf-date">
                                                    <flat-pickr
                                                        v-model="pgfDate"
                                                        class="form-control"
                                                        placeholder="Select a Date"
                                                        :config="{ altInput: true, altFormat: 'F j, Y', dateFormat: 'm-d-Y'}"
                                                    />
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12">
                                                <b-form-group label="Add Goal" label-for="pgf-add-goal">
                                                    <div v-for="(goal, index) in pgfGoals" :key="index" class="mb-2">
                                                        <b-input-group>
                                                            <b-form-textarea
                                                                v-model="pgfGoals[index]"
                                                                placeholder="Enter goal"
                                                                rows="2"
                                                            ></b-form-textarea>
                                                            <b-input-group-append v-if="pgfGoals.length > 1">
                                                                <b-button variant="danger" @click="removePgfGoal(index)">
                                                                    <feather-icon
                                                                        icon="XIcon"
                                                                        class=""
                                                                    />
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </div>
                                                    <b-button variant="primary" @click="addPgfGoal" class="mt-2">
                                                        <feather-icon
                                                            icon="PlusIcon"
                                                            class=""
                                                        /> Add Goal
                                                    </b-button>
                                                </b-form-group>
                                            </b-col>
                                        </b-col>
                                    </b-col>

                                    <b-col cols="12" style="" class="mt-2 mb-2">
                                        <hr>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>

                        <!-- Peer Session Form -->
                        <b-row cols="12" class="mt-2" v-if="((userData.uid === (typeof peerAssignedSaved === 'object' && (peerAssignedSaved && peerAssignedSaved.uid) ? peerAssignedSaved.uid : '')) || (isAdmin || managerPeerSupervisor) || ((isAdmin || managerPeerSupervisor || managerPA) && (!peerAssignedSaved && !peerCompletingSaved))) && (((managerPeerSupervisor || isAdmin) && (activityStatus === 'Engaged' && (engagedStatus === 'Referred to Peer Advocate' || engagedStatus === 'Referred to Clinician and Peer Advocate')) || (activityStatus === 'Closed - Referred to OASAS Program' && referredToPeerAdvocate === 'Yes')) || ((managerPeerSupervisor || managerPA || isAdmin) && (activityStatus === 'Engaged' && (engagedStatus === 'Referred to Peer Advocate' || engagedStatus === 'Referred to Clinician and Peer Advocate')) || (activityStatus === 'Closed - Referred to OASAS Program' && referredToPeerAdvocate === 'Yes')))">
                            <b-col md="12" v-if="activityStatus === 'Engaged' || activityStatus === 'Closed - Referred to OASAS Program'">
                                <b-button
                                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                                    :variant="enterPeerSessionForm ? 'outline-primary' : 'outline-success'"
                                    @click="enterPeerSessionForm ? enterPeerSessionForm = false : enterPeerSessionForm = true"
                                    class="p-50"
                                    :disabled="clinicianUsers ? true : isAdmin ? false : managerPA ? false : managerPeerSupervisor ? false : isClinicianStaff || !adminOrManageUsers ? true : dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? true : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                >
                                Peer Session Form
                                </b-button>
                            </b-col>

                            <b-col md="12" v-if="enterPeerSessionForm && (activityStatus.includes('Engaged') || activityStatus.includes('Admitted') || activityStatus.includes('Discharged') || activityStatus.includes('Closed - Referred to OASAS Program'))">
                                <h4 class="mt-2">Peer Session Form</h4>
                                <hr>

                                <b-row>
                                    <b-col md="12">
                                        <b-col md="12">
                                            <!-- Peer Session Form - Form Repeater -->
                                            <b-form
                                                ref="formRepeaterPeerSessions"
                                                class="repeater-form"
                                                @submit.prevent="repeatPsfAgain"
                                            >
                                                <b-row style="display: block;">
                                                    <b-button
                                                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                                        variant="outline-primary"
                                                        class="mb-1 p-50"
                                                        style="float: right; margin-right: 40px;"
                                                        @click="repeatPsfAgain"
                                                    >
                                                        <feather-icon
                                                            icon="PlusIcon"
                                                            class=""
                                                        />
                                                    </b-button>
                                                    
                                                    <b-col
                                                        md="10"
                                                        v-for="(item, index) in psfItemsFormRepeater"
                                                        :id="item.id"
                                                        :key="item.id"
                                                        ref="row"
                                                    >
                                                        <app-collapse
                                                            accordion
                                                            :type="'margin'"
                                                        >

                                                            <app-collapse-item :title="'Session #'+ (index + 1)">
                                                                <b-card class="mb-2">
                                                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                                                        <h5>Session #{{ index + 1 }}</h5>
                                                                        <b-button
                                                                            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                                                            variant="outline-danger"
                                                                            size="sm"
                                                                            @click="removePsfItem(item.id)"
                                                                        >
                                                                            <feather-icon icon="XIcon" />
                                                                        </b-button>
                                                                    </div>

                                                                    <b-row>
                                                                        <b-col md="6">
                                                                            <b-form-group label="Date" :label-for="'psf-date-' + index">
                                                                                <flat-pickr
                                                                                    :id="'psf-date-' + index"
                                                                                    v-model="item.psfDate"
                                                                                    class="form-control"
                                                                                    placeholder="Select a Date"
                                                                                    :config="{ altInput: true, altFormat: 'F j, Y', dateFormat: 'm-d-Y'}"
                                                                                />
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col md="6">
                                                                            <b-form-group label="Duration" :label-for="'psf-duration-' + index">
                                                                                <v-select
                                                                                    :id="'psf-duration-' + index"
                                                                                    v-model="item.psfDuration"
                                                                                    :options="psfDurationOptions"
                                                                                    placeholder="Select duration"
                                                                                ></v-select>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col md="6">
                                                                            <b-form-group label="Service Delivery" :label-for="'psf-service-delivery-' + index">
                                                                                <v-select
                                                                                    :id="'psf-service-delivery-' + index"
                                                                                    v-model="item.psfServiceDelivery"
                                                                                    :options="psfServiceDeliveryOptions"
                                                                                    placeholder="Select service delivery"
                                                                                ></v-select>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col md="6" v-if="item.psfServiceDelivery === 'Remote'">
                                                                            <b-form-group label="Remote Type" :label-for="'psf-remote-type-' + index">
                                                                                <v-select
                                                                                    :id="'psf-remote-type-' + index"
                                                                                    v-model="item.psfRemoteType"
                                                                                    :options="psfRemoteTypeOptions"
                                                                                    placeholder="Select remote type"
                                                                                ></v-select>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col md="6">
                                                                            <b-form-group label="Service Type" :label-for="'psf-service-type-' + index">
                                                                                <v-select
                                                                                    :id="'psf-service-type-' + index"
                                                                                    v-model="item.psfServiceType"
                                                                                    :options="psfServiceTypeOptions"
                                                                                    placeholder="Select service types"
                                                                                    multiple
                                                                                ></v-select>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <!-- Presenting Problems (Auto-populated from Intake) -->
                                                                        <b-col md="12">
                                                                            <h6 class="mt-3 mb-2">Presenting Problems</h6>
                                                                            <p class="text-muted small">Auto-populated from Intake Form</p>
                                                                        </b-col>

                                                                        <div v-for="(problem, pIndex) in presentingProblems" :key="'problem-' + index + '-' + pIndex">
                                                                            <b-col md="12">
                                                                                <b-card class="mb-3 bg-light">
                                                                                    <h6>{{ problem }}</h6>
                                                                                    
                                                                                    <b-row>
                                                                                        <b-col md="12">
                                                                                            <b-form-group :label="'Status for: ' + problem" :label-for="'psf-problem-status-' + index + '-' + pIndex">
                                                                                            <v-select
                                                                                                :id="'psf-problem-status-' + index + '-' + pIndex"
                                                                                                v-model="item.psfProblemStatuses[pIndex]"
                                                                                                :options="psfProblemStatusOptions"
                                                                                                placeholder="Select status"
                                                                                                style="background: #fff;"
                                                                                            ></v-select>
                                                                                            </b-form-group>
                                                                                        </b-col>

                                                                                        <b-col md="12">
                                                                                            <b-form-group :label="'Comments for: ' + problem" :label-for="'psf-problem-comment-' + index + '-' + pIndex">
                                                                                            <b-form-textarea
                                                                                                :id="'psf-problem-comment-' + index + '-' + pIndex"
                                                                                                v-model="item.psfProblemComments[pIndex]"
                                                                                                placeholder="Enter comments"
                                                                                                rows="3"
                                                                                            ></b-form-textarea>
                                                                                            </b-form-group>
                                                                                        </b-col>
                                                                                    </b-row>
                                                                                </b-card>
                                                                            </b-col>
                                                                        </div>

                                                                        <!-- Goals (Auto-populated from Goal Form) -->
                                                                        <b-col md="12" class="mb-1">
                                                                            <h6 class="mt-3 mb-2">Goals</h6>
                                                                            <p class="text-muted small">Auto-populated from Goal Form</p>
                                                                        </b-col>

                                                                        <div v-for="(goal, gIndex) in pgfGoals" :key="'goal-' + index + '-' + gIndex" class="mb-1">
                                                                            <b-col md="12" v-if="goal">
                                                                                <b-card class="mb-3 bg-light">
                                                                                    <h6>Goal {{ gIndex + 1 }}: {{ goal }}</h6>
                                                                                    
                                                                                    <b-row>
                                                                                        <b-col md="12">
                                                                                            <b-form-group :label="'Status for Goal ' + (gIndex + 1)" :label-for="'psf-goal-status-' + index + '-' + gIndex">
                                                                                            <v-select
                                                                                                :id="'psf-goal-status-' + index + '-' + gIndex"
                                                                                                v-model="item.psfGoalStatuses[gIndex]"
                                                                                                :options="psfGoalStatusOptions"
                                                                                                placeholder="Select status"
                                                                                                style="background: #fff;"
                                                                                            ></v-select>
                                                                                            </b-form-group>
                                                                                        </b-col>

                                                                                        <b-col md="12">
                                                                                            <b-form-group :label="'Peer Comments for Goal ' + (gIndex + 1)" :label-for="'psf-goal-comment-' + index + '-' + gIndex">
                                                                                            <b-form-textarea
                                                                                                :id="'psf-goal-comment-' + index + '-' + gIndex"
                                                                                                v-model="item.psfGoalComments[gIndex]"
                                                                                                placeholder="Enter peer comments"
                                                                                                rows="3"
                                                                                            ></b-form-textarea>
                                                                                            </b-form-group>
                                                                                        </b-col>
                                                                                    </b-row>
                                                                                </b-card>
                                                                            </b-col>
                                                                        </div>

                                                                        <!-- Further Actions -->
                                                                        <b-col md="12">
                                                                            <b-form-group label="Further Actions" :label-for="'psf-further-actions-' + index">
                                                                                <v-select
                                                                                    :id="'psf-further-actions-' + index"
                                                                                    v-model="item.psfFurtherActions"
                                                                                    :options="psfFurtherActionsOptions"
                                                                                    placeholder="Select further actions"
                                                                                    multiple
                                                                                ></v-select>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <!-- Referral to treatment services -->
                                                                        <b-col md="12" v-if="item.psfFurtherActions.includes('Referral to treatment services')">
                                                                            <b-form-group label="Referral to treatment services" :label-for="'psf-treatment-referral-' + index">
                                                                                <v-select
                                                                                    :id="'psf-treatment-referral-' + index"
                                                                                    v-model="item.psfTreatmentReferral"
                                                                                    :options="psfTreatmentReferralOptions"
                                                                                    placeholder="Select treatment referral types"
                                                                                    multiple
                                                                                ></v-select>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col md="6" v-if="item.psfTreatmentReferral.includes('Inpatient Rehabilitation')">
                                                                            <b-form-group label="Inpatient Rehabilitation Details" :label-for="'psf-treatment-inpatient-' + index">
                                                                                <b-form-textarea
                                                                                    :id="'psf-treatment-inpatient-' + index"
                                                                                    v-model="item.psfTreatmentInpatient"
                                                                                    placeholder="Enter details"
                                                                                    rows="3"
                                                                                ></b-form-textarea>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col md="6" v-if="item.psfTreatmentReferral.includes('Residential')">
                                                                            <b-form-group label="Residential Details" :label-for="'psf-treatment-residential-' + index">
                                                                                <b-form-textarea
                                                                                    :id="'psf-treatment-residential-' + index"
                                                                                    v-model="item.psfTreatmentResidential"
                                                                                    placeholder="Enter details"
                                                                                    rows="3"
                                                                                ></b-form-textarea>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col md="6" v-if="item.psfTreatmentReferral.includes('Outpatient')">
                                                                            <b-form-group label="Outpatient Details" :label-for="'psf-treatment-outpatient-' + index">
                                                                                <b-form-textarea
                                                                                    :id="'psf-treatment-outpatient-' + index"
                                                                                    v-model="item.psfTreatmentOutpatient"
                                                                                    placeholder="Enter details"
                                                                                    rows="3"
                                                                                ></b-form-textarea>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <!-- Referral to recovery services -->
                                                                        <b-col md="12" v-if="item.psfFurtherActions.includes('Referral to recovery services')">
                                                                            <b-form-group label="Referral to recovery services" :label-for="'psf-recovery-referral-' + index">
                                                                                <v-select
                                                                                    :id="'psf-recovery-referral-' + index"
                                                                                    v-model="item.psfRecoveryReferral"
                                                                                    :options="psfRecoveryReferralOptions"
                                                                                    placeholder="Select recovery referral types"
                                                                                    multiple
                                                                                ></v-select>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col md="6" v-if="item.psfRecoveryReferral.includes('Recovery Community and Outreach Center')">
                                                                            <b-form-group label="Recovery Community and Outreach Center Details" :label-for="'psf-recovery-rcoc-' + index">
                                                                                <b-form-textarea
                                                                                    :id="'psf-recovery-rcoc-' + index"
                                                                                    v-model="item.psfRecoveryRcoc"
                                                                                    placeholder="Enter details"
                                                                                    rows="3"
                                                                                ></b-form-textarea>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col md="6" v-if="item.psfRecoveryReferral.includes('Youth Clubhouse')">
                                                                            <b-form-group label="Youth Clubhouse Details" :label-for="'psf-recovery-youth-' + index">
                                                                                <b-form-textarea
                                                                                    :id="'psf-recovery-youth-' + index"
                                                                                    v-model="item.psfRecoveryYouth"
                                                                                    placeholder="Enter details"
                                                                                    rows="3"
                                                                                ></b-form-textarea>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col md="6" v-if="item.psfRecoveryReferral.includes('Peer Advocate')">
                                                                            <b-form-group label="Peer Advocate Details" :label-for="'psf-recovery-peer-' + index">
                                                                                <b-form-textarea
                                                                                    :id="'psf-recovery-peer-' + index"
                                                                                    v-model="item.psfRecoveryPeer"
                                                                                    placeholder="Enter details"
                                                                                    rows="3"
                                                                                ></b-form-textarea>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col md="6" v-if="item.psfRecoveryReferral.includes('Open Access Center')">
                                                                            <b-form-group label="Open Access Center Details" :label-for="'psf-recovery-open-' + index">
                                                                                <b-form-textarea
                                                                                    :id="'psf-recovery-open-' + index"
                                                                                    v-model="item.psfRecoveryOpen"
                                                                                    placeholder="Enter details"
                                                                                    rows="3"
                                                                                ></b-form-textarea>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col md="6" v-if="item.psfRecoveryReferral.includes('Family Navigator')">
                                                                            <b-form-group label="Family Navigator Details" :label-for="'psf-recovery-family-' + index">
                                                                                <b-form-textarea
                                                                                    :id="'psf-recovery-family-' + index"
                                                                                    v-model="item.psfRecoveryFamily"
                                                                                    placeholder="Enter details"
                                                                                    rows="3"
                                                                                ></b-form-textarea>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col md="6" v-if="item.psfRecoveryReferral.includes('Regional Addiction Resource Center')">
                                                                            <b-form-group label="Regional Addiction Resource Center Details" :label-for="'psf-recovery-regional-' + index">
                                                                                <b-form-textarea
                                                                                    :id="'psf-recovery-regional-' + index"
                                                                                    v-model="item.psfRecoveryRegional"
                                                                                    placeholder="Enter details"
                                                                                    rows="3"
                                                                                ></b-form-textarea>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col md="12" v-if="item.psfRecoveryReferral.includes('Self Help')">
                                                                            <b-form-group label="Self Help" :label-for="'psf-recovery-self-help-' + index">
                                                                                <v-select
                                                                                    :id="'psf-recovery-self-help-' + index"
                                                                                    v-model="item.psfRecoverySelfHelp"
                                                                                    :options="psfRecoverySelfHelpOptions"
                                                                                    placeholder="Select self help type"
                                                                                ></v-select>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col md="12" v-if="item.psfRecoverySelfHelp === 'Other'">
                                                                            <b-form-group label="Other Self Help Details" :label-for="'psf-recovery-self-help-other-' + index">
                                                                                <b-form-textarea
                                                                                    :id="'psf-recovery-self-help-other-' + index"
                                                                                    v-model="item.psfRecoverySelfHelpOther"
                                                                                    placeholder="Enter details"
                                                                                    rows="3"
                                                                                ></b-form-textarea>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col md="12" v-if="item.psfRecoveryReferral.includes('Other')">
                                                                            <b-form-group label="Other Recovery Service Details" :label-for="'psf-recovery-other-' + index">
                                                                                <b-form-textarea
                                                                                    :id="'psf-recovery-other-' + index"
                                                                                    v-model="item.psfRecoveryOther"
                                                                                    placeholder="Enter details"
                                                                                    rows="3"
                                                                                ></b-form-textarea>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <!-- Attestation -->
                                                                        <b-col md="12">
                                                                            <b-form-group label="Attestation - I completed the form. Peer Signature (typed)" :label-for="'psf-signature-' + index">
                                                                                <b-form-input
                                                                                    :id="'psf-signature-' + index"
                                                                                    v-model="item.psfSignature"
                                                                                    placeholder="Type your signature"
                                                                                ></b-form-input>
                                                                            </b-form-group>
                                                                        </b-col>
                                                                    </b-row>

                                                                    <b-col cols="12" style="" class="mt-4 mb-2">
                                                                        <hr>
                                                                    </b-col>
                                                                </b-card>
                                                            </app-collapse-item>
                                                        </app-collapse>
                                                    </b-col>
                                                </b-row>
                                            </b-form>
                                        </b-col>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>

                        <!-- Peer Services Discharge Form -->
                        <b-row cols="12" class="mt-2" v-if="((userData.uid === (typeof peerAssignedSaved === 'object' && (peerAssignedSaved && peerAssignedSaved.uid) ? peerAssignedSaved.uid : '')) || (isAdmin || managerPeerSupervisor) || ((isAdmin || managerPeerSupervisor || managerPA) && (!peerAssignedSaved && !peerCompletingSaved))) && (((managerPeerSupervisor || isAdmin) && (activityStatus === 'Engaged' && (engagedStatus === 'Referred to Peer Advocate' || engagedStatus === 'Referred to Clinician and Peer Advocate')) || (activityStatus === 'Closed - Referred to OASAS Program' && referredToPeerAdvocate === 'Yes')) || ((managerPeerSupervisor || managerPA || isAdmin) && (activityStatus === 'Engaged' && (engagedStatus === 'Referred to Peer Advocate' || engagedStatus === 'Referred to Clinician and Peer Advocate')) || (activityStatus === 'Closed - Referred to OASAS Program' && referredToPeerAdvocate === 'Yes')))">
                            <b-col md="12" v-if="activityStatus === 'Engaged' || activityStatus === 'Closed - Referred to OASAS Program'">
                                <b-button
                                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                                    :variant="enterPeerServicesDischargeForm ? 'outline-primary' : 'outline-success'"
                                    @click="enterPeerServicesDischargeForm ? enterPeerServicesDischargeForm = false : enterPeerServicesDischargeForm = true"
                                    class="p-50"
                                    :disabled="clinicianUsers ? true : isAdmin ? false : managerPA ? false : managerPeerSupervisor ? false : isClinicianStaff || !adminOrManageUsers ? true : dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? true : clinicianUsers && $route.name === 'edit-client' ? false : true"
                                >
                                Peer Services Discharge Form
                                </b-button>
                            </b-col>

                            <b-col md="12" v-if="enterPeerServicesDischargeForm && (activityStatus.includes('Engaged') || activityStatus.includes('Admitted') || activityStatus.includes('Discharged') || activityStatus.includes('Closed - Referred to OASAS Program'))">
                                <h4 class="mt-2">Peer Services Discharge Form</h4>
                                <hr>

                                <b-row>
                                    <b-col md="12">
                                        <b-col md="12">
                                            <b-col md="6">
                                                <b-form-group label="Date of discharge" label-for="psdf-date">
                                                <flat-pickr
                                                    id="psdf-date"
                                                    v-model="psdfDate"
                                                    class="form-control"
                                                    placeholder="Select a Date"
                                                    :config="{ altInput: true, altFormat: 'F j, Y', dateFormat: 'm-d-Y'}"
                                                />
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12">
                                                <b-form-group label="Discharge status" label-for="psdf-status">
                                                <v-select
                                                    id="psdf-status"
                                                    v-model="psdfStatus"
                                                    :options="psdfStatusOptions"
                                                    placeholder="Select discharge status"
                                                ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12">
                                                <b-form-group label="Discharge disposition" label-for="psdf-disposition">
                                                <v-select
                                                    id="psdf-disposition"
                                                    v-model="psdfDisposition"
                                                    :options="psdfDispositionOptions"
                                                    placeholder="Select disposition"
                                                    multiple
                                                ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12">
                                                <b-form-group label="Referral disposition" label-for="psdf-referral-disposition">
                                                <v-select
                                                    id="psdf-referral-disposition"
                                                    v-model="psdfReferralDisposition"
                                                    :options="psdfReferralDispositionOptions"
                                                    placeholder="Select referral disposition"
                                                    multiple
                                                ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12">
                                                <b-form-group label="Number of sessions attended" label-for="psdf-sessions-attended">
                                                <b-form-input
                                                    id="psdf-sessions-attended"
                                                    v-model="psdfSessionsAttended"
                                                    placeholder="Auto-filled based on session forms"
                                                    readonly
                                                    :disabled="true"
                                                ></b-form-input>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12">
                                                <b-form-group label="Current gambling compared to admission" label-for="psdf-gambling-comparison">
                                                <v-select
                                                    id="psdf-gambling-comparison"
                                                    v-model="psdfGamblingComparison"
                                                    :options="psdfGamblingComparisonOptions"
                                                    placeholder="Select comparison"
                                                ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12">
                                                <b-form-group label="Client involved with self-help at discharge" label-for="psdf-self-help">
                                                <v-select
                                                    id="psdf-self-help"
                                                    v-model="psdfSelfHelp"
                                                    :options="psdfSelfHelpOptions"
                                                    placeholder="Select option"
                                                ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12">
                                                <b-form-group label="Client referred for continued services" label-for="psdf-continued-services">
                                                <v-select
                                                    id="psdf-continued-services"
                                                    v-model="psdfContinuedServices"
                                                    :options="psdfContinuedServicesOptions"
                                                    placeholder="Select services"
                                                    multiple
                                                ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <!-- Problem Gambling Treatment Services -->
                                            <b-col md="12" v-if="psdfContinuedServices.includes('Problem Gambling Treatment Services')">
                                                <b-form-group label="Problem Gambling Treatment Services" label-for="psdf-pg-treatment">
                                                <v-select
                                                    id="psdf-pg-treatment"
                                                    v-model="psdfPgTreatment"
                                                    :options="psdfTreatmentOptions"
                                                    placeholder="Select treatment type"
                                                ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <!-- Substance Use Treatment Services -->
                                            <b-col md="12" v-if="psdfContinuedServices.includes('Substance Use Treatment Services')">
                                                <b-form-group label="Substance Use Treatment Services" label-for="psdf-sud-treatment">
                                                <v-select
                                                    id="psdf-sud-treatment"
                                                    v-model="psdfSudTreatment"
                                                    :options="psdfTreatmentOptions"
                                                    placeholder="Select treatment type"
                                                ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <!-- Recovery Support Services -->
                                            <b-col md="12" v-if="psdfContinuedServices.includes('Recovery Support Services')">
                                                <b-form-group label="Recovery Support Services" label-for="psdf-recovery-services">
                                                <v-select
                                                    id="psdf-recovery-services"
                                                    v-model="psdfRecoveryServices"
                                                    :options="psdfRecoveryServicesOptions"
                                                    placeholder="Select recovery services"
                                                    multiple
                                                ></v-select>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="psdfRecoveryServices.includes('Recovery Community and Outreach Center')">
                                                <b-form-group label="Recovery Community and Outreach Center Details" label-for="psdf-recovery-rcoc">
                                                <b-form-textarea
                                                    id="psdf-recovery-rcoc"
                                                    v-model="psdfRecoveryRcoc"
                                                    placeholder="Enter details"
                                                    rows="3"
                                                ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="psdfRecoveryServices.includes('Youth Clubhouse')">
                                                <b-form-group label="Youth Clubhouse Details" label-for="psdf-recovery-youth">
                                                <b-form-textarea
                                                    id="psdf-recovery-youth"
                                                    v-model="psdfRecoveryYouth"
                                                    placeholder="Enter details"
                                                    rows="3"
                                                ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="psdfRecoveryServices.includes('Peer Advocate')">
                                                <b-form-group label="Peer Advocate Details" label-for="psdf-recovery-peer">
                                                <b-form-textarea
                                                    id="psdf-recovery-peer"
                                                    v-model="psdfRecoveryPeer"
                                                    placeholder="Enter details"
                                                    rows="3"
                                                ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="psdfRecoveryServices.includes('Open Access Center')">
                                                <b-form-group label="Open Access Center Details" label-for="psdf-recovery-open">
                                                <b-form-textarea
                                                    id="psdf-recovery-open"
                                                    v-model="psdfRecoveryOpen"
                                                    placeholder="Enter details"
                                                    rows="3"
                                                ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="psdfRecoveryServices.includes('Family Navigator')">
                                                <b-form-group label="Family Navigator Details" label-for="psdf-recovery-family">
                                                <b-form-textarea
                                                    id="psdf-recovery-family"
                                                    v-model="psdfRecoveryFamily"
                                                    placeholder="Enter details"
                                                    rows="3"
                                                ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="psdfRecoveryServices.includes('Regional Addiction Resource Center')">
                                                <b-form-group label="Regional Addiction Resource Center Details" label-for="psdf-recovery-regional">
                                                <b-form-textarea
                                                    id="psdf-recovery-regional"
                                                    v-model="psdfRecoveryRegional"
                                                    placeholder="Enter details"
                                                    rows="3"
                                                ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <b-col md="12" v-if="psdfRecoveryServices.includes('Other')">
                                                <b-form-group label="Other Recovery Service Details" label-for="psdf-recovery-other">
                                                <b-form-textarea
                                                    id="psdf-recovery-other"
                                                    v-model="psdfRecoveryOther"
                                                    placeholder="Enter details"
                                                    rows="3"
                                                ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>

                                            <!-- Status of Gambling Related Problems -->
                                            <b-row class="px-1">
                                                <h6 class="mt-2">Status of Gambling Related Problems</h6>
                                                <hr style="width: 100%;">

                                                <b-col md="6">
                                                    <b-form-group label="Gambling" label-for="psdf-problem-gambling">
                                                    <v-select
                                                        id="psdf-problem-gambling"
                                                        v-model="psdfProblemGambling"
                                                        :options="psdfProblemStatusOptions"
                                                        placeholder="Select status"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Drug Use" label-for="psdf-problem-drug">
                                                    <v-select
                                                        id="psdf-problem-drug"
                                                        v-model="psdfProblemDrug"
                                                        :options="psdfProblemStatusOptions"
                                                        placeholder="Select status"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Alcohol Use" label-for="psdf-problem-alcohol">
                                                    <v-select
                                                        id="psdf-problem-alcohol"
                                                        v-model="psdfProblemAlcohol"
                                                        :options="psdfProblemStatusOptions"
                                                        placeholder="Select status"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Financial" label-for="psdf-problem-financial">
                                                    <v-select
                                                        id="psdf-problem-financial"
                                                        v-model="psdfProblemFinancial"
                                                        :options="psdfProblemStatusOptions"
                                                        placeholder="Select status"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Legal" label-for="psdf-problem-legal">
                                                    <v-select
                                                        id="psdf-problem-legal"
                                                        v-model="psdfProblemLegal"
                                                        :options="psdfProblemStatusOptions"
                                                        placeholder="Select status"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Vocational/Educational" label-for="psdf-problem-vocational">
                                                    <v-select
                                                        id="psdf-problem-vocational"
                                                        v-model="psdfProblemVocational"
                                                        :options="psdfProblemStatusOptions"
                                                        placeholder="Select status"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Medical/Health" label-for="psdf-problem-medical">
                                                    <v-select
                                                        id="psdf-problem-medical"
                                                        v-model="psdfProblemMedical"
                                                        :options="psdfProblemStatusOptions"
                                                        placeholder="Select status"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Lethality: Self" label-for="psdf-problem-lethality-self">
                                                    <v-select
                                                        id="psdf-problem-lethality-self"
                                                        v-model="psdfProblemLethalitySelf"
                                                        :options="psdfProblemStatusOptions"
                                                        placeholder="Select status"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Lethality: Other" label-for="psdf-problem-lethality-other">
                                                    <v-select
                                                        id="psdf-problem-lethality-other"
                                                        v-model="psdfProblemLethalityOther"
                                                        :options="psdfProblemStatusOptions"
                                                        placeholder="Select status"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Mental Health" label-for="psdf-problem-mental">
                                                    <v-select
                                                        id="psdf-problem-mental"
                                                        v-model="psdfProblemMental"
                                                        :options="psdfProblemStatusOptions"
                                                        placeholder="Select status"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col md="6">
                                                    <b-form-group label="Family" label-for="psdf-problem-family">
                                                    <v-select
                                                        id="psdf-problem-family"
                                                        v-model="psdfProblemFamily"
                                                        :options="psdfProblemStatusOptions"
                                                        placeholder="Select status"
                                                    ></v-select>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>

                        </b-col>

                        <!-- RIGHT CONTENT -->
                        <b-col md="4">
                            <b-form-group
                                label="Peer Services Notes"
                            >
                                <b-form-textarea
                                    id="textarea-default"
                                    placeholder="Peer Services Notes"
                                    rows="3"
                                    v-model="pSNotes"
                                />
                            </b-form-group>
                        </b-col>
                        </b-row>
                        </div>

                        <download-csv
                            :data="json_data"
                            class="mt-2 ml-1 btn btn-default"
                            name="nycpg.csv"
                            style="background: #94221e; color: #fff;"
                            v-if="dataSpecialist"
                        >
                            CSV Export
                        </download-csv>

                        <!-- Form Actions -->
                        <div class="d-flex mt-2 float-right">
                            <b-button
                                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                variant="flat-primary"
                                @click="backList"
                            >
                            Back to list
                            </b-button>
                            <b-button
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                variant="primary"
                                class="mr-2"
                                type="submit"
                                @click.prevent="validationForm"
                                v-if="(clinicianUsers && $route.name === 'edit-client')"
                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                            >
                            Save
                            </b-button>
                            <b-button
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                variant="primary"
                                class="mr-2"
                                type="submit"
                                @click.prevent="validationForm"
                                v-else-if="!clinicianOrClinicianViewer"
                                :disabled="dataSpecialist ? true : staffOrClinician && $route.name === 'edit-clinician' ? true : !clinicianUsers ? false : clinicianUsers && $route.name === 'edit-client' ? false : true"
                            >
                            Save
                            </b-button>
                            <b-button
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                variant="primary"
                                class="mr-2"
                                type="submit"
                                @click.prevent="validationForm"
                                v-else-if="clinicianUsers"
                                :disabled="false"
                            >
                            Save
                            </b-button>
                        </div>
                    </b-form>
                </validation-observer>

            <b-popover
                ref="popover"
                target="popover-reactive-1"
                triggers="click"
                :show.sync="popoverShowDischargeDate"
                placement="auto"
                container="my-container"
                @show="onShowDischargeDate"
                @hidden="onHiddenDischargeDate"
            >
                <div class="mb-1">
                    <span>
                        Please clic N/A if it doesn´t apply
                    </span>
                </div>
                <div>
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        size="sm"
                        variant="danger"
                        class="mr-1"
                        @click="onCloseDischargeDate"
                    >
                    Cancel
                    </b-button>
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        size="sm"
                        variant="primary"
                        @click="onOkDischargeDate"
                    >
                    N/A
                    </b-button>
                </div>
            </b-popover>
            <b-popover
                ref="popover"
                target="popover-reactive-2"
                triggers="click"
                :show.sync="popoverShow"
                placement="auto"
                container="my-container"
                @show="onShow"
                @hidden="onHidden"
            >
                <div class="mb-1">
                    <span>
                        Please clic N/A if it doesn´t apply
                    </span>
                </div>
                <div>
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        size="sm"
                        variant="danger"
                        class="mr-1"
                        @click="onClose"
                    >
                    Cancel
                    </b-button>
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        size="sm"
                        variant="primary"
                        @click="onOk"
                    >
                    N/A
                    </b-button>
                </div>
            </b-popover>
        </div>
    </div>
    <!-- </div> -->
</template>

<script>
import { BForm, BButton, BRow, BCol, BFormGroup, BFormInput, BFormTextarea, BTable, BFormInvalidFeedback, BFormCheckbox, BAlert, BSpinner, VBTooltip, BPopover, BCard, } from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { heightTransition } from '@core/mixins/ui/transition'
import { required, email } from '@validations'
import Cleave from 'vue-cleave-component'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { mapState, mapActions } from 'vuex'
import { db, auth } from '@/firebase'

export default {
    data() {
        return {
            // validation
            required,
            email,
            options: {
                block: {
                    numeral: true,
                    numeralThousandsGroupStyle: 'false',
                    delimiter: ''
                },
            },
            userData: '',
            clinicianUsers: false,
            viewClinicianCLienActivity: false,
            clinicianOrClinicianViewer: false,
            staffOrClinician: false,
            dataSpecialist: false,
            adminOrManageUsers: false,
            isAdmin: false,
            managerPA: false,
            managerPeerSupervisor: false,
            loadDataPage: false,
            client: '',
            nameClient: '',
            requiredDischargeForm: false,
            popoverShow: false,
            popoverShowDischargeDate: false,
            isClinicianStaff: false,

            // configuration remove record admission/discharge
            removeRecordAdmissionData: false,
            removeRecordDischargeData: false,

            // settings table and edit view
            statusEditClientActivity: true,
            pushEditButton: false,
            itemsActivity: [],
            fieldsTable: [
                { key: 'statusLogical', label: 'status', sortable: false },
                { key: 'contactDate', sortable: false },
                { key: 'admissionDate', sortable: false },
                { key: 'dischargeDate', sortable: false },
                { key: 'actions', sortable: false },
            ],

            // vse forms
            notesVSE: '',
            finalStatusVSE: '',
            staffMemberCompletingFormVSE: '',
            contactDateVSE: '',
            genderVSE: '',
            referredByVSE: '',
            familyMemberSelfVSE: '',
            problemGamblingTreatmentServicesVSE: '',
            problemGamblingSelfHelpGroupMeetingsVSE: '',
            substanceUseTreatmentServicesVSE: '',
            recoverySupportServicesVSE: '',
            otherReferredByVSE: '',
            warmTransferVSE: '',
            pgrcPmSE: '',
            PGRCPrivatePractitionerVSE: '',
            OASASProgramVSE: '',
            GamingFacilityVSE: '',
            connectedToPGRCVSE: '',
            connectedToPeerAdvocateVSE: '',
            connectedtoNYSGamingCommissionVSE: '',
            typesofGamblingEngagedInVSE: '',
            interventionStatusVSE: '',
            pendingVSE: '',
            appointmentDateVSE: '',
            followUpDateVSE: '',
            VSETimeframe: '',
            // vse options forms
            optionsFinalStatusVSE: [],
            optionsStaffMemberCompletingFormVSE: [],
            optionsGenderVSE: [],
            optionsConnectedToPGRCVSE: [],
            optionsInterventionStatusVSE: [],
            optionsPendingVSE: [],
            optionsVSETimeframe: [],
            optionsGamblingTypesVSE: [],

            // form
            clinician: [],
            dateOfContact: null,
            methodOfContact: '',
            contactStatus: '',
            referredBy: '',
            otherReferredBy: '',
            warmTransfer: '',
            initialAppointmentDate: null,
            time: '',
            wasTheCallHelpful: '',
            wasTheCallHelpfulIfNotWhy: '',
            informationKitAccepted: '',
            informationKitOption: '',
            regionalCFEReceivingTheCall: '',
            referredToPeerAdvocate: '',
            borough: '',
            readmission: '',
            race: '',
            householdIncome: '',
            gamblingTypes: '',
            employmentStatus: '',
            educationLevels: '',

            ethnicity: '',
            veteran: '',
            zipCode: '',
            industryOfEmployment: '',
            maritalStatus: '',
            religiousPreference: '',
            connectedToPeerAdvocate: '',
            connectedToVSE: '',
            connectedToPeerEducationGroup: '',
            connectedToFamilyEducationGroup: '',
            connectedToAsianServicesProgram: '',
            connectedToGamFin: '',
            // enter adminission/discharge information
            enterAdmissionDischargeInformation: false,
            enterAdmissionInformation: false,
            enterDischargeInformation: false,
            enterSurveyInformation: false,
            // admission form
            dateOfAdmission: null,
            newOrReturningClient: '',
            clientStatusAdmission: '',
            presentingProblemsAtAdmission: '',
            diagnosticCriteriaMetAtAdmission: '',
            otherProblemsAdmission: '',
            clientInvolvedWithLegalSystem: '',
            clientReleaseSigned: '',
            referredByAdmission: '',
            familyMemberSelfAdmission: '',
            problemGamblingTreatmentServicesAdmission: '',
            problemGamblingSelfHelpGroupMeetingsAdmission: '',
            substanceUseTreatmentServicesAdmission: '',
            recoverySupportServicesAdmission: '',
            otherReferredByAdmission: '',
            warmTransferAdmission: '',
            locadtrg: '',
            LOCADTRAssessmentID: '',
            dateOfBirthAdmission: '',
            sexAtBirth: '',
            last4SSN: '',
            firstTwoLettersLastName: '',

            frequencyofGambling: '',
            ageFirstGambled: '',
            past30DaysAmountOfMoney: '',
            past30DaysHowMuchTime: '',
            past30DaysHowManyDays: '',
            gamblinglocationspast12months: '',
            hasClientAttendedReceivedServices: '',
            legalSystem: '',

            notesAdmission: '',
            // discharge form
            dateOfDischarge: null,
            dischargeStatus: '',
            plannedDischargeReasons: '',
            unplannedDischargeReason: '',
            numberOfSessionsAttended: null,
            diagnosticCriteriaMetAtAdmissionWasReduced: '',
            diagnosticCriteriaMetAtDischarge: '',
            goalsMet: '',
            currentGamblingComparedToAdmission: '',
            clientInvolvedWithSelfHelpAtDischarge: '',
            clientReferredForContinuedServices: '',
            ifSoWhatServicesWereRecommended: '',
            relatedProblemsGambling: '',
            relatedProblemsDrugUse: '',
            relatedProblemsAlcoholUse: '',
            relatedProblemsFinancial: '',
            relatedProblemsLegal: '',
            relatedProblemsVocationalEducational: '',
            relatedProblemsMedicalHealth: '',
            relatedProblemsLethalitySelf: '',
            relatedProblemsLethalityOther: '',
            relatedProblemsMentalHealth: '',
            relatedProblemsFamily: '',
            notesDischarge: '',
            // survey
            isClientInsured: '',
            isClientMatchedToaClinicianWhoAcceptsTheirInsurance: '',
            isTheClinicianBillingTheClientsInsurance: '',
            whyInsuranceWasNotBilled: '',
            whyInsuranceWasNotBilledOther: '',
            reasonWhyClientWasReferredToClinician: '',
            reasonWhyClientWasReferredToClinicianOther: '',

            // content right
            specialIssuesOrOtherComments: '',
            callNotes: '',
            activityStatus: '',
            closeNotes: '',

            // "contactDate","admissionDate","dischargeDate","clientId","clinicianId","clinicianEngagementId","callWasHelpful",
            // "callWasNotHelpfulReason","comments","dateCreated","eligibleForServices","externalReferenceLocation","informationKitAccepted",
            // "initialAppointmentDate","notes","referencedExternally","referredByOther","clientStatusCloseNotes","readmission","clientStatusId",
            // "clientStatus","contactMethodId","callerTypeId","referredByTypeId","regionId"
            json_data: [],

            // get data from db
            optionsClient: [],
            optionsClinician: [],
            optionsRace: [],
            optionsHouseholdIncome: [],
            optionsGamblingTypes: [],
            optionsEmploymentStatus: [],
            optionsEducationLevels: [],
            
            optionsClientStatusAdmission: [
                'Problem Gambler',
                'Family Member'
            ],
            optionsGamblingRelatedProblems: [
                'Achieved',
                'Partial Achievement',
                'Not Achieved',
                'Not Applicable'
            ],
            optionsFrequencyofGambling: [
                'None in the last 30 days',
                '1 - 3 times in the last 30 days',
                '1 - 2 times per week',
                '3 - 6 times per week',
                'Daily',
                'Prefer not to answer'
            ],
            optionsGamblinglocationspast12months: [
                'None',
                'Casino',
                'Race track',
                'Grocery/Convenience Store',
                'Internet',
                'Off-Track Betting (OTB)',
                'Bookie',
                'Bar/Restaurant',
                'Work',
                'School',
                'Home',
                'Church',
                'Community Site',
                'Other',
                'Prefer not to answer'
            ],
            optionsHasClientAttendedReceivedServices: [
                'Self-Help',
                'Other Gambling Program',
                'Financial and/or Credit Counseling Service',
                'N/A',
                'Prefer not to answer'
            ],
            optionsLegalSystem: [
                'Pre-Court Sentence (no Alternative to Incarceration)',
                'Pre-Court Sentence (Alternative to Incarceration)',
                'Probation (no Alternative to Incarceration)',
                'Probation (Alternative to Incarceration)',
                'Correctional-based setting',
                'Post-correctional supervision',
                'Other Alternative to Incarceration'
            ],
            optionsMethodOfContact: ['Call', 'Email', 'Text'],
            optionsContactStatus: ['Family member/Significant Other', 'Other', 'Problem Gambler'],
            optionsReferredByVSE: [
                // 'HOPEline',
                // 'Family member/Self',
                // 'Friends or Other Individual',
                // 'Problem Gambling Self-Help Group Meetings',
                // 'Substance Use Self-Help Group Meetings',
                // 'Financial Counseling',
                // 'Crisis Services',
                // 'Problem Gambling Treatment Services',
                // 'Substance Use Treatment Services',
                // 'Recovery Support Services',
                // 'PGRC PM',
                // 'PGRC Private Practitioner',
                // 'OASAS Program',
                // 'Gaming Facility',
                // 'Other'
            ],
            optionsReferredBy: [
                // 'Existing or past CFE client',
                // 'Family member/Self',
                // 'GA/GamAnon',
                // 'HOPEline',
                // 'Internet Search',
                // 'Legal System',
                // 'Friends or Other Individual',
                // 'Problem Gambling Self-Help Group Meetings',
                // 'Substance Use Self-Help Group Meetings',
                // 'Financial Counseling',
                // 'Crisis Services',
                // 'Problem Gambling Treatment Services',
                // 'Substance Use Treatment Services',
                // 'Recovery Support Services',
                // 'Other service provider',
                // 'Other (please describe)'

                // 'Self-Referral',
                // 'Spouse',
                // 'Family, Friends. Other Individual',
                // 'Problem Gambling Self-Help Group Meetings',
                // 'Substance Use Self-Help Group Meetings',
                // 'HOPEline',
                // 'Financial Counseling',
                // 'Crisis Services',
                // 'Problem Gambling Treatment Services',
                // 'Substance Use Treatment Services',
                // 'Recovery Support Services',
                // 'Other'

                'HOPEline',
                'Family member/Self',
                'Friends or Other Individual',
                'Problem Gambling Self-Help Group Meetings',
                'Substance Use Self-Help Group Meetings',
                'Financial Counseling',
                'Crisis Services',
                'Problem Gambling Treatment Services',
                'Substance Use Treatment Services',
                'Recovery Support Services',
                'Other'
            ],
            familyMemberSelf: '',
            optionsFamilyMemberSelf: [
                'Self-Referral',
                'Spouse',
                'Family member'
            ],
            problemGamblingSelfHelpGroupMeetings: '',
            optionsProblemGamblingSelfHelpGroupMeetings: [
                'GA',
                'GamAnon',
                'Smart Recovery',
                'Other'
            ],
            problemGamblingTreatmentServices: '',
            optionsProblemGamblingTreatmentServices: [
                'Inpatient Rehabilitation',
                'Residential',
                'Outpatient'
            ],
            substanceUseTreatmentServices: '',
            optionsSubstanceUseTreatmentServices: [
                'Inpatient Rehabilitation',
                'Residential',
                'Outpatient'
            ],
            recoverySupportServices: '',
            optionsRecoverySupportServices: [
                'Recovery Community and Outreach Center',
                'Youth Clubhouse',
                'Peer Advocate',
                'Open Access Center',
                'Family Navigator',
                'Regional Addiction Resource Center'
            ],
            optionsWarmTransfer: ['Yes', 'No'],
            optionsTime: [
                '12:00 AM', '12:15 AM', '12:30 AM', '12:45 AM',
                '01:00 AM', '01:15 AM', '01:30 AM', '01:45 AM',
                '02:00 AM', '02:15 AM', '02:30 AM', '02:45 AM',
                '03:00 AM', '03:15 AM', '03:30 AM', '03:45 AM',
                '04:00 AM', '04:15 AM', '04:30 AM', '04:45 AM',
                '05:00 AM', '05:15 AM', '05:30 AM', '05:45 AM',
                '06:00 AM', '06:15 AM', '06:30 AM', '06:45 AM',
                '07:00 AM', '07:15 AM', '07:30 AM', '07:45 AM',
                '08:00 AM', '08:15 AM', '08:30 AM', '08:45 AM',
                '09:00 AM', '09:15 AM', '09:30 AM', '09:45 AM',
                '10:00 AM', '10:15 AM', '10:30 AM', '10:45 AM',
                '11:00 AM', '11:15 AM', '11:30 AM', '11:45 AM',
                '12:00 PM', '12:15 PM', '12:30 PM', '12:45 PM',
                '01:00 PM', '01:15 PM', '01:30 PM', '01:45 PM',
                '02:00 PM', '02:15 PM', '02:30 PM', '02:45 PM',
                '03:00 PM', '03:15 PM', '03:30 PM', '03:45 PM',
                '04:00 PM', '04:15 PM', '04:30 PM', '04:45 PM',
                '05:00 PM', '05:15 PM', '05:30 PM', '05:45 PM',
                '06:00 PM', '06:15 PM', '06:30 PM', '06:45 PM',
                '07:00 PM', '07:15 PM', '07:30 PM', '07:45 PM',
                '08:00 PM', '08:15 PM', '08:30 PM', '08:45 PM',
                '09:00 PM', '09:15 PM', '09:30 PM', '09:45 PM',
                '10:00 PM', '10:15 PM', '10:30 PM', '10:45 PM',
                '11:00 PM', '11:15 PM', '11:30 PM', '11:45 PM',
            ],
            optionsWasTheCallHelpful: ['Yes', 'No'],
            optionsInformationKitAccepted: ['Yes', 'No'],
            optionsInformationKitOption: [
                'Client Resources Link',
                'Online Gambling Blocker',
                'GA, GamAnon',
                'Smart Recovery',
                'VSE',
                'Financial counseling'
            ],
            optionsRegionalCFEReceivingTheCall: [],
            optionsBorough: [
                'Bronx',
                'Brooklyn',
                'Manhattan',
                'Queens',
                'Staten Island'
            ],
            // optionsRegionalCFEReceivingTheCall: [
            //     'Bronx',
            //     'Brooklyn',
            //     'Central',
            //     'Finger Lakes',
            //     'Long Island',
            //     'Manhattan',
            //     'Mid-Hudson',
            //     'Northeast',
            //     'Queens',
            //     'Staten Island',
            //     'Western'
            // ],
            optionsReadmission: ['Yes', 'No'],

            optionsEthnicity: [
                // 'Hispanic',
                // 'Not Hispanic',
                // 'N/A'
                'Cuban',
                'Mexican',
                'Puerto Rican',
                'Hispanic/Latino/a/x, Not Specified',
                'Not of Hispanic Origin',
                'Prefer not to answer'
            ],
            optionsVeteran: ['Yes', 'No', 'N/A'],
            optionsIndustryOfEmployment: [
                'Business',
                'Computer',
                'Telecommunications',
                'Financial Services',
                'Manufacturing',
                'Wholesale/Retail/Distribution',
                'Transportation',
                'Travel/Hospitality',
                'Government',
                'Military',
                'Aerospace',
                'Health Care/Medical',
                'Insurance/Legal',
                'Education',
                'Utilities',
                'Architecture/Construction/Real Estate',
                'Agriculture',
                'Religious',
                'Social Services',
                'Sales',
                'Gambling Industry',
                'None',
                'N/A'
            ],
            optionsMaritalStatus: [
                'Married',
                'Never married',
                'Living as married',
                'Separated',
                'Divorced',
                'Widowed',
                'N/A'
            ],
            optionsReligiousPreference: [
                'Catholic',
                'Protestant',
                'Other Christian',
                'Jewish',
                'Muslim',
                'Buddhist',
                'Atheist/Agnostic',
                'No preference',
                'Other',
                'N/A'
            ],
            primaryICD10: '',
            Z72GamblingAndBetting: '',
            numberofAssessmentVisits: '',
            age: '',
            sexualOrientation: '',
            genderIdentity: '',
            transgender: '',
            asianOrigin: '',
            pacificIslanderOrigin: '',
            developmentalDisability: '',
            coexistingPsychiatricDisorder: '',
            treatedForMentalIllness: '',
            hospitalizedForMentalIllness: '',
            hospitalized30OrMoreDaysForMentalIllness: '',
            smokedTobaccoInThePastWeek: '',
            usedSmokelessTobaccoInThePastWeek: '',
            substancesUsed: '',
            substanceUseRouteOfAdministration: '',
            frequencyOfSubstanceUse: '',
            ageOfFirstSubstanceUse: '',
            inThePastFewMonthsDrinks: '',
            dischargeDisposition: '',
            referralDisposition: '',
            optionsDischargeDisposition: [
                'Additional treatment at this level of care no longer necessary',
                'Further treatment at this level of care unlikely to yield additional clinical gains',
                'Left against clinical advice, Formal referral made/offered',
                'Left against clinical advice, Lost contact, No referral possible',
                'Left against clinical advice, Termination of third party funds',
                'Discharged due to non-compliance, Program Rules',
                'Discharged due to non-compliance, Violence',
                'Discharged due to non-compliance, Possession of contraband',
                'Client arrested/incarcerated',
                'Client could no longer participate for medical/psychiatric reasons',
                'Client death',
                'Client relocated',
                'Program closed',
            ],
            optionsReferralDisposition: [
                'No referral made',
                'Client not in need of additional services',
                'Client referred back to SUD program',
                'Client referred to other SUD program',
                'Client referred to mental health program',
                'Client referred to other problem gambling program',
                'Client refused referral',
            ],
            optionsPrimaryICD10: [
                'F 63.0 Pathological Gambling',
                'Z72.6 Gambling and Betting'
            ],
            optionsAge: [
                'Under 18',
                '18 - 24',
                '25 - 34',
                '35 - 44',
                '45 - 54',
                '55 - 64',
                '65+',
                'Prefer not to answer'
            ],
            optionsSexualOrientation: [
                'Bisexual',
                'Lesbian or Gay',
                'Pansexual',
                'Straight',
                'I use a different term',
                'Questioning/Unsure',
                'Prefer not to answer'
            ],
            optionsGenderIdentity: [
                'Intersex',
                'Man',
                'Non-Binary',
                'Two-Spirit',
                'Woman',
                'I use a different term',
                'Questioning/Unsure',
                'Prefer not to answer'
            ],
            optionsTransgender: [
                'Yes',
                'No',
                'Questioning/Unsure',
                'Prefer not to answer'
            ],
            optionsAsianOrigin: [
                'Asian Indian',
                'Bangladeshi',
                'Burmese',
                'Cambodian',
                'Chinese',
                'Filipino',
                'Hmong',
                'Indonesian',
                'Japanese',
                'Korean',
                'Laotian',
                'Malaysian',
                'Nepalese',
                'Pakistani',
                'Sri Lankan',
                'Taiwanese',
                'Thai',
                'Tibetan',
                'Vietnamese',
                'Asian, Not Specified',
                'Not of Asian Origin',
                'Prefer not to answer'
            ],
            optionsPacificIslanderOrigin: [
                'Fijian',
                'Guamanian',
                'Hawaiian',
                'Samoan',
                'Tongan',
                'Pacific Islander, Not Specified',
                'Not of Pacific Islander Origin',
                'Prefer not to answer'
            ],
            // optionsHowWasClientReferredForServices: [
            //     'Self-Referral',
            //     'Spouse',
            //     'Family, Friends. Other Individual',
            //     'Problem Gambling Self-Help Group Meetings',
            //     'Substance Use Self-Help Group Meetings',
            //     'HOPEline',
            //     'Financial Counseling',
            //     'Crisis Services',
            //     'Problem Gambling Treatment Services',
            //     'Substance Use Treatment Services',
            //     'Recovery Support Services',
            //     'Other'
            // ],
            optionsYesNoPreferNotToAnswer: [
                'No',
                'Yes',
                'Prefer not to answer'
            ],
            optionsSubstancesUsed: [
                'None',
                'Prefer not to answer',
                'Alcohol',
                'Cocaine',
                'Crack',
                'Marijuana/Hashish',
                'Heroin',
                'Buprenorphine',
                'Non-Rx Methadone',
                'OxyContin',
                'Other Opiate/Synthetic',
                'Alprazolam (Xanax)',
                'Barbiturate',
                'Benzodiazepine (Klonopin)',
                'Catapres (Clonidine)',
                'Other Sedative/Hypnotic',
                'Elavil',
                'GHB',
                'Khat',
                'Other Tranquilizer',
                'Methamphetamine',
                'Other Amphetamine',
                'Other Stimulant',
                'PCP',
                'Ecstasy',
                'Other Hallucinogen',
                'Ephedrine',
                'Inhalant',
                'Ketamine',
                'Rohypnol',
                'Over the counter',
                'Other'
            ],
            optionsSubstanceUseRouteOfAdministration: [
                'N/A',
                'Prefer not to answer',
                'Inhalation',
                'Injection',
                'Oral',
                'Smoking',
                'Vaping',
                'Other'
            ],
            optionsFrequencyOfSubstanceUse: [
                'N/A',
                'Prefer not to answer',
                'No use in past 30 days',
                '1 - 3 times in the past 30 days',
                '1 - 2 times per week',
                '3 - 6 times per week',
                'Daily'
            ],
            optionsConnectedToPeerAdvocate: ['Yes','No'],

            optionsActivityStatus: [
                'Engaged',
                'Closed - Attended First Session',
                'Closed - Did not attend first session',
                'Closed - Received information',
                'Closed - Referred to OASAS Program',
                'External Referral',
                'On Hold'
            ],
            engagedStatus: '',
            optionsEngagedStatus: [
                'Referred to Clinician',
                'Referred to Peer Advocate',
                'Referred to Clinician and Peer Advocate',
                'Pending/Undecided'
            ],

            // admission options
            optionsNewOrReturningClient: [
                'Returning Client',
                'New Client',
                'N/A'
            ],
            optionsPresentingProblemsAtAdmission: [
                'Co-occurring mental health disorders',
                'Co-occurring substance use disorders',
                'Employment difficulties',
                'Financial difficulties',
                'Physical health problems',
                'Relationship difficulties',
                'Education difficulties',
                'Marital difficulties',
                'Bankruptcy',
                'Borrowing or theft from family/friends',
                'Losing savings/retirement',
                'Significant debt',
                'Embezzlement',
                'Suicidal Ideation/Thoughts/Attempts',
                'Legal Issues',
                'Arrest',
                'Incarceration',
                'N/A'
            ],
            optionsDiagnosticCriteriaMetAtAdmission: [
                'N/A',
                'After losing money gambling, often returns another day to get even ("chasing" ones losses)',
                'Has jeopardized or lost a significant relationship, job, or educational or career opportunity because of gambling.',
                'Has made repeated unsuccesful efforts to control, cut back, or stop gambling',
                'Is often preoccupied with (e.g., having persistent thoughts of reliving past gambling experiences, handicapping or planning the next venture, thinking of ways to get money with which to gamble).',
                'Is restless or irritable when attempting to cut down or stop gambling.',
                'Lies to conceal the extent of involvement with gambling.',
                'Often gambles when feeling distressed (e.g., helpless, guilty, anxious, depressed).',
                'Needs to gamble with increasing amounts of money in order to achieve the desired excitement.',
                'Relies on others to provide money to relieve desperate financial situations caused by gambling.'
            ],
            optionsClientInvolvedWithLegalSystem: ['Yes', 'No', 'N/A'],
            optionsClientReleaseSigned: ['Yes', 'No', 'N/A'],
            
            // discharge options
            optionsStringsDischargeDate: ['n/a', 'N/A'],
            optionsStringsNumberSessions: [null, '', 'n/a', 'N/A', 'N', 'n', 'N/', 'n/'],
            optionsDischargeStatus: [
                'Completed Treatment, All Goals Met',
                'Completed Treatment, Half or More Goals Met',
                'Treatment Not Completed, Max Benefit/Clinical Decision',
                'Treatment Not Completed, Some Goals Met',
                'Treatment Not Completed, No Goals Met'
            ],
            // if DischargeStatus is Planned
            optionsPlannedDischargeReasons: [
                'Barriers to accessing services',
                'Client not ready for treatment',
                'Client reports improvement',
                'Completed treatment process (as determined by Clinician)',
                'Mandatory evaluation completed',
                'Other'
            ],
            optionsDiagnosticCriteriaMetAtAdmissionWasReduced: ['N/A','Yes', 'No'],
            optionsGoalsMet: ['N/A','Achieved','Not Achieved','Partially Achieved'],
            optionsCurrentGamblingComparedToAdmission: [
                'N/A',
                'No longer gambling',
                'Reduced gambling',
                'Same gambling',
                'Worse gambling'
            ],
            optionsClientInvolvedWithSelfHelpAtDischarge: ['Yes', 'No', 'N/A'],
            optionsClientReferredForContinuedServices: [
                'Problem Gambling Self-Help Group Meetings',
                'Substance Use Self-Help Group Meetings',
                'Financial Counseling',
                'Crisis Services',
                'Problem Gambling Treatment Services',
                'Substance Use Treatment Services',
                'Recovery Support Services',
                'Other'
            ],
            // problemGamblingTreatmentServices: '',
            referralrecoverySupportServices: '',
            admissionrecoverySupportServices: '',
            admissionproblemGamblingTreatmentServices: '',
            admissionsubstanceUseTreatmentServices: '',
            optionsProblemGamblingTreatmentServices: [
                'Inpatient Rehabilitation',
                'Residential',
                'Outpatient'
            ],
            substanceUseTreatmentServices: '',
            optionsSubstanceUseTreatmentServices: [
                'Inpatient Rehabilitation',
                'Residential',
                'Outpatient'
            ],
            recoverySupportServices: '',
            optionsRecoverySupportServices: [
                'Recovery Community and Outreach Center',
                'Youth Clubhouse',
                'Peer Advocate',
                'Open Access Center',
                'Family Navigator',
                'Regional Addiction Resource Center'
            ],
            otherClientReferredforContinuedServices: '',
            optionssexAtBirth: [
                'Male',
                'Female'
            ],

            optionsIfSoWhatServicesWereRecommended: [
                'GA',
                'GamAnon',
                'Smart Recovery',
                'Other Mutual Aid Support',
                'NYCPG Maintenance of Alumni Group',
                '1:1 Peer Support',
                'VSE'
            ],
            optionsConnected: ['Yes', 'No'],
            optionsYesNoSurvey: ['Yes', 'No'],
            optionsWhyInsuranceWasNotBilled: [
                'Cost of deductible',
                'Doesn’t want employer to find out',
                'Doesn’t want family member to find out',
                'Other'
            ],
            optionsReasonWhyClientWasReferredToClinician: [
                'Language',
                'Distance',
                'Religion',
                'Culture',
                'Gender',
                'Remote care services',
                'Fear/Stigma',
                'Availability',
                'Client requested specific clinician',
                'Other'
            ],
            nextTodoId: 1,
            validFormRepeater: true,
            itemsFormRepeater: [],
            optionsPaymentArrangement: [
                // 'I will bill the client’s insurance and the client will provide the required copay. NYCPG will not provide reimbursement.',
                // 'The client is uninsured. NYCPG will provide reimbursement.',
                // 'The client is uninsured and will utilize sliding scale. NYCPG will provide reimbursement.',
                // 'The client has insurance, but there is a high deductible and the client is unable to pay. NYCPG will provide reimbursement.',
                // 'The client has insurance, but is not able to provide the required copay. NYCPG will provide reimbursement.',
                // 'I will not bill the client’s insurance at the request of the client. NYCPG will provide reimbursement.',
                // 'The client has insurance that I do not accept. I was provided with this referral due to the circumstances selected below. NYCPG will provide reimbursement.',
                // 'The client will utilize sliding scale for reasons not specified on this form. NYCPG will provide reimbursement.'
            ],
            conditionsPArrangement: [],
            optionsTheClientInsuranceIdonotAccept: [
                'Language preference',
                'Religious preference',
                'Cultural preference',
                'Clinician specialty area',
                'Client requested specific clinician',
                'Other'
            ],

            // edit client activity
            // statusEdit: false,
            // idClientActivity: '',
            activityStatusAtomic: '',
            counterChangesActivityStatus: 0,
            referralOptions: '',
            recoverySupportServices: '',
            optionsReferralOptions: [],
            optionsRecoverySupportServices: [],
            OASASProgram: '',
            optionsOASASProgram: [
                'Inpatient',
                'Residential',
                'Outpatient'
            ],
            OASASProgramOptInpatient: '',
            OASASProgramOptResidential: '',
            OASASProgramOptOutpatient: '',
            privatePractitioner: '',
            recoveryCommunityOutreachCenter: '',
            youthClubhouse: '',
            peerAdvocate: '',
            openAccessCenter: '',
            familyNavigator: '',
            regionalAddictionResourceCenter: '',

            // survey condition
            logicisClientInsured: false,
            logicisClientMatchedToaClinicianWhoAcceptsTheirInsurance: false,
            logicisTheClinicianBillingTheClientsInsurance: false,
            logicisTheClinicianBillingTheClientsInsuranceOptionYes: false,

            // date of dicharge listener
            dodListener: '',

            enterPeerServicesForm: false,
            // Contact Information
            contactDate: '',
            peerCompleting: null,
            peerAssigned: null,
            peerCompletingSaved: null,
            peerAssignedSaved: null,
            clientType: null,
            pifClientStatus: null,
            referralSource: null,
            warmTransferPeer: null,
            familyReferralType: null,
            selfHelpGroupType: null,
            pgTreatmentType: null,
            sudTreatmentType: null,
            recoveryServiceType: null,
            recoveryServiceDetails: '',

            // Service Status - Campo principal
            serviceStatus: [],
            
            // Previously Attended Treatment - Sub-multiselect
            previouslyAttendedTreatment: [],
            prevPgInpatient: '',
            prevPgOutpatient: '',
            prevPgResidential: '',
            prevSudInpatient: '',
            prevSudOutpatient: '',
            prevSudResidential: '',
            
            // Currently Attending Treatment - Sub-multiselect
            currentlyAttendingTreatment: [],
            currPgInpatient: '',
            currPgOutpatient: '',
            currPgResidential: '',
            currSudInpatient: '',
            currSudOutpatient: '',
            currSudResidential: '',
            
            // Previously Utilized Recovery Services - Sub-multiselect
            previouslyUtilizedRecoveryServices: [],
            prevRecoveryRcocName: '',
            
            // Currently Utilizing Recovery Services - Sub-multiselect
            currentlyUtilizingRecoveryServices: [],
            currRecoveryRcocName: '',

            currRecoveryTxtBoxRcocName: '',
            
            // Previously Utilized Financial/Credit Counseling Services - Sub-multiselect
            previouslyUtilizedFinancialServices: [],
            prevFinancialOther: '',
            
            // Currently Utilizing Financial/Credit Counseling Services - Sub-multiselect
            currentlyUtilizingFinancialServices: [],
            currFinancialOther: '',
            
            // Options arrays
            serviceStatusOptions: [
            'Previously Attended Treatment',
            'Currently Attending Treatment',
            'Never Attended Treatment',
            'Previously Utilized Recovery Services',
            'Text box to enter RCOC name',
            'Currently Utilizing Recovery Services',
            'Never Utilized Recovery Services',
            'Previously Utilized Financial/Credit Counseling Services',
            'Currently Utilizing Financial/Credit Counseling Services',
            'Never Utilized Financial/Credit Counseling Services'
            ],
            
            previouslyAttendedTreatmentOptions: [
            'PG Inpatient',
            'PG Outpatient',
            'PG Residential',
            'SUD Inpatient',
            'SUD Outpatient',
            'SUD Residential'
            ],
            
            currentlyAttendingTreatmentOptions: [
            'PG Inpatient',
            'PG Outpatient',
            'PG Residential',
            'SUD Inpatient',
            'SUD Outpatient',
            'SUD Residential'
            ],
            
            previouslyUtilizedRecoveryServicesOptions: [
            'Recovery Community and Outreach Center'
            ],
            
            currentlyUtilizingRecoveryServicesOptions: [
            'Recovery Community and Outreach Center',
            'Youth Clubhouse',
            'Peer Advocate',
            'Open Access Center',
            'Family Navigator',
            'Regional Addiction Resource Center'
            ],
            
            previouslyUtilizedFinancialServicesOptions: [
            'GamFin',
            'Other'
            ],
            
            currentlyUtilizingFinancialServicesOptions: [
            'GamFin',
            'Other'
            ],
            prevRcocName: '',
            currRcocName: '',
            prevFinancialOther: '',
            currFinancialOther: '',
            presentingProblems: [],
            otherProblems: '',
            legalInvolvement: null,
            legalSystemType: null,
            releaseSigned: null,
            notes: '',

            // Demographic Information
            race: null,
            hispanicOrigin: null,
            asianOrigin: null,
            pacificIslanderOrigin: null,
            householdIncome: null,
            gamblingTypes: [],
            employmentStatus: null,
            highestGrade: null,
            veteran: null,
            zipCode: '',
            industry: null,
            maritalStatus: null,
            religiousPreference: null,
            age: null,
            sexualOrientation: null,
            genderIdentity: null,
            transgender: null,

            // Gambling Behavior
            gamblingFrequency: null,
            ageFirstGambled: '',
            typicalAmount: '',
            typicalTime: '',
            daysGambled: '',
            gamblingLocations: [],
            gamblingLocationOther: '',

            // Options arrays
            peerStaffOptions: [],
            clientTypeOptions: ['New client', 'Returning client', 'N/A'],
            clientStatusOptions: ['Problem Gambler', 'Family Member/Significant Other'],
            yesNoOptions: ['Yes', 'No'],
            referralSourceOptions: [
            'Hopeline',
            'Family member/Self',
            'Friends or Other Individual',
            'Problem Gambling Self-Help Group Meetings',
            'Substance Use Self-Help Group Meetings',
            'Financial Counseling',
            'Crisis Services',
            'Problem Gambling Treatment Services',
            'Substance Use Treatment Services',
            'Recovery Support Services'
            ],
            familyReferralTypeOptions: ['Self-Referral', 'Spouse', 'Family member'],
            selfHelpGroupOptions: ['GA', 'GamAnon', 'Smart Recovery', 'Other'],
            treatmentTypeOptions: ['Inpatient Rehabilitation', 'Residential', 'Outpatient'],
            recoveryServiceOptions: [
            'Recovery Community and Outreach Center',
            'Youth Clubhouse',
            'Peer Advocate',
            'Open Access Center',
            'Family Navigator',
            'Regional Addiction Resource Center',
            'Other'
            ],
            presentingProblemsOptions: [
            'Co-occurring mental health disorders',
            'Co-occurring substance use disorders',
            'Employment difficulties',
            'Financial difficulties',
            'Physical health problems',
            'Relationship difficulties',
            'Education difficulties',
            'Marital difficulties',
            'Bankruptcy',
            'Borrowing or theft from family/friends',
            'Losing savings/retirement',
            'Significant debt',
            'Embezzlement',
            'Suicidal Ideation/Thoughts/Attempts',
            'Legal Issues',
            'Arrest',
            'Incarceration',
            'N/A'
            ],
            legalSystemTypeOptions: [
            'Pre-Court Sentence (no Alternative to Incarceration)',
            'Pre-Court Sentence (Alternative to Incarceration)',
            'Probation (no Alternative to Incarceration)',
            'Probation (Alternative to Incarceration)',
            'Correctional-based setting',
            'Post-correctional supervision',
            'Other Alternative to Incarceration'
            ],
            raceOptions: [
            'Alaskan Native',
            'Asian',
            'Black or African American',
            'Hawaiian or other Pacific Islander',
            'Middle Eastern or North African',
            'Native American, Indigenous, or American Indian',
            'White',
            'Some other race, ethnicity, origin',
            'Prefer not to answer'
            ],
            hispanicOriginOptions: [
            'Cuban',
            'Mexican',
            'Puerto Rican',
            'Hispanic/Latino/a/x, Not Specified',
            'Not of Hispanic Origin',
            'Prefer not to answer'
            ],
            asianOriginOptions: [
            'Asian Indian',
            'Bangladeshi',
            'Burmese',
            'Cambodian',
            'Chinese',
            'Filipino',
            'Hmong',
            'Indonesian',
            'Japanese',
            'Korean',
            'Laotian',
            'Malaysian',
            'Nepalese',
            'Pakistani',
            'Sri Lankan',
            'Taiwanese',
            'Thai',
            'Tibetan',
            'Vietnamese',
            'Asian, Not Specified',
            'Not of Asian Origin',
            'Prefer not to answer'
            ],
            pacificIslanderOriginOptions: [
            'Fijian',
            'Guamanian',
            'Hawaiian',
            'Samoan',
            'Tongan',
            'Pacific Islander, Not Specified',
            'Not of Pacific Islander Origin',
            'Prefer not to answer'
            ],
            householdIncomeOptions: [
            'Less than 15k',
            '15k - 30k',
            '30,001 - 50k',
            '50,001k - 75k',
            '75,001 - 100k',
            'More than 100k',
            'N/A'
            ],
            gamblingTypesOptions: [
            'None',
            'Bingo',
            'Cards',
            'Horses',
            'Dogs/other animals',
            'Office pools',
            'Roulette',
            'Slot machines',
            'Sports',
            'Stock/commodities market',
            'Video lottery terminal',
            'Dice games/Coin flips',
            'Lottery (Numbers, Scratch-offs, Quick Draw)',
            'Game of Skill for Money (video games, bowling, pool, etc.)',
            'Raffles (including 50/50) or pull tabs',
            'Native American (Turning Stone, Seneca, Akwesasne, etc.)',
            'Gambling on the Internet (eGaming)',
            'Commercial Casinos (Tioga, Del Lago Resorts, World-Catskills, Rivers, etc.)',
            'Sports Betting at a Casino',
            'Mobile Sports Betting (MSB)',
            'Prefer not to answer'
            ],
            employmentStatusOptions: [
            'Employed Full Time - 35 hours or more/week',
            'Employed Part Time - less than 35 hours/week',
            'Unemployed, looking for work',
            'Unemployed, not looking for work',
            'Not in Labor Force, Retired',
            'Not in Labor Force, Disabled',
            'Not in Labor Force, Student',
            'Not in Labor Force, Other',
            'Prefer not to answer'
            ],
            highestGradeOptions: [
            'No Education',
            '1st grade',
            '2nd grade',
            '3rd grade',
            '4th grade',
            '5th grade',
            '6th grade',
            '7th grade',
            '8th grade',
            '9th grade',
            '10th grade',
            '11th grade',
            'High school Diploma',
            'General Equivalency Diploma (GED)',
            'Vocational Certificate w/out Diploma/GED',
            'Vocational Certificate w/ Diploma/GED',
            'Some College - No Degree',
            'Associate\'s Degree',
            'Bachelor\'s Degree',
            'Graduate Degree',
            'Prefer not to answer'
            ],
            industryOptions: [
            'Business',
            'Computer',
            'Telecommunication',
            'Financial services',
            'Manufacturing',
            'Wholesale/retail/distribution',
            'Transportation',
            'Travel/hospitality',
            'Government',
            'Military',
            'Aerospace',
            'Healthcare/medical',
            'Insurance/legal',
            'Education',
            'Utilities',
            'Architecture/construction/real estate',
            'Agriculture',
            'Religious',
            'Social services',
            'Sales',
            'Gambling industry',
            'None',
            'N/A'
            ],
            maritalStatusOptions: [
            'Married',
            'Never married',
            'Living as married',
            'Separated',
            'Divorced',
            'Widowed',
            'N/A'
            ],
            religiousPreferenceOptions: [
            'Catholic',
            'Protestant',
            'Other Christian',
            'Jewish',
            'Muslim',
            'Buddhist',
            'Atheist/Agnostic',
            'No preference',
            'Other',
            'N/A'
            ],
            ageOptions: [
            'Under 18',
            '18 - 24',
            '25 - 34',
            '35 - 44',
            '45 - 54',
            '55 - 64',
            '65+',
            'Prefer not to answer'
            ],
            sexualOrientationOptions: [
            'Bisexual',
            'Lesbian or Gay',
            'Pansexual',
            'Straight',
            'I use a different term',
            'Questioning/Unsure',
            'Prefer not to answer'
            ],
            genderIdentityOptions: [
            'Intersex',
            'Man',
            'Non-Binary',
            'Two-Spirit',
            'Woman',
            'I use a different term',
            'Questioning/Unsure',
            'Prefer not to answer'
            ],
            transgenderOptions: [
            'Yes',
            'No',
            'Questioning/Unsure',
            'Prefer not to answer'
            ],
            gamblingFrequencyOptions: [
            'None in the last 30 days',
            '1 - 3 times in the last 30 days',
            '1 - 2 times per week',
            '3 - 6 times per week',
            'Daily',
            'Prefer not to answer'
            ],
            gamblingLocationsOptions: [
            'None',
            'Casino',
            'Race track',
            'Grocery/Convenience Store',
            'Internet',
            'Off-Track Betting (OTB)',
            'Bookie',
            'Bar/Restaurant',
            'Work',
            'School',
            'Home',
            'Church',
            'Community Site',
            'Other',
            'Prefer not to answer'
            ],

            // Peer Goal Form
            enterPeerGoalForm: false,
            pgfDate: '',
            pgfGoals: [''],

            // Peer Session Form
            psfItemsFormRepeaterCache: [
            {
                id: 1,
                psfDate: '',
                psfDuration: null,
                psfServiceDelivery: null,
                psfRemoteType: null,
                psfServiceType: [],
                psfProblemStatuses: [],
                psfProblemComments: [],
                psfGoalStatuses: [],
                psfGoalComments: [],
                psfFurtherActions: [],
                psfTreatmentReferral: [],
                psfTreatmentInpatient: '',
                psfTreatmentResidential: '',
                psfTreatmentOutpatient: '',
                psfRecoveryReferral: [],
                psfRecoveryRcoc: '',
                psfRecoveryYouth: '',
                psfRecoveryPeer: '',
                psfRecoveryOpen: '',
                psfRecoveryFamily: '',
                psfRecoveryRegional: '',
                psfRecoverySelfHelp: null,
                psfRecoverySelfHelpOther: '',
                psfRecoveryOther: '',
                psfSignature: ''
            }
            ],
            enterPeerSessionForm: false,
            psfItemsFormRepeater: [],
            psfNextId: 2,
            
            // Options
            psfDurationOptions: [
            '15 minutes',
            '30 minutes',
            '45 minutes',
            '60 minutes',
            '75 minutes',
            '90 minutes'
            ],
            psfServiceDeliveryOptions: ['Remote'],
            psfRemoteTypeOptions: ['Video', 'Phone'],
            psfServiceTypeOptions: [
            'Facilitating access to care',
            'Recovery planning',
            'Modeling coping skills',
            'Mentoring and goal setting',
            'Non-clinical crisis support',
            'Identifying strengths',
            'Relationship building',
            'Promoting self-advocacy',
            'Education around various modes of recovery',
            'Travel training',
            'Linkage to formal recovery supports',
            'Psychoeducation'
            ],
            psfProblemStatusOptions: [
            'Solutions Achieved',
            'Solutions Partially Achieved',
            'Solutions Not Achieved',
            'On Hold (lower priority)',
            'Solutions Not Feasible as part of Peer Services'
            ],
            psfGoalStatusOptions: [
            'Worked On',
            'Did Not Work On',
            'On Hold',
            'Completed',
            'Not Met'
            ],
            psfFurtherActionsOptions: [
            'Continue Peer Services',
            'Service at this level no longer necessary',
            'Client ended services',
            'Referral to treatment services',
            'Referral to recovery services'
            ],
            psfTreatmentReferralOptions: [
            'Inpatient Rehabilitation',
            'Residential',
            'Outpatient'
            ],
            psfRecoveryReferralOptions: [
            'Recovery Community and Outreach Center',
            'Youth Clubhouse',
            'Peer Advocate',
            'Open Access Center',
            'Family Navigator',
            'Regional Addiction Resource Center',
            'Self Help',
            'Other'
            ],
            psfRecoverySelfHelpOptions: [
            'GA',
            'Smart Recovery',
            'Other'
            ],

            // Peer Services Discharge Form
            enterPeerServicesDischargeForm: false,
            psdfDate: '',
            psdfStatus: null,
            psdfDisposition: [],
            psdfReferralDisposition: [],
            psdfGamblingComparison: null,
            psdfSelfHelp: null,
            psdfContinuedServices: [],
            psdfPgTreatment: null,
            psdfSudTreatment: null,
            psdfRecoveryServices: [],
            psdfRecoveryRcoc: '',
            psdfRecoveryYouth: '',
            psdfRecoveryPeer: '',
            psdfRecoveryOpen: '',
            psdfRecoveryFamily: '',
            psdfRecoveryRegional: '',
            psdfRecoveryOther: '',
            psdfProblemGambling: null,
            psdfProblemDrug: null,
            psdfProblemAlcohol: null,
            psdfProblemFinancial: null,
            psdfProblemLegal: null,
            psdfProblemVocational: null,
            psdfProblemMedical: null,
            psdfProblemLethalitySelf: null,
            psdfProblemLethalityOther: null,
            psdfProblemMental: null,
            psdfProblemFamily: null,
            pSNotes: '',
            // psdfSessionsAttended: '',

            // Options
            psdfStatusOptions: [
            'Completed Peer Services, All Goals Met',
            'Completed Peer Services, Half or More Goals Met',
            'Completed Peer Services, Some Goals Met',
            'Unplanned Discharge'
            ],
            psdfDispositionOptions: [
            'Additional services at this level of care no longer necessary',
            'Further services at this level of care unlikely to yield additional gains',
            'Client chose to discontinue services',
            'Formal referral made/offered',
            'Lost contact, No referral possible',
            'Termination of third party funds',
            'Discharged due to non-compliance, Program Rules',
            'Discharged due to non-compliance, Violence',
            'Client arrested/incarcerated',
            'Client could no longer participate for medical/psychiatric reasons',
            'Client death',
            'Client relocated',
            'Program closed'
            ],
            psdfReferralDispositionOptions: [
            'No referral made',
            'Client not in need of additional services',
            'Client referred to SUD program',
            'Client referred to mental health program',
            'Client referred to other problem gambling program',
            'Client refused referral'
            ],
            psdfGamblingComparisonOptions: [
            'N/A',
            'No longer gambling',
            'Reduced gambling',
            'Same gambling',
            'Worse gambling'
            ],
            psdfSelfHelpOptions: [
            'Yes',
            'No',
            'N/A'
            ],
            psdfContinuedServicesOptions: [
            'Problem Gambling Self-Help Group Meetings',
            'Substance Use Self-Help Group Meetings',
            'Financial Counseling',
            'Crisis Services',
            'Problem Gambling Treatment Services',
            'Substance Use Treatment Services',
            'Recovery Support Services',
            'N/A'
            ],
            psdfTreatmentOptions: [
            'Inpatient Rehabilitation',
            'Residential',
            'Outpatient'
            ],
            psdfRecoveryServicesOptions: [
            'Recovery Community and Outreach Center',
            'Youth Clubhouse',
            'Peer Advocate',
            'Open Access Center',
            'Family Navigator',
            'Regional Addiction Resource Center',
            'Other'
            ],
            psdfProblemStatusOptions: [
            'Achieved',
            'Partial Achievement',
            'Not Achieved',
            'Not Applicable'
            ]
        }
    },
    components: {
        BForm,
        BButton,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BFormTextarea,
        BTable,
        BFormInvalidFeedback,
        BFormCheckbox,
        BAlert,
        BSpinner,
        BPopover,
        BCard,
        Cleave,
        AppCollapse,
        AppCollapseItem,
        // AppCollapseItemMargin,
        
        // select
        vSelect,

        // date
        flatPickr,
        DatePicker,

        // Form Validation
        ValidationProvider,
        ValidationObserver,
    },
    directives: {
        'b-tooltip': VBTooltip,
        Ripple,
    },
    mixins: [heightTransition],
    props: ['idClientActivity','isVSEForm'],
    computed: {
        ...mapState(['usuario']),
        psdfSessionsAttended() {
            return this.psfItemsFormRepeater.length;
        }
    },
    watch: {
        // enterAdmissionDischargeInformation(val) {
        //     console.log(val)
        // },
        client(val) {
            // console.log(val)
            if(val) {
                db.collection('clients').doc(val).get()
                .then(item => {
                    this.nameClient = item.data().firstName + ' ' + item.data().lastName
                })
            }
        },
        idClientActivity(val) {
            this.statusEditClientActivity = true
            this.dodListener = ''
            db.collection('clientsActivity').doc(val).get()
            .then(dataClient => {
                if(dataClient.exists) {
                    db.collection('usuarios').get()
                    .then(docsClinicians => {
                        // db.collection('clients').get()
                        // .then(docsClients => {
                            // get clinician
                            var objClinician = []
                            if(dataClient.data().clinician.length >= 1) {
                                dataClient.data().clinician.forEach(activityClinician => {
                                    docsClinicians.forEach(item => {
                                        if(activityClinician === item.id) {
                                            var obj = item.data()
                                            obj.agencyAndName = item.data().firstName + ' ' + item.data().lastName + ' · ' + item.data().agency  + ' (#' + item.data().codigo + ')'
                                            objClinician.push(obj)
                                        }
                                    })
                                })
                            }
                            // console.log('third')

                            // get client
                            var objClient = dataClient.data().client
                            // console.log(dataClient.data().client)
                            // if(dataClient.data().client) {
                            //     docsClients.forEach(item => {
                            //         if(dataClient.data().client === item.id) {
                            //             objClient = item.data()
                            //         }
                            //     })
                            // }

                            // get data
                            this.clinician = objClinician
                            this.dateOfContact = dataClient.data().dateOfContact
                            this.methodOfContact = dataClient.data().methodOfContact
                            this.contactStatus = dataClient.data().contactStatus
                            this.referredBy = dataClient.data().referredBy
                            this.familyMemberSelf = dataClient.data().familyMemberSelf ? dataClient.data().familyMemberSelf : ''
                            this.problemGamblingSelfHelpGroupMeetings = dataClient.data().problemGamblingSelfHelpGroupMeetings ? dataClient.data().problemGamblingSelfHelpGroupMeetings : ''
                            this.problemGamblingTreatmentServices = dataClient.data().problemGamblingTreatmentServices ? dataClient.data().problemGamblingTreatmentServices : ''
                            this.substanceUseTreatmentServices = dataClient.data().substanceUseTreatmentServices ? dataClient.data().substanceUseTreatmentServices : ''
                            this.recoverySupportServices = dataClient.data().recoverySupportServices ? dataClient.data().recoverySupportServices : ''
                            this.otherReferredBy = dataClient.data().otherReferredBy
                            this.warmTransfer = dataClient.data().warmTransfer ? dataClient.data().warmTransfer : ''
                            this.initialAppointmentDate = dataClient.data().initialAppointmentDate
                            this.time = dataClient.data().time
                            this.wasTheCallHelpful = dataClient.data().wasTheCallHelpful
                            this.wasTheCallHelpfulIfNotWhy = dataClient.datA().wasTheCallHelpfulIfNotWhy ? dataClient.data().wasTheCallHelpfulIfNotWhy : ''
                            this.informationKitAccepted = dataClient.data().informationKitAccepted
                            this.informationKitOption = dataClient.data().informationKitOption ? dataClient.data().informationKitOption : ''
                            this.regionalCFEReceivingTheCall = dataClient.data().regionalCFEReceivingTheCall
                            this.referredToPeerAdvocate = dataClient.data().referredToPeerAdvocate ? dataClient.data().referredToPeerAdvocate : ''
                            this.borough = dataClient.data().borough ? dataClient.data().borough : ''
                            this.readmission = dataClient.data().readmission
                            this.race = dataClient.data().race ? dataClient.data().race : ''
                            this.householdIncome = dataClient.data().householdIncome ? dataClient.data().householdIncome : ''
                            this.gamblingTypes = dataClient.data().gamblingTypes ? dataClient.data().gamblingTypes : ''
                            this.employmentStatus = dataClient.data().employmentStatus ? dataClient.data().employmentStatus : ''
                            this.educationLevels = dataClient.data().educationLevels ? dataClient.data().educationLevels : ''
                            this.ethnicity = dataClient.data().ethnicity ? dataClient.data().ethnicity : ''
                            this.veteran = dataClient.data().veteran ? dataClient.data().veteran : ''
                            this.zipCode = dataClient.data().zipCode ? dataClient.data().zipCode : ''
                            this.industryOfEmployment = dataClient.data().industryOfEmployment ? dataClient.data().industryOfEmployment : ''
                            this.maritalStatus = dataClient.data().maritalStatus ? dataClient.data().maritalStatus : ''
                            this.religiousPreference = dataClient.data().religiousPreference ? dataClient.data().religiousPreference : ''
                            this.connectedToPeerAdvocate = dataClient.data().connectedToPeerAdvocate ? dataClient.data().connectedToPeerAdvocate : ''
                            this.connectedToVSE = dataClient.data().connectedToVSE ? dataClient.data().connectedToVSE : ''
                            this.connectedToPeerEducationGroup = dataClient.data().connectedToPeerEducationGroup ? dataClient.data().connectedToPeerEducationGroup : ''
                            this.connectedToFamilyEducationGroup = dataClient.data().connectedToFamilyEducationGroup ? dataClient.data().connectedToFamilyEducationGroup : ''
                            this.connectedToAsianServicesProgram = dataClient.data().connectedToAsianServicesProgram ? dataClient.data().connectedToAsianServicesProgram : ''
                            this.connectedToGamFin = dataClient.data().connectedToGamFin ? dataClient.data().connectedToGamFin : ''
                            this.referralrecoverySupportServices = dataClient.data().referralrecoverySupportServices ? dataClient.data().referralrecoverySupportServices : ''
                            this.admissionrecoverySupportServices = dataClient.data().admissionrecoverySupportServices ? dataClient.data().admissionrecoverySupportServices : ''
                            this.admissionproblemGamblingTreatmentServices = dataClient.data().admissionproblemGamblingTreatmentServices ? dataClient.data().admissionproblemGamblingTreatmentServices : ''
                            this.admissionsubstanceUseTreatmentServices = dataClient.data().admissionsubstanceUseTreatmentServices ? dataClient.data().admissionsubstanceUseTreatmentServices : ''
                            // enter adminission/discharge information
                            this.enterAdmissionDischargeInformation = dataClient.data().enterAdmissionDischargeInformation
                            this.enterAdmissionInformation = dataClient.data().enterAdmissionInformation === undefined ? dataClient.data().enterAdmissionDischargeInformation : dataClient.data().enterAdmissionInformation ? dataClient.data().enterAdmissionInformation : false
                            this.enterDischargeInformation = dataClient.data().enterDischargeInformation === undefined ? dataClient.data().enterAdmissionDischargeInformation : dataClient.data().enterDischargeInformation ? dataClient.data().enterDischargeInformation : false
                            this.enterSurveyInformation = dataClient.data().enterSurveyInformation ? dataClient.data().enterSurveyInformation : false
                            // admission form
                            this.dateOfAdmission = dataClient.data().dateOfAdmission
                            this.newOrReturningClient = dataClient.data().newOrReturningClient
                            this.clientStatusAdmission = dataClient.data().clientStatusAdmission ? dataClient.data().clientStatusAdmission : ''
                            this.presentingProblemsAtAdmission = dataClient.data().presentingProblemsAtAdmission
                            this.diagnosticCriteriaMetAtAdmission = dataClient.data().diagnosticCriteriaMetAtAdmission
                            this.otherProblemsAdmission = dataClient.data().otherProblemsAdmission
                            this.clientInvolvedWithLegalSystem = dataClient.data().clientInvolvedWithLegalSystem
                            this.clientReleaseSigned = dataClient.data().clientReleaseSigned
                            this.referredByAdmission = dataClient.data().referredByAdmission ? dataClient.data().referredByAdmission : ''
                            this.familyMemberSelfAdmission = dataClient.data().familyMemberSelfAdmission ? dataClient.data().familyMemberSelfAdmission : ''
                            this.problemGamblingTreatmentServicesAdmission = dataClient.data().problemGamblingTreatmentServicesAdmission ? dataClient.data().problemGamblingTreatmentServicesAdmission : ''
                            this.problemGamblingSelfHelpGroupMeetingsAdmission = dataClient.data().problemGamblingSelfHelpGroupMeetingsAdmission ? dataClient.data().problemGamblingSelfHelpGroupMeetingsAdmission : ''
                            this.substanceUseTreatmentServicesAdmission = dataClient.data().substanceUseTreatmentServicesAdmission ? dataClient.data().substanceUseTreatmentServicesAdmission : ''
                            this.recoverySupportServicesAdmission = dataClient.data().recoverySupportServicesAdmission ? dataClient.data().recoverySupportServicesAdmission : ''
                            this.otherReferredByAdmission = dataClient.data().otherReferredByAdmission ? dataClient.data().otherReferredByAdmission : ''
                            this.warmTransferAdmission = dataClient.data().warmTransferAdmission ? dataClient.data().warmTransferAdmission : ''
                            this.primaryICD10 = dataClient.data().primaryICD10 ? dataClient.data().primaryICD10 : ''
                            this.Z72GamblingAndBetting = dataClient.data().Z72GamblingAndBetting ? dataClient.data().Z72GamblingAndBetting : ''
                            this.numberofAssessmentVisits = dataClient.data().numberofAssessmentVisits ? dataClient.data().numberofAssessmentVisits : ''
                            this.age = dataClient.data().age ? dataClient.data().age : ''
                            this.sexualOrientation = dataClient.data().sexualOrientation ? dataClient.data().sexualOrientation : ''
                            this.genderIdentity = dataClient.data().genderIdentity ? dataClient.data().genderIdentity : ''
                            this.transgender = dataClient.data().transgender ? dataClient.data().transgender : ''
                            this.asianOrigin = dataClient.data().asianOrigin ? dataClient.data().asianOrigin : ''
                            this.pacificIslanderOrigin = dataClient.data().pacificIslanderOrigin ? dataClient.data().pacificIslanderOrigin : ''
                            this.developmentalDisability = dataClient.data().developmentalDisability ? dataClient.data().developmentalDisability : ''
                            this.coexistingPsychiatricDisorder = dataClient.data().coexistingPsychiatricDisorder ? dataClient.data().coexistingPsychiatricDisorder : ''
                            this.treatedForMentalIllness = dataClient.data().treatedForMentalIllness ? dataClient.data().treatedForMentalIllness : ''
                            this.hospitalizedForMentalIllness = dataClient.data().hospitalizedForMentalIllness ? dataClient.data().hospitalizedForMentalIllness : ''
                            this.hospitalized30OrMoreDaysForMentalIllness = dataClient.data().hospitalized30OrMoreDaysForMentalIllness ? dataClient.data().hospitalized30OrMoreDaysForMentalIllness : ''
                            this.smokedTobaccoInThePastWeek = dataClient.data().smokedTobaccoInThePastWeek ? dataClient.data().smokedTobaccoInThePastWeek : ''
                            this.usedSmokelessTobaccoInThePastWeek = dataClient.data().usedSmokelessTobaccoInThePastWeek ? dataClient.data().usedSmokelessTobaccoInThePastWeek : ''
                            this.substancesUsed = dataClient.data().substancesUsed ? dataClient.data().substancesUsed : ''
                            this.substanceUseRouteOfAdministration = dataClient.data().substanceUseRouteOfAdministration ? dataClient.data().substanceUseRouteOfAdministration : ''
                            this.frequencyOfSubstanceUse = dataClient.data().frequencyOfSubstanceUse ? dataClient.data().frequencyOfSubstanceUse : ''
                            this.ageOfFirstSubstanceUse = dataClient.data().ageOfFirstSubstanceUse ? dataClient.data().ageOfFirstSubstanceUse : ''
                            this.inThePastFewMonthsDrinks = dataClient.data().inThePastFewMonthsDrinks ? dataClient.data().inThePastFewMonthsDrinks : ''
                            this.referralOptions = dataClient.data().referralOptions ? dataClient.data().referralOptions : ''
                            this.OASASProgram = dataClient.data().OASASProgram ? dataClient.data().OASASProgram : ''
                            this.OASASProgramOptInpatient = dataClient.data().OASASProgramOptInpatient ? dataClient.data().OASASProgramOptInpatient : ''
                            this.OASASProgramOptResidential = dataClient.data().OASASProgramOptResidential ? dataClient.data().OASASProgramOptResidential : ''
                            this.OASASProgramOptOutpatient = dataClient.data().OASASProgramOptOutpatient ? dataClient.data().OASASProgramOptOutpatient : ''
                            this.privatePractitioner = dataClient.data().privatePractitioner ? dataClient.data().privatePractitioner : ''
                            this.recoverySupportServices = dataClient.data().recoverySupportServices ? dataClient.data().recoverySupportServices : ''
                            this.recoveryCommunityOutreachCenter = dataClient.data().recoveryCommunityOutreachCenter ? dataClient.data().recoveryCommunityOutreachCenter : ''
                            this.youthClubhouse = dataClient.data().youthClubhouse ? dataClient.data().youthClubhouse : ''
                            this.peerAdvocate = dataClient.data().peerAdvocate ? dataClient.data().peerAdvocate : ''
                            this.openAccessCenter = dataClient.data().openAccessCenter ? dataClient.data().openAccessCenter : ''
                            this.familyNavigator = dataClient.data().familyNavigator ? dataClient.data().familyNavigator : ''
                            this.regionalAddictionResourceCenter = dataClient.data().regionalAddictionResourceCenter ? dataClient.data().regionalAddictionResourceCenter : ''
                            this.locadtrg = dataClient.data().locadtrg ? dataClient.data().locadtrg : ''
                            this.LOCADTRAssessmentID = dataClient.data().LOCADTRAssessmentID ? dataClient.data().LOCADTRAssessmentID : ''
                            this.dateOfBirthAdmission = dataClient.data().dateOfBirthAdmission ? dataClient.data().dateOfBirthAdmission : ''
                            this.sexAtBirth = dataClient.data().sexAtBirth ? dataClient.data().sexAtBirth : ''
                            this.last4SSN = dataClient.data().last4SSN ? dataClient.data().last4SSN : ''
                            this.firstTwoLettersLastName = dataClient.data().firstTwoLettersLastName ? dataClient.data().firstTwoLettersLastName : ''
                            this.frequencyofGambling = dataClient.data().frequencyofGambling ? dataClient.data().frequencyofGambling : ''
                            this.ageFirstGambled = dataClient.data().ageFirstGambled ? dataClient.data().ageFirstGambled : ''
                            this.past30DaysAmountOfMoney = dataClient.data().past30DaysAmountOfMoney ? dataClient.data().past30DaysAmountOfMoney : ''
                            this.past30DaysHowMuchTime = dataClient.data().past30DaysHowMuchTime ? dataClient.data().past30DaysHowMuchTime : ''
                            this.past30DaysHowManyDays = dataClient.data().past30DaysHowManyDays ? dataClient.data().past30DaysHowManyDays : ''
                            this.gamblinglocationspast12months = dataClient.data().gamblinglocationspast12months ? dataClient.data().gamblinglocationspast12months : ''
                            this.hasClientAttendedReceivedServices = dataClient.data().hasClientAttendedReceivedServices ? dataClient.data().hasClientAttendedReceivedServices : ''
                            this.legalSystem = dataClient.data().legalSystem ? dataClient.data().legalSystem : ''
                            this.notesAdmission = dataClient.data().notesAdmission
                            // discharge form
                            this.dateOfDischarge = dataClient.data().dateOfDischarge
                            this.dischargeStatus = dataClient.data().dischargeStatus
                            this.plannedDischargeReasons = dataClient.data().plannedDischargeReasons
                            this.unplannedDischargeReason = dataClient.data().unplannedDischargeReason
                            this.numberOfSessionsAttended = dataClient.data().numberOfSessionsAttended
                            this.dischargeDisposition = dataClient.data().dischargeDisposition ? dataClient.data().dischargeDisposition : ''
                            this.referralDisposition = dataClient.data().referralDisposition ? dataClient.data().referralDisposition : ''
                            this.diagnosticCriteriaMetAtAdmissionWasReduced = dataClient.data().diagnosticCriteriaMetAtAdmissionWasReduced
                            this.diagnosticCriteriaMetAtDischarge = dataClient.data().diagnosticCriteriaMetAtDischarge ? dataClient.data().diagnosticCriteriaMetAtDischarge : ''
                            this.goalsMet = dataClient.data().goalsMet
                            this.currentGamblingComparedToAdmission = dataClient.data().currentGamblingComparedToAdmission
                            this.clientInvolvedWithSelfHelpAtDischarge = dataClient.data().clientInvolvedWithSelfHelpAtDischarge
                            this.clientReferredForContinuedServices = dataClient.data().clientReferredForContinuedServices
                            this.ifSoWhatServicesWereRecommended = dataClient.data().ifSoWhatServicesWereRecommended
                            this.relatedProblemsGambling = dataClient.data().relatedProblemsGambling ? dataClient.data().relatedProblemsGambling : ''
                            this.relatedProblemsDrugUse = dataClient.data().relatedProblemsDrugUse ? dataClient.data().relatedProblemsDrugUse : ''
                            this.relatedProblemsAlcoholUse = dataClient.data().relatedProblemsAlcoholUse ? dataClient.data().relatedProblemsAlcoholUse : ''
                            this.relatedProblemsFinancial = dataClient.data().relatedProblemsFinancial ? dataClient.data().relatedProblemsFinancial : ''
                            this.relatedProblemsLegal = dataClient.data().relatedProblemsLegal ? dataClient.data().relatedProblemsLegal : ''
                            this.relatedProblemsVocationalEducational = dataClient.data().relatedProblemsVocationalEducational ? dataClient.data().relatedProblemsVocationalEducational : ''
                            this.relatedProblemsMedicalHealth = dataClient.data().relatedProblemsMedicalHealth ? dataClient.data().relatedProblemsMedicalHealth : ''
                            this.relatedProblemsLethalitySelf = dataClient.data().relatedProblemsLethalitySelf ? dataClient.data().relatedProblemsLethalitySelf : ''
                            this.relatedProblemsLethalityOther = dataClient.data().relatedProblemsLethalityOther ? dataClient.data().relatedProblemsLethalityOther : ''
                            this.relatedProblemsMentalHealth = dataClient.data().relatedProblemsMentalHealth ? dataClient.data().relatedProblemsMentalHealth : ''
                            this.relatedProblemsFamily = dataClient.data().relatedProblemsFamily ? dataClient.data().relatedProblemsFamily : ''
                            this.notesDischarge = dataClient.data().notesDischarge
                            // survey
                            this.isClientInsured = dataClient.data().isClientInsured ? dataClient.data().isClientInsured : ''
                            this.isClientMatchedToaClinicianWhoAcceptsTheirInsurance = dataClient.data().isClientMatchedToaClinicianWhoAcceptsTheirInsurance ? dataClient.data().isClientMatchedToaClinicianWhoAcceptsTheirInsurance : ''
                            this.isTheClinicianBillingTheClientsInsurance = dataClient.data().isTheClinicianBillingTheClientsInsurance ? dataClient.data().isTheClinicianBillingTheClientsInsurance : ''
                            this.whyInsuranceWasNotBilled = dataClient.data().whyInsuranceWasNotBilled ? dataClient.data().whyInsuranceWasNotBilled : ''
                            this.whyInsuranceWasNotBilledOther = dataClient.data().whyInsuranceWasNotBilledOther ? dataClient.data().whyInsuranceWasNotBilledOther : ''
                            this.reasonWhyClientWasReferredToClinician = dataClient.data().reasonWhyClientWasReferredToClinician ? dataClient.data().reasonWhyClientWasReferredToClinician : ''
                            this.reasonWhyClientWasReferredToClinicianOther = dataClient.data().reasonWhyClientWasReferredToClinicianOther ? dataClient.data().reasonWhyClientWasReferredToClinicianOther : ''
                            this.itemsFormRepeater = dataClient.data().paymentInsuranceUtilizationForm && dataClient.data().paymentInsuranceUtilizationForm.length ? dataClient.data().paymentInsuranceUtilizationForm : []

                            this.enterPeerServicesForm = dataClient.data().enterPeerServicesForm ? dataClient.data().enterPeerServicesForm : false
                            this.contactDate = dataClient.data().contactDate ? dataClient.data().contactDate : ''
                            this.peerCompleting = dataClient.data().peerCompleting ? dataClient.data().peerCompleting : null
                            this.peerAssigned = dataClient.data().peerAssigned ? dataClient.data().peerAssigned : null
                            this.peerCompletingSaved = dataClient.data().peerCompleting ? dataClient.data().peerCompleting : null
                            this.peerAssignedSaved = dataClient.data().peerAssigned ? dataClient.data().peerAssigned : null
                            this.clientType = dataClient.data().clientType ? dataClient.data().clientType : null
                            this.pifClientStatus = dataClient.data().pifClientStatus ? dataClient.data().pifClientStatus : null
                            this.referralSource = dataClient.data().referralSource ? dataClient.data().referralSource : null
                            this.warmTransferPeer = dataClient.data().warmTransferPeer ? dataClient.data().warmTransferPeer : null
                            this.familyReferralType = dataClient.data().familyReferralType ? dataClient.data().familyReferralType : null
                            this.selfHelpGroupType = dataClient.data().selfHelpGroupType ? dataClient.data().selfHelpGroupType : null
                            this.pgTreatmentType = dataClient.data().pgTreatmentType ? dataClient.data().pgTreatmentType : null
                            this.sudTreatmentType = dataClient.data().sudTreatmentType ? dataClient.data().sudTreatmentType : null
                            this.recoveryServiceType = dataClient.data().recoveryServiceType ? dataClient.data().recoveryServiceType : null
                            this.recoveryServiceDetails = dataClient.data().recoveryServiceDetails ? dataClient.data().recoveryServiceDetails : ''
                            this.serviceStatus = dataClient.data().serviceStatus ? dataClient.data().serviceStatus : []
                            this.previouslyAttendedTreatment = dataClient.data().previouslyAttendedTreatment ? dataClient.data().previouslyAttendedTreatment : []
                            this.prevPgInpatient = dataClient.data().prevPgInpatient ? dataClient.data().prevPgInpatient : ''
                            this.prevPgOutpatient = dataClient.data().prevPgOutpatient ? dataClient.data().prevPgOutpatient : ''
                            this.prevPgResidential = dataClient.data().prevPgResidential ? dataClient.data().prevPgResidential : ''
                            this.prevSudInpatient = dataClient.data().prevSudInpatient ? dataClient.data().prevSudInpatient : ''
                            this.prevSudOutpatient = dataClient.data().prevSudOutpatient ? dataClient.data().prevSudOutpatient : ''
                            this.prevSudResidential = dataClient.data().prevSudResidential ? dataClient.data().prevSudResidential : ''
                            this.currentlyAttendingTreatment = dataClient.data().currentlyAttendingTreatment ? dataClient.data().currentlyAttendingTreatment : []
                            this.currPgInpatient = dataClient.data().currPgInpatient ? dataClient.data().currPgInpatient : ''
                            this.currPgOutpatient = dataClient.data().currPgOutpatient ? dataClient.data().currPgOutpatient : ''
                            this.currPgResidential = dataClient.data().currPgResidential ? dataClient.data().currPgResidential : ''
                            this.currSudInpatient = dataClient.data().currSudInpatient ? dataClient.data().currSudInpatient : ''
                            this.currSudOutpatient = dataClient.data().currSudOutpatient ? dataClient.data().currSudOutpatient : ''
                            this.currSudResidential = dataClient.data().currSudResidential ? dataClient.data().currSudResidential : ''
                            this.previouslyUtilizedRecoveryServices = dataClient.data().previouslyUtilizedRecoveryServices ? dataClient.data().previouslyUtilizedRecoveryServices : []
                            this.prevRecoveryRcocName = dataClient.data().prevRecoveryRcocName ? dataClient.data().prevRecoveryRcocName : ''
                            this.currRecoveryTxtBoxRcocName = dataClient.data().currRecoveryTxtBoxRcocName ? dataClient.data().currRecoveryTxtBoxRcocName : ''
                            this.currentlyUtilizingRecoveryServices = dataClient.data().currentlyUtilizingRecoveryServices ? dataClient.data().currentlyUtilizingRecoveryServices : []
                            this.currRecoveryRcocName = dataClient.data().currRecoveryRcocName ? dataClient.data().currRecoveryRcocName : ''
                            this.previouslyUtilizedFinancialServices = dataClient.data().previouslyUtilizedFinancialServices ? dataClient.data().previouslyUtilizedFinancialServices : null
                            this.prevFinancialOther = dataClient.data().prevFinancialOther ? dataClient.data().prevFinancialOther : ''
                            this.currentlyUtilizingFinancialServices = dataClient.data().currentlyUtilizingFinancialServices ? dataClient.data().currentlyUtilizingFinancialServices : null
                            this.currFinancialOther = dataClient.data().currFinancialOther ? dataClient.data().currFinancialOther : ''
                            this.presentingProblems = dataClient.data().presentingProblems ? dataClient.data().presentingProblems : []
                            this.otherProblems = dataClient.data().otherProblems ? dataClient.data().otherProblems : ''
                            this.legalInvolvement = dataClient.data().legalInvolvement ? dataClient.data().legalInvolvement : null
                            this.legalSystemType = dataClient.data().legalSystemType ? dataClient.data().legalSystemType : null
                            this.releaseSigned = dataClient.data().releaseSigned ? dataClient.data().releaseSigned : null
                            this.notes = dataClient.data().notes ? dataClient.data().notes : ''
                            this.race = dataClient.data().race ? dataClient.data().race : null
                            this.hispanicOrigin = dataClient.data().hispanicOrigin ? dataClient.data().hispanicOrigin : null
                            this.asianOrigin = dataClient.data().asianOrigin ? dataClient.data().asianOrigin : null
                            this.pacificIslanderOrigin = dataClient.data().pacificIslanderOrigin ? dataClient.data().pacificIslanderOrigin : null
                            this.householdIncome = dataClient.data().householdIncome ? dataClient.data().householdIncome : null
                            this.gamblingTypes = dataClient.data().gamblingTypes ? dataClient.data().gamblingTypes : []
                            this.employmentStatus = dataClient.data().employmentStatus ? dataClient.data().employmentStatus : null
                            this.highestGrade = dataClient.data().highestGrade ? dataClient.data().highestGrade : null
                            this.veteran = dataClient.data().veteran ? dataClient.data().veteran : null
                            this.zipCode = dataClient.data().zipCode ? dataClient.data().zipCode : ''
                            this.industry = dataClient.data().industry ? dataClient.data().industry : null
                            this.maritalStatus = dataClient.data().maritalStatus ? dataClient.data().maritalStatus : null
                            this.religiousPreference = dataClient.data().religiousPreference ? dataClient.data().religiousPreference : null
                            this.age = dataClient.data().age ? dataClient.data().age : null
                            this.sexualOrientation = dataClient.data().sexualOrientation ? dataClient.data().sexualOrientation : null
                            this.genderIdentity = dataClient.data().genderIdentity ? dataClient.data().genderIdentity : null
                            this.transgender = dataClient.data().transgender ? dataClient.data().transgender : null
                            this.gamblingFrequency = dataClient.data().gamblingFrequency ? dataClient.data().gamblingFrequency : null
                            this.ageFirstGambled = dataClient.data().ageFirstGambled ? dataClient.data().ageFirstGambled : ''
                            this.typicalAmount = dataClient.data().typicalAmount ? dataClient.data().typicalAmount : ''
                            this.typicalTime = dataClient.data().typicalTime ? dataClient.data().typicalTime : ''
                            this.daysGambled = dataClient.data().daysGambled ? dataClient.data().daysGambled : ''
                            this.gamblingLocations = dataClient.data().gamblingLocations ? dataClient.data().gamblingLocations : []
                            this.gamblingLocationOther = dataClient.data().gamblingLocationOther ? dataClient.data().gamblingLocationOther : ''

                            // goals form
                            this.enterPeerGoalForm = dataClient.data().enterPeerGoalForm ? dataClient.data().enterPeerGoalForm : false
                            this.pgfDate = dataClient.data().pgfDate ? dataClient.data().pgfDate : ''
                            this.pgfGoals = dataClient.data().pgfGoals ? dataClient.data().pgfGoals : ['']

                            // Peer Session Form
                            this.enterPeerSessionForm = dataClient.data().enterPeerSessionForm ? dataClient.data().enterPeerSessionForm : false
                            this.psfItemsFormRepeater = dataClient.data().psfItemsFormRepeater ? dataClient.data().psfItemsFormRepeater : []
                            this.psfNextId = dataClient.data().psfNextId ? dataClient.data().psfNextId : 2

                            // Peer Services Discharge Form
                            this.enterPeerServicesDischargeForm = dataClient.data().enterPeerServicesDischargeForm ? dataClient.data().enterPeerServicesDischargeForm : false
                            this.psdfDate = dataClient.data().psdfDate ? dataClient.data().psdfDate : ''
                            this.psdfStatus = dataClient.data().psdfStatus ? dataClient.data().psdfStatus : null
                            this.psdfDisposition = dataClient.data().psdfDisposition ? dataClient.data().psdfDisposition : []
                            this.psdfReferralDisposition = dataClient.data().psdfReferralDisposition ? dataClient.data().psdfReferralDisposition : []
                            this.psdfGamblingComparison = dataClient.data().psdfGamblingComparison ? dataClient.data().psdfGamblingComparison : null
                            this.psdfSelfHelp = dataClient.data().psdfSelfHelp ? dataClient.data().psdfSelfHelp : null
                            this.psdfContinuedServices = dataClient.data().psdfContinuedServices ? dataClient.data().psdfContinuedServices : []
                            this.psdfPgTreatment = dataClient.data().psdfPgTreatment ? dataClient.data().psdfPgTreatment : null
                            this.psdfSudTreatment = dataClient.data().psdfSudTreatment ? dataClient.data().psdfSudTreatment : null
                            this.psdfRecoveryServices = dataClient.data().psdfRecoveryServices ? dataClient.data().psdfRecoveryServices : []
                            this.psdfRecoveryRcoc = dataClient.data().psdfRecoveryRcoc ? dataClient.data().psdfRecoveryRcoc : ''
                            this.psdfRecoveryYouth = dataClient.data().psdfRecoveryYouth ? dataClient.data().psdfRecoveryYouth : ''
                            this.psdfRecoveryPeer = dataClient.data().psdfRecoveryPeer ? dataClient.data().psdfRecoveryPeer : ''
                            this.psdfRecoveryOpen = dataClient.data().psdfRecoveryOpen ? dataClient.data().psdfRecoveryOpen : ''
                            this.psdfRecoveryFamily = dataClient.data().psdfRecoveryFamily ? dataClient.data().psdfRecoveryFamily : ''
                            this.psdfRecoveryRegional = dataClient.data().psdfRecoveryRegional ? dataClient.data().psdfRecoveryRegional : ''
                            this.psdfRecoveryOther = dataClient.data().psdfRecoveryOther ? dataClient.data().psdfRecoveryOther : ''
                            this.psdfProblemGambling = dataClient.data().psdfProblemGambling ? dataClient.data().psdfProblemGambling : null
                            this.psdfProblemDrug = dataClient.data().psdfProblemDrug ? dataClient.data().psdfProblemDrug : null
                            this.psdfProblemAlcohol = dataClient.data().psdfProblemAlcohol ? dataClient.data().psdfProblemAlcohol : null
                            this.psdfProblemFinancial = dataClient.data().psdfProblemFinancial ? dataClient.data().psdfProblemFinancial : null
                            this.psdfProblemLegal = dataClient.data().psdfProblemLegal ? dataClient.data().psdfProblemLegal : null
                            this.psdfProblemVocational = dataClient.data().psdfProblemVocational ? dataClient.data().psdfProblemVocational : null
                            this.psdfProblemMedical = dataClient.data().psdfProblemMedical ? dataClient.data().psdfProblemMedical : null
                            this.psdfProblemLethalitySelf = dataClient.data().psdfProblemLethalitySelf ? dataClient.data().psdfProblemLethalitySelf : null
                            this.psdfProblemLethalityOther = dataClient.data().psdfProblemLethalityOther ? dataClient.data().psdfProblemLethalityOther : null
                            this.psdfProblemMental = dataClient.data().psdfProblemMental ? dataClient.data().psdfProblemMental : null
                            this.psdfProblemFamily = dataClient.data().psdfProblemFamily ? dataClient.data().psdfProblemFamily : null
                            this.pSNotes = dataClient.data().pSNotes ? dataClient.data().pSNotes : ''
                            // psdfSessionsAttended: '',

                            // content right
                            this.specialIssuesOrOtherComments = dataClient.data().specialIssuesOrOtherComments
                            this.callNotes = dataClient.data().callNotes
                            this.activityStatus = dataClient.data().activityStatus
                            this.engagedStatus = dataClient.data().engagedStatus ? dataClient.data().engagedStatus : ''
                            this.closeNotes = dataClient.data().closeNotes
                            this.client = objClient
                        // })
                            this.loadDataPage = true
                    })
                } else {
                    db.collection('clientsActivityVSE').doc(val).get()
                    .then(dataClient => {
                        this.notesVSE = dataClient.data().notesVSE ? dataClient.data().notesVSE : ''
                        this.finalStatusVSE = dataClient.data().finalStatusVSE ? dataClient.data().finalStatusVSE : ''
                        this.staffMemberCompletingFormVSE = dataClient.data().staffMemberCompletingFormVSE ? dataClient.data().staffMemberCompletingFormVSE : ''
                        this.contactDateVSE = dataClient.data().contactDateVSE ? dataClient.data().contactDateVSE : ''
                        this.genderVSE = dataClient.data().genderVSE ? dataClient.data().genderVSE : ''
                        this.referredByVSE = dataClient.data().referredByVSE ? dataClient.data().referredByVSE : ''
                        this.familyMemberSelfVSE = dataClient.data().familyMemberSelfVSE ? dataClient.data().familyMemberSelfVSE : ''
                        this.problemGamblingTreatmentServicesVSE = dataClient.data().problemGamblingTreatmentServicesVSE ? dataClient.data().problemGamblingTreatmentServicesVSE : ''
                        this.problemGamblingSelfHelpGroupMeetingsVSE = dataClient.data().problemGamblingSelfHelpGroupMeetingsVSE ? dataClient.data().problemGamblingSelfHelpGroupMeetingsVSE : ''
                        this.substanceUseTreatmentServicesVSE = dataClient.data().substanceUseTreatmentServicesVSE ? dataClient.data().substanceUseTreatmentServicesVSE : ''
                        this.recoverySupportServicesVSE = dataClient.data().recoverySupportServicesVSE ? dataClient.data().recoverySupportServicesVSE : ''
                        this.otherReferredByVSE = dataClient.data().otherReferredByVSE ? dataClient.data().otherReferredByVSE : ''
                        this.warmTransferVSE = dataClient.data().warmTransferVSE ? dataClient.data().warmTransferVSE : ''
                        this.pgrcPmSE = dataClient.data().pgrcPmSE ? dataClient.data().pgrcPmSE : ''
                        this.PGRCPrivatePractitionerVSE = dataClient.data().PGRCPrivatePractitionerVSE ? dataClient.data().PGRCPrivatePractitionerVSE : ''
                        this.OASASProgramVSE = dataClient.data().OASASProgramVSE ? dataClient.data().OASASProgramVSE : ''
                        this.GamingFacilityVSE = dataClient.data().GamingFacilityVSE ? dataClient.data().GamingFacilityVSE : ''
                        this.connectedToPGRCVSE = dataClient.data().connectedToPGRCVSE ? dataClient.data().connectedToPGRCVSE : ''
                        this.connectedToPeerAdvocateVSE = dataClient.data().connectedToPeerAdvocateVSE ? dataClient.data().connectedToPeerAdvocateVSE : ''
                        this.connectedtoNYSGamingCommissionVSE = dataClient.data().connectedtoNYSGamingCommissionVSE ? dataClient.data().connectedtoNYSGamingCommissionVSE : ''
                        this.typesofGamblingEngagedInVSE = dataClient.data().typesofGamblingEngagedInVSE ? dataClient.data().typesofGamblingEngagedInVSE : ''
                        this.interventionStatusVSE = dataClient.data().interventionStatusVSE ? dataClient.data().interventionStatusVSE : ''
                        this.pendingVSE = dataClient.data().pendingVSE ? dataClient.data().pendingVSE : ''
                        this.appointmentDateVSE = dataClient.data().appointmentDateVSE ? dataClient.data().appointmentDateVSE : ''
                        this.followUpDateVSE = dataClient.data().followUpDateVSE ? dataClient.data().followUpDateVSE : ''
                        this.VSETimeframe = dataClient.data().VSETimeframe ? dataClient.data().VSETimeframe : ''

                        this.loadDataPage = true
                    })
                }
            })
        },
        activityStatus(val) {
            if(val.includes('Closed') || val === 'Engaged') {
                this.removeRecordAdmissionData =  false
                this.removeRecordDischargeData = false
                // this.activityStatus = 'Engaged'
            }

            if(val !== 'Engaged') {
                this.engagedStatus = ''
            }

            if(val !== 'Closed - Referred to OASAS Program') {
                this.referredToPeerAdvocate = ''
            }

            // increment changes of activity status, no show alert when load component
            this.counterChangesActivityStatus += 1
            
            if(this.counterChangesActivityStatus >= 2) {
                if(val === 'Closed - Referred to OASAS Program' || val === 'External Referral' || val === 'Closed - Received information') {
                    // console.log('first')
                    // alert activity status
                    if(this.activityStatusAtomic !== 'Closed - Referred to OASAS Program' && this.activityStatusAtomic !== 'External Referral' && this.activityStatusAtomic !== 'Closed - Received information') {
                        this.$swal({
                            title: 'Are you sure?',
                            text: "Are you sure you want to change the status? The initial appointment date/time will be disabled.",
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Yes',
                            cancelButtonText: 'No',
                            customClass: {
                                confirmButton: 'btn btn-primary',
                                cancelButton: 'btn btn-outline-danger ml-1',
                            },
                            buttonsStyling: false,
                        }).then(result => {
                            if (result.value) {
                                this.activityStatusAtomic = val
                                this.clinician = []
                                this.initialAppointmentDate = null
                                this.time = ''
                                // this.$swal({
                                //     icon: 'success',
                                //     title: 'Activity Status changed',
                                //     text: 'The initial appointment date/time will be disabled',
                                //     customClass: {
                                //         confirmButton: 'btn btn-success',
                                //     },
                                // })
                            } else {
                                this.activityStatus = this.activityStatusAtomic
                            }
                        })
                    }
                }
            } else {
                this.activityStatusAtomic = val
            }
        },
        isClientInsured(val) {
            if(val === 'No') {
                this.logicisClientInsured = true
                this.isClientMatchedToaClinicianWhoAcceptsTheirInsurance = ''
                this.isTheClinicianBillingTheClientsInsurance = ''
                this.whyInsuranceWasNotBilled = ''
                this.whyInsuranceWasNotBilledOther = ''
                this.reasonWhyClientWasReferredToClinician = ''
                this.reasonWhyClientWasReferredToClinicianOther = ''
            } else {
                // answer: isClientMatchedToaClinicianWhoAcceptsTheirInsurance
                this.logicisClientInsured = false
            }
        },
        isClientMatchedToaClinicianWhoAcceptsTheirInsurance(val) {
            if(val === 'No') {
                // answer: reasonWhyClientWasReferredToClinician -> reasonWhyClientWasReferredToClinicianOther
                this.logicisClientMatchedToaClinicianWhoAcceptsTheirInsurance = true
                this.isTheClinicianBillingTheClientsInsurance = ''
                this.whyInsuranceWasNotBilled = ''
                this.whyInsuranceWasNotBilledOther = ''
                this.reasonWhyClientWasReferredToClinician = ''
                this.reasonWhyClientWasReferredToClinicianOther = ''
            } else {
                // answer: isTheClinicianBillingTheClientsInsurance
                this.logicisClientMatchedToaClinicianWhoAcceptsTheirInsurance = false
            }
        },
        isTheClinicianBillingTheClientsInsurance(val) {
            if(val === 'Yes') {
                this.logicisTheClinicianBillingTheClientsInsurance = false
                this.logicisTheClinicianBillingTheClientsInsuranceOptionYes = true
                this.whyInsuranceWasNotBilled = ''
                this.whyInsuranceWasNotBilledOther = ''
                this.reasonWhyClientWasReferredToClinician = ''
                this.reasonWhyClientWasReferredToClinicianOther = ''
            } else if(val === 'No') {
                // answer: whyInsuranceWasNotBilled -> whyInsuranceWasNotBilledOther
                this.logicisTheClinicianBillingTheClientsInsurance = true
                this.logicisTheClinicianBillingTheClientsInsuranceOptionYes = false
                this.reasonWhyClientWasReferredToClinician = ''
                this.reasonWhyClientWasReferredToClinicianOther = ''
            } else {
                this.logicisTheClinicianBillingTheClientsInsurance = false
                this.logicisTheClinicianBillingTheClientsInsuranceOptionYes = false
            }
        },
        // enterAdmissionDischargeInformation(val) {
        //     console.log(val)
        // },
        serviceStatus(newVal, oldVal) {
            // Limpiar Previously Attended Treatment
            if (!newVal.includes('Previously Attended Treatment')) {
            this.previouslyAttendedTreatment = [];
            this.prevPgInpatient = '';
            this.prevPgOutpatient = '';
            this.prevPgResidential = '';
            this.prevSudInpatient = '';
            this.prevSudOutpatient = '';
            this.prevSudResidential = '';
            }
            
            // Limpiar Currently Attending Treatment
            if (!newVal.includes('Currently Attending Treatment')) {
            this.currentlyAttendingTreatment = [];
            this.currPgInpatient = '';
            this.currPgOutpatient = '';
            this.currPgResidential = '';
            this.currSudInpatient = '';
            this.currSudOutpatient = '';
            this.currSudResidential = '';
            }
            
            // Limpiar Previously Utilized Recovery Services
            if (!newVal.includes('Previously Utilized Recovery Services')) {
            this.previouslyUtilizedRecoveryServices = [];
            this.prevRecoveryRcocName = '';
            }
            
            // Limpiar Currently Utilizing Recovery Services
            if (!newVal.includes('Currently Utilizing Recovery Services')) {
            this.currentlyUtilizingRecoveryServices = [];
            this.currRecoveryRcocName = '';
            }
            
            // Limpiar Previously Utilized Financial Services
            if (!newVal.includes('Previously Utilized Financial/Credit Counseling Services')) {
            this.previouslyUtilizedFinancialServices = [];
            this.prevFinancialOther = '';
            }
            
            // Limpiar Currently Utilizing Financial Services
            if (!newVal.includes('Currently Utilizing Financial/Credit Counseling Services')) {
            this.currentlyUtilizingFinancialServices = [];
            this.currFinancialOther = '';
            }
        },
        
        previouslyAttendedTreatment(newVal) {
            if (!newVal.includes('PG Inpatient')) this.prevPgInpatient = '';
            if (!newVal.includes('PG Outpatient')) this.prevPgOutpatient = '';
            if (!newVal.includes('PG Residential')) this.prevPgResidential = '';
            if (!newVal.includes('SUD Inpatient')) this.prevSudInpatient = '';
            if (!newVal.includes('SUD Outpatient')) this.prevSudOutpatient = '';
            if (!newVal.includes('SUD Residential')) this.prevSudResidential = '';
        },
        
        currentlyAttendingTreatment(newVal) {
            if (!newVal.includes('PG Inpatient')) this.currPgInpatient = '';
            if (!newVal.includes('PG Outpatient')) this.currPgOutpatient = '';
            if (!newVal.includes('PG Residential')) this.currPgResidential = '';
            if (!newVal.includes('SUD Inpatient')) this.currSudInpatient = '';
            if (!newVal.includes('SUD Outpatient')) this.currSudOutpatient = '';
            if (!newVal.includes('SUD Residential')) this.currSudResidential = '';
        },
        
        previouslyUtilizedRecoveryServices(newVal) {
            if (!newVal.includes('Recovery Community and Outreach Center')) {
            this.prevRecoveryRcocName = '';
            }
        },
        
        currentlyUtilizingRecoveryServices(newVal) {
            if (!newVal.includes('Recovery Community and Outreach Center')) {
            this.currRecoveryRcocName = '';
            }
        },
        
        previouslyUtilizedFinancialServices(newVal) {
            if (!newVal.includes('Other')) {
            this.prevFinancialOther = '';
            }
        },
        
        currentlyUtilizingFinancialServices(newVal) {
            if (!newVal.includes('Other')) {
            this.currFinancialOther = '';
            }
        },

        currentlyUtilizingRecoveryServices(newVal) {
            if (!newVal.includes('Recovery Community and Outreach Center')) {
                this.currRecoveryRcocName = '';
            }
        },

        psdfContinuedServices(newVal) {
            if (!newVal.includes('Problem Gambling Treatment Services')) {
                this.psdfPgTreatment = null;
            }

            if (!newVal.includes('Substance Use Treatment Services')) {
                this.psdfSudTreatment = null;
            }
            
            if (!newVal.includes('Recovery Support Services')) {
                this.psdfRecoveryServices = [];
                this.psdfRecoveryRcoc = '';
                this.psdfRecoveryYouth = '';
                this.psdfRecoveryPeer = '';
                this.psdfRecoveryOpen = '';
                this.psdfRecoveryFamily = '';
                this.psdfRecoveryRegional = '';
                this.psdfRecoveryOther = '';
            }
        },
        psdfRecoveryServices(newVal) {
            if (!newVal.includes('Recovery Community and Outreach Center')) this.psdfRecoveryRcoc = '';
            if (!newVal.includes('Youth Clubhouse')) this.psdfRecoveryYouth = '';
            if (!newVal.includes('Peer Advocate')) this.psdfRecoveryPeer = '';
            if (!newVal.includes('Open Access Center')) this.psdfRecoveryOpen = '';
            if (!newVal.includes('Family Navigator')) this.psdfRecoveryFamily = '';
            if (!newVal.includes('Regional Addiction Resource Center')) this.psdfRecoveryRegional = '';
            if (!newVal.includes('Other')) this.psdfRecoveryOther = '';
        },
    },
    methods: {
        ...mapActions(['updateClientActivity','updateClientFormVSE']),
        addPgfGoal() {
            this.pgfGoals.push('')
        },
        removePgfGoal(index) {
            if (this.pgfGoals.length > 1) {
                this.pgfGoals.splice(index, 1)
            }
        },
        repeatPsfAgain() {
            this.psfItemsFormRepeater.push({
                id: this.psfNextId++,
                psfDate: '',
                psfDuration: null,
                psfServiceDelivery: null,
                psfRemoteType: null,
                psfServiceType: [],
                psfProblemStatuses: [],
                psfProblemComments: [],
                psfGoalStatuses: [],
                psfGoalComments: [],
                psfFurtherActions: [],
                psfTreatmentReferral: [],
                psfTreatmentInpatient: '',
                psfTreatmentResidential: '',
                psfTreatmentOutpatient: '',
                psfRecoveryReferral: [],
                psfRecoveryRcoc: '',
                psfRecoveryYouth: '',
                psfRecoveryPeer: '',
                psfRecoveryOpen: '',
                psfRecoveryFamily: '',
                psfRecoveryRegional: '',
                psfRecoverySelfHelp: null,
                psfRecoverySelfHelpOther: '',
                psfRecoveryOther: '',
                psfSignature: ''
            })
        },
        removePsfItem(id) {
            const index = this.psfItemsFormRepeater.findIndex(item => item.id === id)
            if (index > -1 && this.psfItemsFormRepeater.length > 1) {
                this.psfItemsFormRepeater.splice(index, 1)
            }
        },
        filtChange(val) {
            // this.loading = true
            // var triggers = val.explicitOriginalTarget ? val.explicitOriginalTarget.value : val.target._value
            // console.log(val)
            this.dodListener += val.key
            setTimeout(() => {
                var changeInputSite = val.explicitOriginalTarget ? val.explicitOriginalTarget.value : val.target._value
                var ultimosTresCaracteres = this.dodListener.slice(-3);
                if(changeInputSite === 'n/a' || changeInputSite === 'N/A' || ultimosTresCaracteres === 'N/A' || ultimosTresCaracteres === 'n/a') {
                    this.dateOfDischarge = 'N/A'
                    this.dodListener = ''
                    // console.log(this.dodListener, changeInputSite)
                }
            }, 500)
        },
        onCloseDischargeDate() {
            this.popoverShowDischargeDate = false
        },
        onOkDischargeDate() {
            // console.log('ok')
            this.dateOfDischarge = 'N/A'
            this.onCloseDischargeDate()
        },
        onShowDischargeDate() {
            // console.log('asdf')
        },
        // onShown() {
        //     console.log('first')
        // },
        onHiddenDischargeDate() {
            // console.log('first')
        },
        onClose() {
            this.popoverShow = false
        },
        onOk() {
            // console.log('ok')
            this.numberOfSessionsAttended = 'N/A'
            this.onClose()
        },
        onShow() {
            // console.log('asdf')
        },
        // onShown() {
        //     console.log('first')
        // },
        onHidden() {
            // console.log('first')
        },
        handleReferralSourceChange(value) {
            // Reset conditional fields when referral source changes
            this.warmTransfer = null;
            this.familyReferralType = null;
            this.selfHelpGroupType = null;
            this.pgTreatmentType = null;
            this.sudTreatmentType = null;
            this.recoveryServiceType = null;
            this.recoveryServiceDetails = '';
        },
        handleLegalInvolvementChange(value) {
            if (value !== 'Yes') {
            this.legalSystemType = null;
            }
        },
        submitFormClientActivity() {
            var clinicianUidArray = []
            this.clinician.forEach(clinicianUid => {
                clinicianUidArray.push(clinicianUid.uid)
            })

            var objClient = {
                // form
                clinician: clinicianUidArray,
                dateOfContact: this.dateOfContact,
                methodOfContact: this.methodOfContact,
                contactStatus: this.contactStatus,
                referredBy: this.referredBy,
                familyMemberSelf: this.familyMemberSelf,
                problemGamblingSelfHelpGroupMeetings: this.problemGamblingSelfHelpGroupMeetings,
                problemGamblingTreatmentServices: this.problemGamblingTreatmentServices,
                substanceUseTreatmentServices: this.substanceUseTreatmentServices,
                recoverySupportServices: this.recoverySupportServices,
                otherReferredBy: this.otherReferredBy,
                warmTransfer: this.warmTransfer,
                initialAppointmentDate: this.initialAppointmentDate,
                time: this.time,
                wasTheCallHelpful: this.wasTheCallHelpful,
                wasTheCallHelpfulIfNotWhy: this.wasTheCallHelpfulIfNotWhy,
                informationKitAccepted: this.informationKitAccepted,
                informationKitOption: this.informationKitOption,
                regionalCFEReceivingTheCall: this.regionalCFEReceivingTheCall,
                referredToPeerAdvocate: this.referredToPeerAdvocate,
                borough: this.borough,
                readmission: this.readmission,
                race: this.race,
                householdIncome: this.householdIncome,
                gamblingTypes: this.gamblingTypes,
                employmentStatus: this.employmentStatus,
                educationLevels: this.educationLevels,
                ethnicity: this.ethnicity,
                veteran: this.veteran,
                zipCode: this.zipCode,
                industryOfEmployment: this.industryOfEmployment,
                maritalStatus: this.maritalStatus,
                religiousPreference: this.religiousPreference,
                connectedToPeerAdvocate: this.connectedToPeerAdvocate,
                connectedToVSE: this.connectedToVSE,
                connectedToPeerEducationGroup: this.connectedToPeerEducationGroup,
                connectedToFamilyEducationGroup: this.connectedToFamilyEducationGroup,
                connectedToAsianServicesProgram: this.connectedToAsianServicesProgram,
                connectedToGamFin: this.connectedToGamFin,
                referralrecoverySupportServices: this.referralrecoverySupportServices ? this.referralrecoverySupportServices : '',
                admissionrecoverySupportServices: this.admissionrecoverySupportServices ? this.admissionrecoverySupportServices : '',
                admissionproblemGamblingTreatmentServices: this.admissionproblemGamblingTreatmentServices ? this.admissionproblemGamblingTreatmentServices : '',
                admissionsubstanceUseTreatmentServices: this.admissionsubstanceUseTreatmentServices ? this.admissionsubstanceUseTreatmentServices : '',
                // enter adminission/discharge information
                enterAdmissionDischargeInformation: this.enterAdmissionDischargeInformation,
                enterAdmissionInformation: this.enterAdmissionInformation,
                enterDischargeInformation: this.enterDischargeInformation,
                enterSurveyInformation: this.enterSurveyInformation,
                // admission form
                dateOfAdmission: this.dateOfAdmission ? this.dateOfAdmission : null,
                daaf: this.dateOfAdmission ? Date.now() : null,
                newOrReturningClient: this.newOrReturningClient ? this.newOrReturningClient : '',
                clientStatusAdmission: this.clientStatusAdmission ? this.clientStatusAdmission : '',
                presentingProblemsAtAdmission: this.presentingProblemsAtAdmission ? this.presentingProblemsAtAdmission : '',
                diagnosticCriteriaMetAtAdmission: this.diagnosticCriteriaMetAtAdmission ? this.diagnosticCriteriaMetAtAdmission : '',
                otherProblemsAdmission: this.otherProblemsAdmission ? this.otherProblemsAdmission : '',
                clientInvolvedWithLegalSystem: this.clientInvolvedWithLegalSystem ? this.clientInvolvedWithLegalSystem : '',
                clientReleaseSigned: this.clientReleaseSigned ? this.clientReleaseSigned : '',
                referredByAdmission: this.referredByAdmission ? this.referredByAdmission : '',
                familyMemberSelfAdmission: this.familyMemberSelfAdmission ? this.familyMemberSelfAdmission : '',
                problemGamblingTreatmentServicesAdmission: this.problemGamblingTreatmentServicesAdmission ? this.problemGamblingTreatmentServicesAdmission : '',
                problemGamblingSelfHelpGroupMeetingsAdmission: this.problemGamblingSelfHelpGroupMeetingsAdmission ? this.problemGamblingSelfHelpGroupMeetingsAdmission : '',
                substanceUseTreatmentServicesAdmission: this.substanceUseTreatmentServicesAdmission ? this.substanceUseTreatmentServicesAdmission : '',
                recoverySupportServicesAdmission: this.recoverySupportServicesAdmission ? this.recoverySupportServicesAdmission : '',
                otherReferredByAdmission: this.otherReferredByAdmission ? this.otherReferredByAdmission : '',
                warmTransferAdmission: this.warmTransferAdmission ? this.warmTransferAdmission : '',
                primaryICD10: this.primaryICD10 ? this.primaryICD10 : '',
                Z72GamblingAndBetting: this.Z72GamblingAndBetting ? this.Z72GamblingAndBetting : '',
                numberofAssessmentVisits: this.numberofAssessmentVisits ? this.numberofAssessmentVisits : '',
                age: this.age ? this.age : '',
                sexualOrientation: this.sexualOrientation ? this.sexualOrientation : '',
                genderIdentity: this.genderIdentity ? this.genderIdentity : '',
                transgender: this.transgender ? this.transgender : '',
                asianOrigin: this.asianOrigin ? this.asianOrigin : '',
                pacificIslanderOrigin: this.pacificIslanderOrigin ? this.pacificIslanderOrigin : '',
                developmentalDisability: this.developmentalDisability ? this.developmentalDisability : '',
                coexistingPsychiatricDisorder: this.coexistingPsychiatricDisorder ? this.coexistingPsychiatricDisorder : '',
                treatedForMentalIllness: this.treatedForMentalIllness ? this.treatedForMentalIllness : '',
                hospitalizedForMentalIllness: this.hospitalizedForMentalIllness ? this.hospitalizedForMentalIllness : '',
                hospitalized30OrMoreDaysForMentalIllness: this.hospitalized30OrMoreDaysForMentalIllness ? this.hospitalized30OrMoreDaysForMentalIllness : '',
                smokedTobaccoInThePastWeek: this.smokedTobaccoInThePastWeek ? this.smokedTobaccoInThePastWeek : '',
                usedSmokelessTobaccoInThePastWeek: this.usedSmokelessTobaccoInThePastWeek ? this.usedSmokelessTobaccoInThePastWeek : '',
                substancesUsed: this.substancesUsed ? this.substancesUsed : '',
                substanceUseRouteOfAdministration: this.substanceUseRouteOfAdministration ? this.substanceUseRouteOfAdministration : '',
                frequencyOfSubstanceUse: this.frequencyOfSubstanceUse ? this.frequencyOfSubstanceUse : '',
                ageOfFirstSubstanceUse: this.ageOfFirstSubstanceUse ? this.ageOfFirstSubstanceUse : '',
                inThePastFewMonthsDrinks: this.inThePastFewMonthsDrinks ? this.inThePastFewMonthsDrinks : '',
                referralOptions : this.referralOptions ? this.referralOptions : '',
                OASASProgram : this.OASASProgram ? this.OASASProgram : '',
                OASASProgramOptInpatient : this.OASASProgramOptInpatient ? this.OASASProgramOptInpatient : '',
                OASASProgramOptResidential : this.OASASProgramOptResidential ? this.OASASProgramOptResidential : '',
                OASASProgramOptOutpatient : this.OASASProgramOptOutpatient ? this.OASASProgramOptOutpatient : '',
                privatePractitioner : this.privatePractitioner ? this.privatePractitioner : '',
                recoverySupportServices : this.recoverySupportServices ? this.recoverySupportServices : '',
                recoveryCommunityOutreachCenter: this.recoveryCommunityOutreachCenter ? this.recoveryCommunityOutreachCenter : '',
                youthClubhouse: this.youthClubhouse ? this.youthClubhouse : '',
                peerAdvocate: this.peerAdvocate ? this.peerAdvocate : '',
                openAccessCenter: this.openAccessCenter ? this.openAccessCenter : '',
                familyNavigator: this.familyNavigator ? this.familyNavigator : '',
                regionalAddictionResourceCenter: this.regionalAddictionResourceCenter ? this.regionalAddictionResourceCenter : '',
                locadtrg: this.locadtrg ? this.locadtrg : '',
                LOCADTRAssessmentID: this.LOCADTRAssessmentID ? this.LOCADTRAssessmentID : '',
                dateOfBirthAdmission: this.dateOfBirthAdmission ? this.dateOfBirthAdmission : '',
                sexAtBirth: this.sexAtBirth ? this.sexAtBirth : '',
                last4SSN: this.last4SSN ? this.last4SSN : '',
                firstTwoLettersLastName: this.firstTwoLettersLastName ? this.firstTwoLettersLastName : '',
                frequencyofGambling: this.frequencyofGambling ? this.frequencyofGambling : '',
                ageFirstGambled: this.ageFirstGambled ? this.ageFirstGambled : '',
                past30DaysAmountOfMoney: this.past30DaysAmountOfMoney ? this.past30DaysAmountOfMoney : '',
                past30DaysHowMuchTime: this.past30DaysHowMuchTime ? this.past30DaysHowMuchTime : '',
                past30DaysHowManyDays: this.past30DaysHowManyDays ? this.past30DaysHowManyDays : '',
                gamblinglocationspast12months: this.gamblinglocationspast12months ? this.gamblinglocationspast12months : '',
                hasClientAttendedReceivedServices: this.hasClientAttendedReceivedServices ? this.hasClientAttendedReceivedServices : '',
                legalSystem: this.legalSystem ? this.legalSystem : '',
                notesAdmission: this.notesAdmission ? this.notesAdmission : '',
                // discharge form
                dateOfDischarge: this.dateOfDischarge ? this.dateOfDischarge : null,
                dadf: this.dateOfDischarge ? Date.now() : null,
                dischargeStatus: this.dischargeStatus ? this.dischargeStatus : '',
                plannedDischargeReasons: this.plannedDischargeReasons ? this.plannedDischargeReasons : '',
                unplannedDischargeReason: this.unplannedDischargeReason ? this.unplannedDischargeReason : '',
                numberOfSessionsAttended: this.numberOfSessionsAttended ? this.numberOfSessionsAttended : null,
                dischargeDisposition: this.dischargeDisposition ? this.dischargeDisposition : '',
                referralDisposition: this.referralDisposition ? this.referralDisposition : '',
                diagnosticCriteriaMetAtAdmissionWasReduced: this.diagnosticCriteriaMetAtAdmissionWasReduced ? this.diagnosticCriteriaMetAtAdmissionWasReduced : '',
                diagnosticCriteriaMetAtDischarge: this.diagnosticCriteriaMetAtDischarge ? this.diagnosticCriteriaMetAtDischarge : '',
                goalsMet: this.goalsMet ? this.goalsMet : '',
                currentGamblingComparedToAdmission: this.currentGamblingComparedToAdmission ? this.currentGamblingComparedToAdmission : '',
                clientInvolvedWithSelfHelpAtDischarge: this.clientInvolvedWithSelfHelpAtDischarge ? this.clientInvolvedWithSelfHelpAtDischarge : '',
                clientReferredForContinuedServices: this.clientReferredForContinuedServices ? this.clientReferredForContinuedServices : '',
                ifSoWhatServicesWereRecommended: this.ifSoWhatServicesWereRecommended ? this.ifSoWhatServicesWereRecommended : '',
                relatedProblemsGambling: this.relatedProblemsGambling ? this.relatedProblemsGambling : '',
                relatedProblemsDrugUse: this.relatedProblemsDrugUse ? this.relatedProblemsDrugUse : '',
                relatedProblemsAlcoholUse: this.relatedProblemsAlcoholUse ? this.relatedProblemsAlcoholUse : '',
                relatedProblemsFinancial: this.relatedProblemsFinancial ? this.relatedProblemsFinancial : '',
                relatedProblemsLegal: this.relatedProblemsLegal ? this.relatedProblemsLegal : '',
                relatedProblemsVocationalEducational: this.relatedProblemsVocationalEducational ? this.relatedProblemsVocationalEducational : '',
                relatedProblemsMedicalHealth: this.relatedProblemsMedicalHealth ? this.relatedProblemsMedicalHealth : '',
                relatedProblemsLethalitySelf: this.relatedProblemsLethalitySelf ? this.relatedProblemsLethalitySelf : '',
                relatedProblemsLethalityOther: this.relatedProblemsLethalityOther ? this.relatedProblemsLethalityOther : '',
                relatedProblemsMentalHealth: this.relatedProblemsMentalHealth ? this.relatedProblemsMentalHealth : '',
                relatedProblemsFamily: this.relatedProblemsFamily ? this.relatedProblemsFamily : '',
                notesDischarge: this.notesDischarge ? this.notesDischarge : '',
                // survey
                isClientInsured: this.isClientInsured,
                isClientMatchedToaClinicianWhoAcceptsTheirInsurance: this.isClientMatchedToaClinicianWhoAcceptsTheirInsurance,
                isTheClinicianBillingTheClientsInsurance: this.isTheClinicianBillingTheClientsInsurance,
                whyInsuranceWasNotBilled: this.whyInsuranceWasNotBilled,
                whyInsuranceWasNotBilledOther: this.whyInsuranceWasNotBilledOther,
                reasonWhyClientWasReferredToClinician: this.reasonWhyClientWasReferredToClinician,
                reasonWhyClientWasReferredToClinicianOther: this.reasonWhyClientWasReferredToClinicianOther,
                paymentInsuranceUtilizationForm: this.itemsFormRepeater && this.itemsFormRepeater.length ? this.itemsFormRepeater : [],
                // content right
                specialIssuesOrOtherComments: this.specialIssuesOrOtherComments,
                callNotes: this.callNotes,
                activityStatus: this.activityStatus,
                engagedStatus: this.engagedStatus,
                closeNotes: this.closeNotes,
                // client: this.idClientActivity,

                enterPeerServicesForm: this.enterPeerServicesForm,
                contactDate: this.contactDate ? this.contactDate : '',
                peerCompleting: this.peerCompleting ? this.peerCompleting : null,
                peerAssigned: this.peerAssigned ? this.peerAssigned : null,
                clientType: this.clientType ? this.clientType : null,
                pifClientStatus: this.pifClientStatus ? this.pifClientStatus : null,
                referralSource: this.referralSource ? this.referralSource : null,
                warmTransferPeer: this.warmTransferPeer ? this.warmTransferPeer : null,
                familyReferralType: this.familyReferralType ? this.familyReferralType : null,
                selfHelpGroupType: this.selfHelpGroupType ? this.selfHelpGroupType : null,
                pgTreatmentType: this.pgTreatmentType ? this.pgTreatmentType : null,
                sudTreatmentType: this.sudTreatmentType ? this.sudTreatmentType : null,
                recoveryServiceType: this.recoveryServiceType ? this.recoveryServiceType : null,
                recoveryServiceDetails: this.recoveryServiceDetails ? this.recoveryServiceDetails : '',
                serviceStatus: this.serviceStatus ? this.serviceStatus : [],
                previouslyAttendedTreatment: this.previouslyAttendedTreatment ? this.previouslyAttendedTreatment : [],
                prevPgInpatient: this.prevPgInpatient ? this.prevPgInpatient : '',
                prevPgOutpatient: this.prevPgOutpatient ? this.prevPgOutpatient : '',
                prevPgResidential: this.prevPgResidential ? this.prevPgResidential : '',
                prevSudInpatient: this.prevSudInpatient ? this.prevSudInpatient : '',
                prevSudOutpatient: this.prevSudOutpatient ? this.prevSudOutpatient : '',
                prevSudResidential: this.prevSudResidential ? this.prevSudResidential : '',
                currentlyAttendingTreatment: this.currentlyAttendingTreatment ? this.currentlyAttendingTreatment : [],
                currPgInpatient: this.currPgInpatient ? this.currPgInpatient : '',
                currPgOutpatient: this.currPgOutpatient ? this.currPgOutpatient : '',
                currPgResidential: this.currPgResidential ? this.currPgResidential : '',
                currSudInpatient: this.currSudInpatient ? this.currSudInpatient : '',
                currSudOutpatient: this.currSudOutpatient ? this.currSudOutpatient : '',
                currSudResidential: this.currSudResidential ? this.currSudResidential : '',
                previouslyUtilizedRecoveryServices: this.previouslyUtilizedRecoveryServices ? this.previouslyUtilizedRecoveryServices : [],
                prevRecoveryRcocName: this.prevRecoveryRcocName ? this.prevRecoveryRcocName : '',
                currRecoveryTxtBoxRcocName: this.currRecoveryTxtBoxRcocName ? this.currRecoveryTxtBoxRcocName : '',
                currentlyUtilizingRecoveryServices: this.currentlyUtilizingRecoveryServices ? this.currentlyUtilizingRecoveryServices : [],
                currRecoveryRcocName: this.currRecoveryRcocName ? this.currRecoveryRcocName : '',
                previouslyUtilizedFinancialServices: this.previouslyUtilizedFinancialServices ? this.previouslyUtilizedFinancialServices : null,
                prevFinancialOther: this.prevFinancialOther ? this.prevFinancialOther : '',
                currentlyUtilizingFinancialServices: this.currentlyUtilizingFinancialServices ? this.currentlyUtilizingFinancialServices : null,
                currFinancialOther: this.currFinancialOther ? this.currFinancialOther : '',
                presentingProblems: this.presentingProblems ? this.presentingProblems : [],
                otherProblems: this.otherProblems ? this.otherProblems : '',
                legalInvolvement: this.legalInvolvement ? this.legalInvolvement : null,
                legalSystemType: this.legalSystemType ? this.legalSystemType : null,
                releaseSigned: this.releaseSigned ? this.releaseSigned : null,
                notes: this.notes ? this.notes : '',
                race: this.race ? this.race : null,
                hispanicOrigin: this.hispanicOrigin ? this.hispanicOrigin : null,
                asianOrigin: this.asianOrigin ? this.asianOrigin : null,
                pacificIslanderOrigin: this.pacificIslanderOrigin ? this.pacificIslanderOrigin : null,
                householdIncome: this.householdIncome ? this.householdIncome : null,
                gamblingTypes: this.gamblingTypes ? this.gamblingTypes : [],
                employmentStatus: this.employmentStatus ? this.employmentStatus : null,
                highestGrade: this.highestGrade ? this.highestGrade : null,
                veteran: this.veteran ? this.veteran : null,
                zipCode: this.zipCode ? this.zipCode : '',
                industry: this.industry ? this.industry : null,
                maritalStatus: this.maritalStatus ? this.maritalStatus : null,
                religiousPreference: this.religiousPreference ? this.religiousPreference : null,
                age: this.age ? this.age : null,
                sexualOrientation: this.sexualOrientation ? this.sexualOrientation : null,
                genderIdentity: this.genderIdentity ? this.genderIdentity : null,
                transgender: this.transgender ? this.transgender : null,
                gamblingFrequency: this.gamblingFrequency ? this.gamblingFrequency : null,
                ageFirstGambled: this.ageFirstGambled ? this.ageFirstGambled : '',
                typicalAmount: this.typicalAmount ? this.typicalAmount : '',
                typicalTime: this.typicalTime ? this.typicalTime : '',
                daysGambled: this.daysGambled ? this.daysGambled : '',
                gamblingLocations: this.gamblingLocations ? this.gamblingLocations : [],
                gamblingLocationOther: this.gamblingLocationOther ? this.gamblingLocationOther : '',

                // goal form
                enterPeerGoalForm: this.enterPeerGoalForm,
                pgfDate: this.pgfDate ? this.pgfDate : '',
                pgfGoals: this.pgfGoals ? this.pgfGoals : [],

                // Peer Session Form
                enterPeerSessionForm: this.enterPeerSessionForm,
                psfItemsFormRepeater: this.psfItemsFormRepeater,
                psfNextId: this.psfNextId,

                // Peer Services Discharge Form
                enterPeerServicesDischargeForm: this.enterPeerServicesDischargeForm,
                psdfDate: this.psdfDate,
                psdfStatus: this.psdfStatus,
                psdfDisposition: this.psdfDisposition,
                psdfReferralDisposition: this.psdfReferralDisposition,
                psdfGamblingComparison: this.psdfGamblingComparison,
                psdfSelfHelp: this.psdfSelfHelp,
                psdfContinuedServices: this.psdfContinuedServices,
                psdfPgTreatment: this.psdfPgTreatment,
                psdfSudTreatment: this.psdfSudTreatment,
                psdfRecoveryServices: this.psdfRecoveryServices,
                psdfRecoveryRcoc: this.psdfRecoveryRcoc,
                psdfRecoveryYouth: this.psdfRecoveryYouth,
                psdfRecoveryPeer: this.psdfRecoveryPeer,
                psdfRecoveryOpen: this.psdfRecoveryOpen,
                psdfRecoveryFamily: this.psdfRecoveryFamily,
                psdfRecoveryRegional: this.psdfRecoveryRegional,
                psdfRecoveryOther: this.psdfRecoveryOther,
                psdfProblemGambling: this.psdfProblemGambling,
                psdfProblemDrug: this.psdfProblemDrug,
                psdfProblemAlcohol: this.psdfProblemAlcohol,
                psdfProblemFinancial: this.psdfProblemFinancial,
                psdfProblemLegal: this.psdfProblemLegal,
                psdfProblemVocational: this.psdfProblemVocational,
                psdfProblemMedical: this.psdfProblemMedical,
                psdfProblemLethalitySelf: this.psdfProblemLethalitySelf,
                psdfProblemLethalityOther: this.psdfProblemLethalityOther,
                psdfProblemMental: this.psdfProblemMental,
                psdfProblemFamily: this.psdfProblemFamily,
                psdfSessionsAttended: this.psdfSessionsAttended,
                pSNotes: this.pSNotes,

                // configuration admission and discharge
                removeRecordAdmissionData: this.removeRecordAdmissionData,
                removeRecordDischargeData: this.removeRecordDischargeData,

                clinicianName: '',
                clinicianStatus: '',
                clinicianRegion: [],
                arrayClinicianStatus: [],
                arrayClinicianName: []
            }
            this.updateClientActivity({id: this.idClientActivity, data: objClient})
            this.statusEditClientActivity = false
            this.$emit('statusEditClientActivity',false)
            this.pushEditButton = true
            this.$emit('pushEditButton',true)
            //  reset form
            this.clinician = []
            this.dateOfContact = null
            this.methodOfContact = ''
            this.contactStatus = ''
            this.referredBy = ''
            this.familyMemberSelf = ''
            this.problemGamblingSelfHelpGroupMeetings = ''
            this.problemGamblingTreatmentServices = ''
            this.substanceUseTreatmentServices = ''
            this.recoverySupportServices = ''
            this.otherReferredBy = ''
            this.warmTransfer = ''
            this.initialAppointmentDate = null
            this.time = ''
            this.wasTheCallHelpful = ''
            this.wasTheCallHelpfulIfNotWhy = ''
            this.informationKitAccepted = ''
            this.informationKitOption = ''
            this.regionalCFEReceivingTheCall = ''
            this.referredToPeerAdvocate = ''
            this.borough = ''
            this.readmission = ''
            this.race = ''
            this.householdIncome = ''
            this.gamblingTypes = ''
            this.employmentStatus = ''
            this.educationLevels = ''
            this.ethnicity = ''
            this.veteran = ''
            this.zipCode = ''
            this.industryOfEmployment = ''
            this.maritalStatus = ''
            this.religiousPreference = ''
            this.connectedToPeerAdvocate = ''
            this.connectedToVSE = ''
            this.connectedToPeerEducationGroup = ''
            this.connectedToFamilyEducationGroup = ''
            this.connectedToAsianServicesProgram = ''
            this.connectedToGamFin = ''
            this.referralrecoverySupportServices = ''
            this.admissionrecoverySupportServices = ''
            this.admissionproblemGamblingTreatmentServices = ''
            this.admissionsubstanceUseTreatmentServices = ''
            // enter adminission/discharge information
            this.enterAdmissionDischargeInformation = false
            this.enterAdmissionInformation = false
            this.enterDischargeInformation = false
            this.enterSurveyInformation = false
            // admission form
            this.dateOfAdmission = null
            this.newOrReturningClient = ''
            this.clientStatusAdmission = ''
            this.presentingProblemsAtAdmission = ''
            this.diagnosticCriteriaMetAtAdmission = ''
            this.otherProblemsAdmission = ''
            this.clientInvolvedWithLegalSystem = ''
            this.clientReleaseSigned = ''
            this.referredByAdmission = ''
            this.familyMemberSelfAdmission = ''
            this.problemGamblingTreatmentServicesAdmission = ''
            this.problemGamblingSelfHelpGroupMeetingsAdmission = ''
            this.substanceUseTreatmentServicesAdmission = ''
            this.recoverySupportServicesAdmission = ''
            this.otherReferredByAdmission = ''
            this.warmTransferAdmission = ''
            this.primaryICD10 = ''
            this.Z72GamblingAndBetting = ''
            this.numberofAssessmentVisits = ''
            this.age = ''
            this.sexualOrientation = ''
            this.genderIdentity = ''
            this.transgender = ''
            this.asianOrigin = ''
            this.pacificIslanderOrigin = ''
            this.developmentalDisability = ''
            this.coexistingPsychiatricDisorder = ''
            this.treatedForMentalIllness = ''
            this.hospitalizedForMentalIllness = ''
            this.hospitalized30OrMoreDaysForMentalIllness = ''
            this.smokedTobaccoInThePastWeek = ''
            this.usedSmokelessTobaccoInThePastWeek = ''
            this.substancesUsed = ''
            this.substanceUseRouteOfAdministration = ''
            this.frequencyOfSubstanceUse = ''
            this.ageOfFirstSubstanceUse = ''
            this.inThePastFewMonthsDrinks = ''
            this.referralOptions = ''
            this.OASASProgram = ''
            this.OASASProgramOptInpatient = ''
            this.OASASProgramOptResidential = ''
            this.OASASProgramOptOutpatient = ''
            this.privatePractitioner = ''
            this.recoverySupportServices = ''
            this.recoveryCommunityOutreachCenter = ''
            this.youthClubhouse = ''
            this.peerAdvocate = ''
            this.openAccessCenter = ''
            this.familyNavigator = ''
            this.regionalAddictionResourceCenter = ''
            this.locadtrg = ''
            this.LOCADTRAssessmentID = ''
            this.dateOfBirthAdmission = ''
            this.sexAtBirth = ''
            this.last4SSN = ''
            this.firstTwoLettersLastName = ''
            this.frequencyofGambling = ''
            this.ageFirstGambled = ''
            this.past30DaysAmountOfMoney = ''
            this.past30DaysHowMuchTime = ''
            this.past30DaysHowManyDays = ''
            this.gamblinglocationspast12months = ''
            this.hasClientAttendedReceivedServices = ''
            this.legalSystem = ''
            this.notesAdmission = ''
            // discharge form
            this.dateOfDischarge = null
            this.dischargeStatus = ''
            this.plannedDischargeReasons = ''
            this.unplannedDischargeReason = ''
            this.numberOfSessionsAttended = null
            this.dischargeDisposition = ''
            this.referralDisposition = ''
            this.diagnosticCriteriaMetAtAdmissionWasReduced = ''
            this.diagnosticCriteriaMetAtDischarge = ''
            this.goalsMet = ''
            this.currentGamblingComparedToAdmission = ''
            this.clientInvolvedWithSelfHelpAtDischarge = ''
            this.clientReferredForContinuedServices = ''
            this.ifSoWhatServicesWereRecommended = ''
            this.relatedProblemsGambling = ''
            this.relatedProblemsDrugUse = ''
            this.relatedProblemsAlcoholUse = ''
            this.relatedProblemsFinancial = ''
            this.relatedProblemsLegal = ''
            this.relatedProblemsVocationalEducational = ''
            this.relatedProblemsMedicalHealth = ''
            this.relatedProblemsLethalitySelf = ''
            this.relatedProblemsLethalityOther = ''
            this.relatedProblemsMentalHealth = ''
            this.relatedProblemsFamily = ''
            this.notesDischarge = ''
            // survey
            this.isClientInsured = ''
            this.isClientMatchedToaClinicianWhoAcceptsTheirInsurance = ''
            this.isTheClinicianBillingTheClientsInsurance = ''
            this.whyInsuranceWasNotBilled = ''
            this.whyInsuranceWasNotBilledOther = ''
            this.reasonWhyClientWasReferredToClinician = ''
            this.reasonWhyClientWasReferredToClinicianOther = ''
            this.itemsFormRepeater = []

            this.enterPeerServicesForm = false
            this.contactDate = ''
            this.peerCompleting = null
            this.peerAssigned = null
            this.peerCompletingSaved = null
            this.peerAssignedSaved = null
            this.clientType = null
            this.pifClientStatus = null
            this.referralSource = null
            this.warmTransferPeer = null
            this.familyReferralType = null
            this.selfHelpGroupType = null
            this.pgTreatmentType = null
            this.sudTreatmentType = null
            this.recoveryServiceType = null
            this.recoveryServiceDetails = ''
            this.serviceStatus = []
            this.previouslyAttendedTreatment = []
            this.prevPgInpatient = ''
            this.prevPgOutpatient = ''
            this.prevPgResidential = ''
            this.prevSudInpatient = ''
            this.prevSudOutpatient = ''
            this.prevSudResidential = ''
            this.currentlyAttendingTreatment = []
            this.currPgInpatient = ''
            this.currPgOutpatient = ''
            this.currPgResidential = ''
            this.currSudInpatient = ''
            this.currSudOutpatient = ''
            this.currSudResidential = ''
            this.previouslyUtilizedRecoveryServices = []
            this.prevRecoveryRcocName = ''
            this.currRecoveryTxtBoxRcocName = ''
            this.currentlyUtilizingRecoveryServices = []
            this.currRecoveryRcocName = ''
            this.previouslyUtilizedFinancialServices = null
            this.prevFinancialOther = ''
            this.currentlyUtilizingFinancialServices = null
            this.currFinancialOther = ''
            this.presentingProblems = []
            this.otherProblems = ''
            this.legalInvolvement = null
            this.legalSystemType = null
            this.releaseSigned = null
            this.notes = ''
            this.race = null
            this.hispanicOrigin = null
            this.asianOrigin = null
            this.pacificIslanderOrigin = null
            this.householdIncome = null
            this.gamblingTypes = []
            this.employmentStatus = null
            this.highestGrade = null
            this.veteran = null
            this.zipCode = ''
            this.industry = null
            this.maritalStatus = null
            this.religiousPreference = null
            this.age = null
            this.sexualOrientation = null
            this.genderIdentity = null
            this.transgender = null
            this.gamblingFrequency = null
            this.ageFirstGambled = ''
            this.typicalAmount = ''
            this.typicalTime = ''
            this.daysGambled = ''
            this.gamblingLocations = []
            this.gamblingLocationOther = ''

            // goal form
            this.enterPeerGoalForm = false
            this.pgfDate = ''
            this.pgfGoals = ['']

            // Peer Session Form
            this.enterPeerSessionForm = false
            this.psfItemsFormRepeater = []
            this.psfNextId = 2

            // Peer Services Discharge Form
            this.enterPeerServicesDischargeForm = false
            this.psdfDate = ''
            this.psdfStatus = null
            this.psdfDisposition = []
            this.psdfReferralDisposition = []
            this.psdfGamblingComparison = null
            this.psdfSelfHelp = null
            this.psdfContinuedServices = []
            this.psdfPgTreatment = null
            this.psdfSudTreatment = null
            this.psdfRecoveryServices = []
            this.psdfRecoveryRcoc = ''
            this.psdfRecoveryYouth = ''
            this.psdfRecoveryPeer = ''
            this.psdfRecoveryOpen = ''
            this.psdfRecoveryFamily = ''
            this.psdfRecoveryRegional = ''
            this.psdfRecoveryOther = ''
            this.psdfProblemGambling = null
            this.psdfProblemDrug = null
            this.psdfProblemAlcohol = null
            this.psdfProblemFinancial = null
            this.psdfProblemLegal = null
            this.psdfProblemVocational = null
            this.psdfProblemMedical = null
            this.psdfProblemLethalitySelf = null
            this.psdfProblemLethalityOther = null
            this.psdfProblemMental = null
            this.psdfProblemFamily = null
            this.pSNotes = ''
            // psdfSessionsAttended: '',

            // content right
            this.specialIssuesOrOtherComments = ''
            this.callNotes = ''
            this.activityStatus = ''
            this.engagedStatus = ''
            this.closeNotes = ''
        },
        validationForm() {
            this.$refs.editClinicianRules.validate().then(success => {
                if (success) {
                    // check validation form repeater
                    this.validFormRepeater = true
                    var validateFormRepeater = true
                    this.itemsFormRepeater.forEach(ele => {
                        if(!ele.paymentAssessmentDate) {
                            validateFormRepeater = false
                        }

                        if(!ele.paymentArrangement) {
                            validateFormRepeater = false
                        }

                        if(ele.theClientInsuranceIdonotAccept.length === 0 && ele.paymentArrangement.includes('The client has insurance that I do not accept. I was provided with this referral due to the circumstances selected below. NYCPG will provide reimbursement.')) {
                            validateFormRepeater = false
                        }

                        // if(ele.paymentArrangement === 'I will bill the client’s insurance and the client will provide the required copay. NYCPG will not provide reimbursement.' || ele.paymentArrangement === 'The client has insurance, but is not able to provide the required copay. NYCPG will provide reimbursement.' || ele.paymentArrangement === 'I will not bill the client’s insurance at the request of the client. NYCPG will provide reimbursement.' || ele.paymentArrangement === 'The client will utilize sliding scale for reasons not specified on this form. NYCPG will provide reimbursement.' || ele.theClientInsuranceIdonotAccept.includes('Other')) {
                        //     if(!ele.explanation) {
                        //         validateFormRepeater = false
                        //     }
                        // }
                    })
                    // console.log(validateFormRepeater)
                    
                    // eslint-disable-next-line
                    if(validateFormRepeater) {
                        // eslint-disable-next-line
                        this.submitFormClientActivity()
                    } else {
                        this.validFormRepeater = false
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: `(*) One or more required field(s) are missing.`,
                                icon: 'CoffeeIcon',
                                variant: 'danger',
                            },
                        })
                    }
                }
            })
        },
        submitFormVSE() {
            var clinicianUidArray = []
            // this.clinician.forEach(clinicianUid => {
            //     clinicianUidArray.push(clinicianUid.uid)
            // })

            var objClient = {
                // form
                clinician: clinicianUidArray,
                notesVSE: this.notesVSE ? this.notesVSE : '',
                finalStatusVSE: this.finalStatusVSE ? this.finalStatusVSE : '',
                // staffMemberCompletingFormVSE: this.staffMemberCompletingFormVSE && this.staffMemberCompletingFormVSE.uid ? this.staffMemberCompletingFormVSE.uid : '',
                staffMemberCompletingFormVSE: this.staffMemberCompletingFormVSE && this.staffMemberCompletingFormVSE.uid ? this.staffMemberCompletingFormVSE : '',
                contactDateVSE: this.contactDateVSE ? this.contactDateVSE : '',
                genderVSE: this.genderVSE ? this.genderVSE : '',
                referredByVSE: this.referredByVSE ? this.referredByVSE : '',
                familyMemberSelfVSE: this.familyMemberSelfVSE ? this.familyMemberSelfVSE : '',
                problemGamblingTreatmentServicesVSE: this.problemGamblingTreatmentServicesVSE ? this.problemGamblingTreatmentServicesVSE : '',
                problemGamblingSelfHelpGroupMeetingsVSE: this.problemGamblingSelfHelpGroupMeetingsVSE ? this.problemGamblingSelfHelpGroupMeetingsVSE : '',
                substanceUseTreatmentServicesVSE: this.substanceUseTreatmentServicesVSE ? this.substanceUseTreatmentServicesVSE : '',
                recoverySupportServicesVSE: this.recoverySupportServicesVSE ? this.recoverySupportServicesVSE : '',
                otherReferredByVSE: this.otherReferredByVSE ? this.otherReferredByVSE : '',
                warmTransferVSE: this.warmTransferVSE ? this.warmTransferVSE : '',
                pgrcPmSE: this.pgrcPmSE ? this.pgrcPmSE : '',
                PGRCPrivatePractitionerVSE: this.PGRCPrivatePractitionerVSE ? this.PGRCPrivatePractitionerVSE : '',
                OASASProgramVSE: this.OASASProgramVSE ? this.OASASProgramVSE : '',
                GamingFacilityVSE: this.GamingFacilityVSE ? this.GamingFacilityVSE : '',
                connectedToPGRCVSE: this.connectedToPGRCVSE ? this.connectedToPGRCVSE : '',
                connectedToPeerAdvocateVSE: this.connectedToPeerAdvocateVSE ? this.connectedToPeerAdvocateVSE : '',
                connectedtoNYSGamingCommissionVSE: this.connectedtoNYSGamingCommissionVSE ? this.connectedtoNYSGamingCommissionVSE : '',
                typesofGamblingEngagedInVSE: this.typesofGamblingEngagedInVSE ? this.typesofGamblingEngagedInVSE : '',
                interventionStatusVSE: this.interventionStatusVSE ? this.interventionStatusVSE : '',
                pendingVSE: this.pendingVSE ? this.pendingVSE : '',
                appointmentDateVSE: this.appointmentDateVSE ? this.appointmentDateVSE : '',
                followUpDateVSE: this.followUpDateVSE ? this.followUpDateVSE : '',
                VSETimeframe: this.VSETimeframe ? this.VSETimeframe : '',

                // client: this.$route.params.id,
                // created: Date.now()
            }
            // this.updateClientFormVSE(objClient)
            this.updateClientFormVSE({id: this.idClientActivity, data: objClient})
            this.statusEditClientActivity = false
            this.$emit('statusEditClientActivity',false)
            this.pushEditButton = true
            this.$emit('pushEditButton',true)

            // this.statusCreate = false
            this.statusCreateVSE = false
            //  reset form
            this.notesVSE = ''
            this.finalStatusVSE = ''
            this.staffMemberCompletingFormVSE = ''
            this.contactDateVSE = ''
            this.genderVSE = ''
            this.referredByVSE = ''
            this.familyMemberSelfVSE = ''
            this.problemGamblingTreatmentServicesVSE = ''
            this.problemGamblingSelfHelpGroupMeetingsVSE = ''
            this.substanceUseTreatmentServicesVSE = ''
            this.recoverySupportServicesVSE = ''
            this.otherReferredByVSE = ''
            this.warmTransferVSE = ''
            this.pgrcPmSE = ''
            this.PGRCPrivatePractitionerVSE = ''
            this.OASASProgramVSE = ''
            this.GamingFacilityVSE = ''
            this.connectedToPGRCVSE = ''
            this.connectedToPeerAdvocateVSE = ''
            this.connectedtoNYSGamingCommissionVSE = ''
            this.typesofGamblingEngagedInVSE = ''
            this.interventionStatusVSE = ''
            this.pendingVSE = ''
            this.appointmentDateVSE = ''
            this.followUpDateVSE = ''
            this.VSETimeframe = ''
        },
        validationFormVSE() {
            this.$refs.editClinicianRulesVSE.validate().then(success => {
                if (success) {
                    this.submitFormVSE()
                }
            })
        },
        repeateAgain() {
            this.itemsFormRepeater.push({
                id: this.nextTodoId += this.itemsFormRepeater.length,
                paymentAssessmentDate: '',
                paymentArrangement: '',
                theClientInsuranceIdonotAccept: '',
                explanation: '',
                providingReimbursement: false
            })

            this.$nextTick(() => {
                this.trAddHeight(this.$refs.row[0].offsetHeight)
            })
        },
        removeItem(index) {
            this.itemsFormRepeater.splice(index, 1)
            // this.counterSession()
            this.trTrimHeight(this.$refs.row[0].offsetHeight)
        },
        initTrHeight() {
            this.trSetHeight(null)
            this.$nextTick(() => {
                this.trSetHeight(this.$refs.formRepeaterSessionsEng.scrollHeight)
            })
        },
        backList() {
            this.statusEditClientActivity = false
            this.$emit('statusEditClientActivity',false)
        },
        removeRecordAdmission() {
            this.$swal({
                title: 'Remove',
                text: "Are you sure you want to delete this Admission record?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1 cancelBtn-modal',
                },
                buttonsStyling: false,
            }).then(result => {
                if(result.value) {
                    // admission form
                    this.dateOfAdmission = null
                    this.newOrReturningClient = ''
                    this.clientStatusAdmission = ''
                    this.presentingProblemsAtAdmission = ''
                    this.otherProblemsAdmission = ''
                    this.diagnosticCriteriaMetAtAdmission = ''
                    this.clientInvolvedWithLegalSystem = ''
                    this.clientReleaseSigned = ''
                    this.referredByAdmission = ''
                    this.familyMemberSelfAdmission = ''
                    this.problemGamblingTreatmentServicesAdmission = ''
                    this.problemGamblingSelfHelpGroupMeetingsAdmission = ''
                    this.substanceUseTreatmentServicesAdmission = ''
                    this.recoverySupportServicesAdmission = ''
                    this.otherReferredByAdmission = ''
                    this.warmTransferAdmission = ''
                    this.race = ''
                    this.householdIncome = ''
                    this.gamblingTypes = ''
                    this.employmentStatus = ''
                    this.educationLevels = ''
                    this.ethnicity = ''
                    this.veteran = ''
                    this.zipCode = ''
                    this.industryOfEmployment = ''
                    this.maritalStatus = ''
                    this.religiousPreference = ''
                    this.primaryICD10 = ''
                    this.Z72GamblingAndBetting = ''
                    this.numberofAssessmentVisits = ''
                    this.age = ''
                    this.sexualOrientation = ''
                    this.genderIdentity = ''
                    this.transgender = ''
                    this.asianOrigin = ''
                    this.pacificIslanderOrigin = ''
                    this.developmentalDisability = ''
                    this.coexistingPsychiatricDisorder = ''
                    this.treatedForMentalIllness = ''
                    this.hospitalizedForMentalIllness = ''
                    this.hospitalized30OrMoreDaysForMentalIllness = ''
                    this.smokedTobaccoInThePastWeek = ''
                    this.usedSmokelessTobaccoInThePastWeek = ''
                    this.substancesUsed = ''
                    this.substanceUseRouteOfAdministration = ''
                    this.frequencyOfSubstanceUse = ''
                    this.ageOfFirstSubstanceUse = ''
                    this.locadtrg = ''
                    this.LOCADTRAssessmentID = ''
                    this.dateOfBirthAdmission = ''
                    this.sexAtBirth = ''
                    this.last4SSN = ''
                    this.firstTwoLettersLastName = ''
                    this.frequencyofGambling = ''
                    this.ageFirstGambled = ''
                    this.past30DaysAmountOfMoney = ''
                    this.past30DaysHowMuchTime = ''
                    this.past30DaysHowManyDays = ''
                    this.gamblinglocationspast12months = ''
                    this.hasClientAttendedReceivedServices = ''
                    this.legalSystem = ''
                    // this.referralOptions = ''
                    // this.OASASProgram = ''
                    // this.OASASProgramOptInpatient = ''
                    // this.OASASProgramOptResidential = ''
                    // this.OASASProgramOptOutpatient = ''
                    // this.privatePractitioner = ''
                    // this.recoverySupportServices = ''
                    // this.inThePastFewMonthsDrinks = ''
                    // this.referredBy = ''
                    // this.familyMemberSelf = ''
                    // this.problemGamblingSelfHelpGroupMeetings = ''
                    // this.problemGamblingTreatmentServices = ''
                    // this.substanceUseTreatmentServices = ''
                    // this.recoverySupportServices = ''
                    // this.otherReferredBy = ''
                    // this.warmTransfer = ''
                    // this.notesAdmission = ''
                    // this.removeRecordAdmissionData = true
                    this.referralrecoverySupportServices = ''
                    this.admissionrecoverySupportServices = ''
                    this.admissionproblemGamblingTreatmentServices = ''
                    this.admissionsubstanceUseTreatmentServices = ''

                    db.collection('clientsActivity').doc(this.idClientActivity).update({
                        removeRecordAdmissionData: true,
                        activityStatus: 'Engaged',
                        dateOfAdmission: null,
                        newOrReturningClient: '',
                        clientStatusAdmission: '',
                        presentingProblemsAtAdmission: '',
                        otherProblemsAdmission: '',
                        diagnosticCriteriaMetAtAdmission: '',
                        clientInvolvedWithLegalSystem: '',
                        clientReleaseSigned: '',
                        referredByAdmission: '',
                        familyMemberSelfAdmission: '',
                        problemGamblingTreatmentServicesAdmission: '',
                        problemGamblingSelfHelpGroupMeetingsAdmission: '',
                        substanceUseTreatmentServicesAdmission: '',
                        recoverySupportServicesAdmission: '',
                        otherReferredByAdmission: '',
                        warmTransferAdmission: '',
                        race: '',
                        householdIncome: '',
                        gamblingTypes: '',
                        employmentStatus: '',
                        educationLevels: '',
                        ethnicity: '',
                        veteran: '',
                        zipCode: '',
                        industryOfEmployment: '',
                        maritalStatus: '',
                        religiousPreference: '',
                        primaryICD10: '',
                        Z72GamblingAndBetting: '',
                        numberofAssessmentVisits: '',
                        age: '',
                        sexualOrientation: '',
                        genderIdentity: '',
                        transgender: '',
                        asianOrigin: '',
                        pacificIslanderOrigin: '',
                        developmentalDisability: '',
                        coexistingPsychiatricDisorder: '',
                        treatedForMentalIllness: '',
                        hospitalizedForMentalIllness: '',
                        hospitalized30OrMoreDaysForMentalIllness: '',
                        smokedTobaccoInThePastWeek: '',
                        usedSmokelessTobaccoInThePastWeek: '',
                        substancesUsed: '',
                        substanceUseRouteOfAdministration: '',
                        frequencyOfSubstanceUse: '',
                        ageOfFirstSubstanceUse: '',
                        // referralOptions: '',
                        // OASASProgram: '',
                        // OASASProgramOptInpatient: '',
                        // OASASProgramOptResidential: '',
                        // OASASProgramOptOutpatient: '',
                        // privatePractitioner: '',
                        // recoverySupportServices: '',
                        // inThePastFewMonthsDrinks: '',
                        // referredBy: '',
                        // familyMemberSelf: '',
                        // problemGamblingSelfHelpGroupMeetings: '',
                        // problemGamblingTreatmentServices: '',
                        // substanceUseTreatmentServices: '',
                        // recoverySupportServices: '',
                        // otherReferredBy: '',
                        // warmTransfer: '',
                        referralrecoverySupportServices: '',
                        admissionrecoverySupportServices: '',
                        admissionproblemGamblingTreatmentServices: '',
                        admissionsubstanceUseTreatmentServices: '',
                        locadtrg: '',
                        LOCADTRAssessmentID: '',
                        dateOfBirthAdmission: '',
                        sexAtBirth: '',
                        last4SSN: '',
                        firstTwoLettersLastName: '',
                        frequencyofGambling: '',
                        ageFirstGambled: '',
                        past30DaysAmountOfMoney: '',
                        past30DaysHowMuchTime: '',
                        past30DaysHowManyDays: '',
                        gamblinglocationspast12months: '',
                        hasClientAttendedReceivedServices: '',
                        legalSystem: '',
                        notesAdmission: '',
                        enterAdmissionInformation: false,
                        draf: Date.now()
                    })
                    .then(() => {
                        this.$swal({
                            icon: 'success',
                            title: 'Deleted!',
                            text: 'The record has been deleted.',
                            customClass: {
                                confirmButton: 'btn btn-success',
                            },
                        })
                        if(!this.dateOfDischarge) {
                            this.enterAdmissionInformation = false
                        }

                        if(this.activityStatus.includes('Closed')) {
                            this.activityStatus = 'Engaged'
                        }
                        this.removeRecordAdmissionData =  false
                        this.removeRecordDischargeData = false
                    })
                }
            })
        },
        removeRecordDischarge() {
            this.$swal({
                title: 'Remove',
                text: "Are you sure you want to delete this Discharge record?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1 cancelBtn-modal',
                },
                buttonsStyling: false,
            }).then(result => {
                if(result.value) {
                    // discharge form
                    this.dateOfDischarge = null
                    this.dischargeStatus = ''
                    this.plannedDischargeReasons = ''
                    this.unplannedDischargeReason = ''
                    this.numberOfSessionsAttended = null
                    this.dischargeDisposition = ''
                    this.referralDisposition = ''
                    this.diagnosticCriteriaMetAtAdmissionWasReduced = ''
                    this.diagnosticCriteriaMetAtDischarge = ''
                    this.goalsMet = ''
                    this.currentGamblingComparedToAdmission = ''
                    this.clientInvolvedWithSelfHelpAtDischarge = ''
                    this.clientReferredForContinuedServices = ''
                    this.ifSoWhatServicesWereRecommended = ''
                    this.relatedProblemsGambling = ''
                    this.relatedProblemsDrugUse = ''
                    this.relatedProblemsAlcoholUse = ''
                    this.relatedProblemsFinancial = ''
                    this.relatedProblemsLegal = ''
                    this.relatedProblemsVocationalEducational = ''
                    this.relatedProblemsMedicalHealth = ''
                    this.relatedProblemsLethalitySelf = ''
                    this.relatedProblemsLethalityOther = ''
                    this.relatedProblemsMentalHealth = ''
                    this.relatedProblemsFamily = ''
                    this.notesDischarge = ''
                    // this.removeRecordDischargeData = true

                    db.collection('clientsActivity').doc(this.idClientActivity).update({
                        dateOfDischarge: null,
                        dischargeStatus: '',
                        plannedDischargeReasons: '',
                        unplannedDischargeReason: '',
                        numberOfSessionsAttended: null,
                        dischargeDisposition: '',
                        referralDisposition: '',
                        diagnosticCriteriaMetAtAdmissionWasReduced: '',
                        diagnosticCriteriaMetAtDischarge: '',
                        goalsMet: '',
                        currentGamblingComparedToAdmission: '',
                        clientInvolvedWithSelfHelpAtDischarge: '',
                        clientReferredForContinuedServices: '',
                        ifSoWhatServicesWereRecommended: '',
                        relatedProblemsGambling: '',
                        relatedProblemsDrugUse: '',
                        relatedProblemsAlcoholUse: '',
                        relatedProblemsFinancial: '',
                        relatedProblemsLegal: '',
                        relatedProblemsVocationalEducational: '',
                        relatedProblemsMedicalHealth: '',
                        relatedProblemsLethalitySelf: '',
                        relatedProblemsLethalityOther: '',
                        relatedProblemsMentalHealth: '',
                        relatedProblemsFamily: '',
                        notesDischarge: '',
                        removeRecordDischargeData: true,
                        activityStatus: 'Engaged',
                        enterDischargeInformation: false,
                        drdf: Date.now()
                    })
                    .then(() => {
                        this.$swal({
                            icon: 'success',
                            title: 'Deleted!',
                            text: 'The record has been deleted.',
                            customClass: {
                                confirmButton: 'btn btn-success',
                            },
                        })
                        if(!this.dateOfAdmission) {
                            this.enterDischargeInformation = false
                        }

                        if(this.activityStatus.includes('Closed')) {
                            this.activityStatus = 'Engaged'
                        }
                    })
                }
            })
        }
    },
    created() {
        window.addEventListener('resize', this.initTrHeight)
        this.requiredDischargeForm = false
        this.isClinicianStaff = false
        this.logicisClientInsured = false
        this.logicisClientMatchedToaClinicianWhoAcceptsTheirInsurance = false
        this.logicisTheClinicianBillingTheClientsInsurance = false
        this.logicisTheClinicianBillingTheClientsInsuranceOptionYes = false
        this.counterChangesActivityStatus = 0
        var user = auth.currentUser
        db.collection('usuarios').doc(user.uid).get()
        .then(userDoc => {
            // this.isDataSpecialist = false
            // if(userDoc.data().role === 'staff') {
            //     if(userDoc.data().permissions.includes('data specialist')) {
            //         this.isDataSpecialist = true
            //     }
            // }
            

            if(userDoc.data().role === 'admin') {
                this.isAdmin = true
                this.adminOrManageUsers = true
            } else if(userDoc.data().role === 'staff') {
                this.staffOrClinician = true
                if(userDoc.data().permissions.includes('manage users') || userDoc.data().permissions.includes('program manager - vse')) {
                    this.adminOrManageUsers = true
                } else if(userDoc.data().permissions.includes('program manager - pa')) {
                    this.managerPA = true
                } else if(userDoc.data().permissions.includes('program manager peer supervisor')) {
                    this.managerPeerSupervisor = true
                } else if(userDoc.data().permissions.includes('data specialist')) {
                    this.dataSpecialist = true
                } else if(userDoc.data().permissions.includes('clinician viewer')) {
                    this.clinicianOrClinicianViewer = true
                } else {
                    this.clinicianOrClinicianViewer = true
                }
            } else if(userDoc.data().role === 'clinician' || userDoc.data().role === 'clinician-staff') {
                userDoc.data().role === 'clinician-staff' ? this.staffOrClinician = true : null
                // this.staffOrClinician = true
                this.clinicianUsers = true
            }

            if(userDoc.data().role === 'clinician-staff') {
                this.isClinicianStaff = true
                // db.collection('usuarios').doc(userDoc.data().dependency).get()
                // .then(doc => {
                    this.userData = userDoc.data()
                // })
            } else {
                this.userData = userDoc.data()
            }
        })

        db.collection('taxonomies').doc('vse').get()
        .then(docTaxonomia => {
            this.optionsFinalStatusVSE = docTaxonomia.data().FinalStatusVSE
            // this.optionsStaffMemberCompletingFormVSE = docTaxonomia.data().StaffMemberCompletingFormVSE
            this.optionsGenderVSE = docTaxonomia.data().GenderVSE
            this.optionsConnectedToPGRCVSE = docTaxonomia.data().ConnectedToPGRCVSE
            this.optionsInterventionStatusVSE = docTaxonomia.data().InterventionStatusVSE
            this.optionsPendingVSE = docTaxonomia.data().PendingVSE
            this.optionsVSETimeframe = docTaxonomia.data().VSETimeframe
            this.optionsReferredByVSE = docTaxonomia.data().referralSourceVSE
            this.optionsGamblingTypesVSE = docTaxonomia.data().typesOfGamblingEngagedInVSE
        })

        this.optionsStaffMemberCompletingFormVSE = []
        this.peerStaffOptions = []
        db.collection('usuarios').where('role', 'in', ['staff', 'admin']).get()
        .then(docsClinicians => {
            docsClinicians.forEach(ele => {
                if((ele.data().permissions.includes('program manager - vse') && ele.data().role === 'staff') || ele.id === 'A26LWS3DwRR7cByPOij0F4If4en2') {
                    this.optionsStaffMemberCompletingFormVSE.push({uid: ele.id, name: ele.data().firstName + ' ' + ele.data().lastName})
                }

                if((ele.data().permissions.includes('program manager peer supervisor') || ele.data().permissions.includes('program manager - pa')) && ele.data().role === 'staff') {
                    this.peerStaffOptions.push({uid: ele.id, name: ele.data().firstName + ' ' + ele.data().lastName})
                }
            })
        })

        db.collection('taxonomies').doc('client').get()
        .then(docTaxonomia => {
            this.optionsRace = docTaxonomia.data().race
            this.optionsHouseholdIncome = docTaxonomia.data().householdIncome
            this.optionsGamblingTypes = docTaxonomia.data().gamblingTypes
            this.optionsEmploymentStatus = docTaxonomia.data().employmentStatus
            this.optionsEducationLevels = docTaxonomia.data().educationLevels
            this.optionsReferralOptions = docTaxonomia.data().referralOptions
            this.optionsRecoverySupportServices = docTaxonomia.data().recoverySupportServices

            this.optionsPaymentArrangement = docTaxonomia.data().paymentArrangement && docTaxonomia.data().paymentArrangement.length ? docTaxonomia.data().paymentArrangement : []
            var AtomConditionsPArrangement = docTaxonomia.data().conditionsPArrangement && docTaxonomia.data().conditionsPArrangement.length ? docTaxonomia.data().conditionsPArrangement : []
            AtomConditionsPArrangement.forEach(ele => {
                if(ele.cond && ele.label) {
                    this.conditionsPArrangement.push(ele)
                }
            })
        })

        db.collection('taxonomies').doc('clinician').get()
        .then(docTaxonomia => {
            // profile fields
            this.optionsRegionalCFEReceivingTheCall = docTaxonomia.data().region
        })
        // console.log(this.idClientActivity)
        
        db.collection('clientsActivity').doc(this.idClientActivity).get()
        .then(dataClient => {
            if(dataClient.exists) {
                db.collection('usuarios').get()
                .then(docsClinicians => {
                    // db.collection('clients').get()
                    // .then(docsClients => {
                        // get clinician
                        var objClinician = []
                        var concatClinician = ''
                        // console.log(dataClient.data().clinician)
                        if(dataClient.data().clinician.length >= 1) {
                            dataClient.data().clinician.forEach(activityClinician => {
                                docsClinicians.forEach(item => {
                                    if(activityClinician === item.id) {
                                        concatClinician = concatClinician.concat(' - ', item.id)
                                        var obj = item.data()
                                        obj.agencyAndName = item.data().firstName + ' ' + item.data().lastName + ' · ' + item.data().agency  + ' (#' + item.data().codigo + ')'
                                        objClinician.push(obj)
                                    }
                                })
                            })
                        }
                        // console.log('second')

                        // get client
                        var objClient = dataClient.data().client
                        // var objClient = dataClient.data().client
                            // console.log(dataClient.data().client)
                        // if(dataClient.data().client) {
                        //     docsClients.forEach(item => {
                        //         if(dataClient.data().client === item.id) {
                        //             objClient = item.data()
                        //         }
                        //     })
                        // }

                        // get data
                        this.clinician = objClinician
                        this.dateOfContact = dataClient.data().dateOfContact
                        this.methodOfContact = dataClient.data().methodOfContact
                        this.contactStatus = dataClient.data().contactStatus
                        this.referredBy = dataClient.data().referredBy
                        this.familyMemberSelf = dataClient.data().familyMemberSelf ? dataClient.data().familyMemberSelf : ''
                        this.problemGamblingSelfHelpGroupMeetings = dataClient.data().problemGamblingSelfHelpGroupMeetings ? dataClient.data().problemGamblingSelfHelpGroupMeetings : ''
                        this.problemGamblingTreatmentServices = dataClient.data().problemGamblingTreatmentServices ? dataClient.data().problemGamblingTreatmentServices : ''
                        this.substanceUseTreatmentServices = dataClient.data().substanceUseTreatmentServices ? dataClient.data().substanceUseTreatmentServices : ''
                        this.recoverySupportServices = dataClient.data().recoverySupportServices ? dataClient.data().recoverySupportServices : ''
                        this.otherReferredBy = dataClient.data().otherReferredBy
                        this.warmTransfer = dataClient.data().warmTransfer ? dataClient.data().warmTransfer : ''
                        this.initialAppointmentDate = dataClient.data().initialAppointmentDate
                        this.time = dataClient.data().time
                        this.wasTheCallHelpful = dataClient.data().wasTheCallHelpful
                        this.wasTheCallHelpfulIfNotWhy = dataClient.data().wasTheCallHelpfulIfNotWhy ? dataClient.data().wasTheCallHelpfulIfNotWhy : ''
                        this.informationKitAccepted = dataClient.data().informationKitAccepted
                        this.informationKitOption = dataClient.data().informationKitOption ? dataClient.data().informationKitOption : ''
                        this.regionalCFEReceivingTheCall = dataClient.data().regionalCFEReceivingTheCall
                        this.referredToPeerAdvocate = dataClient.data().referredToPeerAdvocate ? dataClient.data().referredToPeerAdvocate : ''
                        this.borough = dataClient.data().borough ? dataClient.data().borough : ''
                        this.readmission = dataClient.data().readmission
                        this.race = dataClient.data().race ? dataClient.data().race : ''
                        this.householdIncome = dataClient.data().householdIncome ? dataClient.data().householdIncome : ''
                        this.gamblingTypes = dataClient.data().gamblingTypes ? dataClient.data().gamblingTypes : ''
                        this.employmentStatus = dataClient.data().employmentStatus ? dataClient.data().employmentStatus : ''
                        this.educationLevels = dataClient.data().educationLevels ? dataClient.data().educationLevels : ''
                        this.ethnicity = dataClient.data().ethnicity ? dataClient.data().ethnicity : ''
                        this.veteran = dataClient.data().veteran ? dataClient.data().veteran : ''
                        this.zipCode = dataClient.data().zipCode ? dataClient.data().zipCode : ''
                        this.industryOfEmployment = dataClient.data().industryOfEmployment ? dataClient.data().industryOfEmployment : ''
                        this.maritalStatus = dataClient.data().maritalStatus ? dataClient.data().maritalStatus : ''
                        this.religiousPreference = dataClient.data().religiousPreference ? dataClient.data().religiousPreference : ''
                        this.connectedToPeerAdvocate = dataClient.data().connectedToPeerAdvocate ? dataClient.data().connectedToPeerAdvocate : ''
                        this.connectedToVSE = dataClient.data().connectedToVSE ? dataClient.data().connectedToVSE : ''
                        this.connectedToPeerEducationGroup = dataClient.data().connectedToPeerEducationGroup ? dataClient.data().connectedToPeerEducationGroup : ''
                        this.connectedToFamilyEducationGroup = dataClient.data().connectedToFamilyEducationGroup ? dataClient.data().connectedToFamilyEducationGroup : ''
                        this.connectedToAsianServicesProgram = dataClient.data().connectedToAsianServicesProgram ? dataClient.data().connectedToAsianServicesProgram : ''
                        this.connectedToGamFin = dataClient.data().connectedToGamFin ? dataClient.data().connectedToGamFin : ''
                        this.referralrecoverySupportServices = dataClient.data().referralrecoverySupportServices ? dataClient.data().referralrecoverySupportServices : ''
                        this.admissionrecoverySupportServices = dataClient.data().admissionrecoverySupportServices ? dataClient.data().admissionrecoverySupportServices : ''
                        this.admissionproblemGamblingTreatmentServices = dataClient.data().admissionproblemGamblingTreatmentServices ? dataClient.data().admissionproblemGamblingTreatmentServices : ''
                        this.admissionsubstanceUseTreatmentServices = dataClient.data().admissionsubstanceUseTreatmentServices ? dataClient.data().admissionsubstanceUseTreatmentServices : ''
                        // enter adminission/discharge information
                        this.enterAdmissionDischargeInformation = dataClient.data().enterAdmissionDischargeInformation
                        this.enterAdmissionInformation = dataClient.data().enterAdmissionInformation === undefined ? dataClient.data().enterAdmissionDischargeInformation : dataClient.data().enterAdmissionInformation ? dataClient.data().enterAdmissionInformation : false
                        this.enterDischargeInformation = dataClient.data().enterDischargeInformation === undefined ? dataClient.data().enterAdmissionDischargeInformation : dataClient.data().enterDischargeInformation ? dataClient.data().enterDischargeInformation : false
                        this.enterSurveyInformation = dataClient.data().enterSurveyInformation ? dataClient.data().enterSurveyInformation : false
                        // admission form
                        this.dateOfAdmission = dataClient.data().dateOfAdmission
                        this.newOrReturningClient = dataClient.data().newOrReturningClient
                        this.clientStatusAdmission = dataClient.data().clientStatusAdmission ? dataClient.data().clientStatusAdmission : ''
                        this.presentingProblemsAtAdmission = dataClient.data().presentingProblemsAtAdmission
                        this.diagnosticCriteriaMetAtAdmission = dataClient.data().diagnosticCriteriaMetAtAdmission
                        this.otherProblemsAdmission = dataClient.data().otherProblemsAdmission
                        this.clientInvolvedWithLegalSystem = dataClient.data().clientInvolvedWithLegalSystem
                        this.clientReleaseSigned = dataClient.data().clientReleaseSigned
                        this.referredByAdmission = dataClient.data().referredByAdmission ? dataClient.data().referredByAdmission : ''
                        this.familyMemberSelfAdmission = dataClient.data().familyMemberSelfAdmission ? dataClient.data().familyMemberSelfAdmission : ''
                        this.problemGamblingTreatmentServicesAdmission = dataClient.data().problemGamblingTreatmentServicesAdmission ? dataClient.data().problemGamblingTreatmentServicesAdmission : ''
                        this.problemGamblingSelfHelpGroupMeetingsAdmission = dataClient.data().problemGamblingSelfHelpGroupMeetingsAdmission ? dataClient.data().problemGamblingSelfHelpGroupMeetingsAdmission : ''
                        this.substanceUseTreatmentServicesAdmission = dataClient.data().substanceUseTreatmentServicesAdmission ? dataClient.data().substanceUseTreatmentServicesAdmission : ''
                        this.recoverySupportServicesAdmission = dataClient.data().recoverySupportServicesAdmission ? dataClient.data().recoverySupportServicesAdmission : ''
                        this.otherReferredByAdmission = dataClient.data().otherReferredByAdmission ? dataClient.data().otherReferredByAdmission : ''
                        this.warmTransferAdmission = dataClient.data().warmTransferAdmission ? dataClient.data().warmTransferAdmission : ''
                        this.primaryICD10 = dataClient.data().primaryICD10 ? dataClient.data().primaryICD10 : ''
                        this.Z72GamblingAndBetting = dataClient.data().Z72GamblingAndBetting ? dataClient.data().Z72GamblingAndBetting : ''
                        this.numberofAssessmentVisits = dataClient.data().numberofAssessmentVisits ? dataClient.data().numberofAssessmentVisits : ''
                        this.age = dataClient.data().age ? dataClient.data().age : ''
                        this.sexualOrientation = dataClient.data().sexualOrientation ? dataClient.data().sexualOrientation : ''
                        this.genderIdentity = dataClient.data().genderIdentity ? dataClient.data().genderIdentity : ''
                        this.transgender = dataClient.data().transgender ? dataClient.data().transgender : ''
                        this.asianOrigin = dataClient.data().asianOrigin ? dataClient.data().asianOrigin : ''
                        this.pacificIslanderOrigin = dataClient.data().pacificIslanderOrigin ? dataClient.data().pacificIslanderOrigin : ''
                        this.developmentalDisability = dataClient.data().developmentalDisability ? dataClient.data().developmentalDisability : ''
                        this.coexistingPsychiatricDisorder = dataClient.data().coexistingPsychiatricDisorder ? dataClient.data().coexistingPsychiatricDisorder : ''
                        this.treatedForMentalIllness = dataClient.data().treatedForMentalIllness ? dataClient.data().treatedForMentalIllness : ''
                        this.hospitalizedForMentalIllness = dataClient.data().hospitalizedForMentalIllness ? dataClient.data().hospitalizedForMentalIllness : ''
                        this.hospitalized30OrMoreDaysForMentalIllness = dataClient.data().hospitalized30OrMoreDaysForMentalIllness ? dataClient.data().hospitalized30OrMoreDaysForMentalIllness : ''
                        this.smokedTobaccoInThePastWeek = dataClient.data().smokedTobaccoInThePastWeek ? dataClient.data().smokedTobaccoInThePastWeek : ''
                        this.usedSmokelessTobaccoInThePastWeek = dataClient.data().usedSmokelessTobaccoInThePastWeek ? dataClient.data().usedSmokelessTobaccoInThePastWeek : ''
                        this.substancesUsed = dataClient.data().substancesUsed ? dataClient.data().substancesUsed : ''
                        this.substanceUseRouteOfAdministration = dataClient.data().substanceUseRouteOfAdministration ? dataClient.data().substanceUseRouteOfAdministration : ''
                        this.frequencyOfSubstanceUse = dataClient.data().frequencyOfSubstanceUse ? dataClient.data().frequencyOfSubstanceUse : ''
                        this.ageOfFirstSubstanceUse = dataClient.data().ageOfFirstSubstanceUse ? dataClient.data().ageOfFirstSubstanceUse : ''
                        this.inThePastFewMonthsDrinks = dataClient.data().inThePastFewMonthsDrinks ? dataClient.data().inThePastFewMonthsDrinks : ''
                        this.referralOptions = dataClient.data().referralOptions ? dataClient.data().referralOptions : ''
                        this.OASASProgram = dataClient.data().OASASProgram ? dataClient.data().OASASProgram : ''
                        this.OASASProgramOptInpatient = dataClient.data().OASASProgramOptInpatient ? dataClient.data().OASASProgramOptInpatient : ''
                        this.OASASProgramOptResidential = dataClient.data().OASASProgramOptResidential ? dataClient.data().OASASProgramOptResidential : ''
                        this.OASASProgramOptOutpatient = dataClient.data().OASASProgramOptOutpatient ? dataClient.data().OASASProgramOptOutpatient : ''
                        this.privatePractitioner = dataClient.data().privatePractitioner ? dataClient.data().privatePractitioner : ''
                        this.recoverySupportServices = dataClient.data().recoverySupportServices ? dataClient.data().recoverySupportServices : ''
                        this.recoveryCommunityOutreachCenter = dataClient.data().recoveryCommunityOutreachCenter ? dataClient.data().recoveryCommunityOutreachCenter : ''
                        this.youthClubhouse = dataClient.data().youthClubhouse ? dataClient.data().youthClubhouse : ''
                        this.peerAdvocate = dataClient.data().peerAdvocate ? dataClient.data().peerAdvocate : ''
                        this.openAccessCenter = dataClient.data().openAccessCenter ? dataClient.data().openAccessCenter : ''
                        this.familyNavigator = dataClient.data().familyNavigator ? dataClient.data().familyNavigator : ''
                        this.regionalAddictionResourceCenter = dataClient.data().regionalAddictionResourceCenter ? dataClient.data().regionalAddictionResourceCenter : ''
                        this.locadtrg = dataClient.data().locadtrg ? dataClient.data().locadtrg : ''
                        this.LOCADTRAssessmentID = dataClient.data().LOCADTRAssessmentID ? dataClient.data().LOCADTRAssessmentID : ''
                        this.dateOfBirthAdmission = dataClient.data().dateOfBirthAdmission ? dataClient.data().dateOfBirthAdmission : ''
                        this.sexAtBirth = dataClient.data().sexAtBirth ? dataClient.data().sexAtBirth : ''
                        this.last4SSN = dataClient.data().last4SSN ? dataClient.data().last4SSN : ''
                        this.firstTwoLettersLastName = dataClient.data().firstTwoLettersLastName ? dataClient.data().firstTwoLettersLastName : ''
                        this.frequencyofGambling = dataClient.data().frequencyofGambling ? dataClient.data().frequencyofGambling : ''
                        this.ageFirstGambled = dataClient.data().ageFirstGambled ? dataClient.data().ageFirstGambled : ''
                        this.past30DaysAmountOfMoney = dataClient.data().past30DaysAmountOfMoney ? dataClient.data().past30DaysAmountOfMoney : ''
                        this.past30DaysHowMuchTime = dataClient.data().past30DaysHowMuchTime ? dataClient.data().past30DaysHowMuchTime : ''
                        this.past30DaysHowManyDays = dataClient.data().past30DaysHowManyDays ? dataClient.data().past30DaysHowManyDays : ''
                        this.gamblinglocationspast12months = dataClient.data().gamblinglocationspast12months ? dataClient.data().gamblinglocationspast12months : ''
                        this.hasClientAttendedReceivedServices = dataClient.data().hasClientAttendedReceivedServices ? dataClient.data().hasClientAttendedReceivedServices : ''
                        this.legalSystem = dataClient.data().legalSystem ? dataClient.data().legalSystem : ''
                        this.notesAdmission = dataClient.data().notesAdmission
                        // discharge form
                        this.dateOfDischarge = dataClient.data().dateOfDischarge
                        this.dischargeStatus = dataClient.data().dischargeStatus
                        this.plannedDischargeReasons = dataClient.data().plannedDischargeReasons
                        this.unplannedDischargeReason = dataClient.data().unplannedDischargeReason
                        this.numberOfSessionsAttended = dataClient.data().numberOfSessionsAttended
                        this.dischargeDisposition = dataClient.data().dischargeDisposition ? dataClient.data().dischargeDisposition : ''
                        this.referralDisposition = dataClient.data().referralDisposition ? dataClient.data().referralDisposition : ''
                        this.diagnosticCriteriaMetAtAdmissionWasReduced = dataClient.data().diagnosticCriteriaMetAtAdmissionWasReduced
                        this.diagnosticCriteriaMetAtDischarge = dataClient.data().diagnosticCriteriaMetAtDischarge ? dataClient.data().diagnosticCriteriaMetAtDischarge : ''
                        this.goalsMet = dataClient.data().goalsMet
                        this.currentGamblingComparedToAdmission = dataClient.data().currentGamblingComparedToAdmission
                        this.clientInvolvedWithSelfHelpAtDischarge = dataClient.data().clientInvolvedWithSelfHelpAtDischarge
                        this.clientReferredForContinuedServices = dataClient.data().clientReferredForContinuedServices
                        this.ifSoWhatServicesWereRecommended = dataClient.data().ifSoWhatServicesWereRecommended
                        this.relatedProblemsGambling = dataClient.data().relatedProblemsGambling ? dataClient.data().relatedProblemsGambling : ''
                        this.relatedProblemsDrugUse = dataClient.data().relatedProblemsDrugUse ? dataClient.data().relatedProblemsDrugUse : ''
                        this.relatedProblemsAlcoholUse = dataClient.data().relatedProblemsAlcoholUse ? dataClient.data().relatedProblemsAlcoholUse : ''
                        this.relatedProblemsFinancial = dataClient.data().relatedProblemsFinancial ? dataClient.data().relatedProblemsFinancial : ''
                        this.relatedProblemsLegal = dataClient.data().relatedProblemsLegal ? dataClient.data().relatedProblemsLegal : ''
                        this.relatedProblemsVocationalEducational = dataClient.data().relatedProblemsVocationalEducational ? dataClient.data().relatedProblemsVocationalEducational : ''
                        this.relatedProblemsMedicalHealth = dataClient.data().relatedProblemsMedicalHealth ? dataClient.data().relatedProblemsMedicalHealth : ''
                        this.relatedProblemsLethalitySelf = dataClient.data().relatedProblemsLethalitySelf ? dataClient.data().relatedProblemsLethalitySelf : ''
                        this.relatedProblemsLethalityOther = dataClient.data().relatedProblemsLethalityOther ? dataClient.data().relatedProblemsLethalityOther : ''
                        this.relatedProblemsMentalHealth = dataClient.data().relatedProblemsMentalHealth ? dataClient.data().relatedProblemsMentalHealth : ''
                        this.relatedProblemsFamily = dataClient.data().relatedProblemsFamily ? dataClient.data().relatedProblemsFamily : ''
                        this.notesDischarge = dataClient.data().notesDischarge
                        // survey
                        this.isClientInsured = dataClient.data().isClientInsured ? dataClient.data().isClientInsured : ''
                        this.isClientMatchedToaClinicianWhoAcceptsTheirInsurance = dataClient.data().isClientMatchedToaClinicianWhoAcceptsTheirInsurance ? dataClient.data().isClientMatchedToaClinicianWhoAcceptsTheirInsurance : ''
                        this.isTheClinicianBillingTheClientsInsurance = dataClient.data().isTheClinicianBillingTheClientsInsurance ? dataClient.data().isTheClinicianBillingTheClientsInsurance : ''
                        this.whyInsuranceWasNotBilled = dataClient.data().whyInsuranceWasNotBilled ? dataClient.data().whyInsuranceWasNotBilled : ''
                        this.whyInsuranceWasNotBilledOther = dataClient.data().whyInsuranceWasNotBilledOther ? dataClient.data().whyInsuranceWasNotBilledOther : ''
                        this.reasonWhyClientWasReferredToClinician = dataClient.data().reasonWhyClientWasReferredToClinician ? dataClient.data().reasonWhyClientWasReferredToClinician : ''
                        this.reasonWhyClientWasReferredToClinicianOther = dataClient.data().reasonWhyClientWasReferredToClinicianOther ? dataClient.data().reasonWhyClientWasReferredToClinicianOther : ''
                        this.itemsFormRepeater = dataClient.data().paymentInsuranceUtilizationForm && dataClient.data().paymentInsuranceUtilizationForm.length ? dataClient.data().paymentInsuranceUtilizationForm : []

                        this.enterPeerServicesForm = dataClient.data().enterPeerServicesForm ? dataClient.data().enterPeerServicesForm : false
                        this.contactDate = dataClient.data().contactDate ? dataClient.data().contactDate : ''
                        this.peerCompleting = dataClient.data().peerCompleting ? dataClient.data().peerCompleting : null
                        this.peerAssigned = dataClient.data().peerAssigned ? dataClient.data().peerAssigned : null
                        this.peerCompletingSaved = dataClient.data().peerCompleting ? dataClient.data().peerCompleting : null
                        this.peerAssignedSaved = dataClient.data().peerAssigned ? dataClient.data().peerAssigned : null
                        this.clientType = dataClient.data().clientType ? dataClient.data().clientType : null
                        this.pifClientStatus = dataClient.data().pifClientStatus ? dataClient.data().pifClientStatus : null
                        this.referralSource = dataClient.data().referralSource ? dataClient.data().referralSource : null
                        this.warmTransferPeer = dataClient.data().warmTransferPeer ? dataClient.data().warmTransferPeer : null
                        this.familyReferralType = dataClient.data().familyReferralType ? dataClient.data().familyReferralType : null
                        this.selfHelpGroupType = dataClient.data().selfHelpGroupType ? dataClient.data().selfHelpGroupType : null
                        this.pgTreatmentType = dataClient.data().pgTreatmentType ? dataClient.data().pgTreatmentType : null
                        this.sudTreatmentType = dataClient.data().sudTreatmentType ? dataClient.data().sudTreatmentType : null
                        this.recoveryServiceType = dataClient.data().recoveryServiceType ? dataClient.data().recoveryServiceType : null
                        this.recoveryServiceDetails = dataClient.data().recoveryServiceDetails ? dataClient.data().recoveryServiceDetails : ''
                        this.serviceStatus = dataClient.data().serviceStatus ? dataClient.data().serviceStatus : []
                        this.previouslyAttendedTreatment = dataClient.data().previouslyAttendedTreatment ? dataClient.data().previouslyAttendedTreatment : []
                        this.prevPgInpatient = dataClient.data().prevPgInpatient ? dataClient.data().prevPgInpatient : ''
                        this.prevPgOutpatient = dataClient.data().prevPgOutpatient ? dataClient.data().prevPgOutpatient : ''
                        this.prevPgResidential = dataClient.data().prevPgResidential ? dataClient.data().prevPgResidential : ''
                        this.prevSudInpatient = dataClient.data().prevSudInpatient ? dataClient.data().prevSudInpatient : ''
                        this.prevSudOutpatient = dataClient.data().prevSudOutpatient ? dataClient.data().prevSudOutpatient : ''
                        this.prevSudResidential = dataClient.data().prevSudResidential ? dataClient.data().prevSudResidential : ''
                        this.currentlyAttendingTreatment = dataClient.data().currentlyAttendingTreatment ? dataClient.data().currentlyAttendingTreatment : []
                        this.currPgInpatient = dataClient.data().currPgInpatient ? dataClient.data().currPgInpatient : ''
                        this.currPgOutpatient = dataClient.data().currPgOutpatient ? dataClient.data().currPgOutpatient : ''
                        this.currPgResidential = dataClient.data().currPgResidential ? dataClient.data().currPgResidential : ''
                        this.currSudInpatient = dataClient.data().currSudInpatient ? dataClient.data().currSudInpatient : ''
                        this.currSudOutpatient = dataClient.data().currSudOutpatient ? dataClient.data().currSudOutpatient : ''
                        this.currSudResidential = dataClient.data().currSudResidential ? dataClient.data().currSudResidential : ''
                        this.previouslyUtilizedRecoveryServices = dataClient.data().previouslyUtilizedRecoveryServices ? dataClient.data().previouslyUtilizedRecoveryServices : []
                        this.prevRecoveryRcocName = dataClient.data().prevRecoveryRcocName ? dataClient.data().prevRecoveryRcocName : ''
                        this.currRecoveryTxtBoxRcocName = dataClient.data().currRecoveryTxtBoxRcocName ? dataClient.data().currRecoveryTxtBoxRcocName : ''
                        this.currentlyUtilizingRecoveryServices = dataClient.data().currentlyUtilizingRecoveryServices ? dataClient.data().currentlyUtilizingRecoveryServices : []
                        this.currRecoveryRcocName = dataClient.data().currRecoveryRcocName ? dataClient.data().currRecoveryRcocName : ''
                        this.previouslyUtilizedFinancialServices = dataClient.data().previouslyUtilizedFinancialServices ? dataClient.data().previouslyUtilizedFinancialServices : null
                        this.prevFinancialOther = dataClient.data().prevFinancialOther ? dataClient.data().prevFinancialOther : ''
                        this.currentlyUtilizingFinancialServices = dataClient.data().currentlyUtilizingFinancialServices ? dataClient.data().currentlyUtilizingFinancialServices : null
                        this.currFinancialOther = dataClient.data().currFinancialOther ? dataClient.data().currFinancialOther : ''
                        this.presentingProblems = dataClient.data().presentingProblems ? dataClient.data().presentingProblems : []
                        this.otherProblems = dataClient.data().otherProblems ? dataClient.data().otherProblems : ''
                        this.legalInvolvement = dataClient.data().legalInvolvement ? dataClient.data().legalInvolvement : null
                        this.legalSystemType = dataClient.data().legalSystemType ? dataClient.data().legalSystemType : null
                        this.releaseSigned = dataClient.data().releaseSigned ? dataClient.data().releaseSigned : null
                        this.notes = dataClient.data().notes ? dataClient.data().notes : ''
                        this.race = dataClient.data().race ? dataClient.data().race : null
                        this.hispanicOrigin = dataClient.data().hispanicOrigin ? dataClient.data().hispanicOrigin : null
                        this.asianOrigin = dataClient.data().asianOrigin ? dataClient.data().asianOrigin : null
                        this.pacificIslanderOrigin = dataClient.data().pacificIslanderOrigin ? dataClient.data().pacificIslanderOrigin : null
                        this.householdIncome = dataClient.data().householdIncome ? dataClient.data().householdIncome : null
                        this.gamblingTypes = dataClient.data().gamblingTypes ? dataClient.data().gamblingTypes : []
                        this.employmentStatus = dataClient.data().employmentStatus ? dataClient.data().employmentStatus : null
                        this.highestGrade = dataClient.data().highestGrade ? dataClient.data().highestGrade : null
                        this.veteran = dataClient.data().veteran ? dataClient.data().veteran : null
                        this.zipCode = dataClient.data().zipCode ? dataClient.data().zipCode : ''
                        this.industry = dataClient.data().industry ? dataClient.data().industry : null
                        this.maritalStatus = dataClient.data().maritalStatus ? dataClient.data().maritalStatus : null
                        this.religiousPreference = dataClient.data().religiousPreference ? dataClient.data().religiousPreference : null
                        this.age = dataClient.data().age ? dataClient.data().age : null
                        this.sexualOrientation = dataClient.data().sexualOrientation ? dataClient.data().sexualOrientation : null
                        this.genderIdentity = dataClient.data().genderIdentity ? dataClient.data().genderIdentity : null
                        this.transgender = dataClient.data().transgender ? dataClient.data().transgender : null
                        this.gamblingFrequency = dataClient.data().gamblingFrequency ? dataClient.data().gamblingFrequency : null
                        this.ageFirstGambled = dataClient.data().ageFirstGambled ? dataClient.data().ageFirstGambled : ''
                        this.typicalAmount = dataClient.data().typicalAmount ? dataClient.data().typicalAmount : ''
                        this.typicalTime = dataClient.data().typicalTime ? dataClient.data().typicalTime : ''
                        this.daysGambled = dataClient.data().daysGambled ? dataClient.data().daysGambled : ''
                        this.gamblingLocations = dataClient.data().gamblingLocations ? dataClient.data().gamblingLocations : []
                        this.gamblingLocationOther = dataClient.data().gamblingLocationOther ? dataClient.data().gamblingLocationOther : ''

                        // goals form
                        this.enterPeerGoalForm = dataClient.data().enterPeerGoalForm ? dataClient.data().enterPeerGoalForm : false
                        this.pgfDate = dataClient.data().pgfDate ? dataClient.data().pgfDate : ''
                        this.pgfGoals = dataClient.data().pgfGoals ? dataClient.data().pgfGoals : ['']

                        // Peer Session Form
                        this.enterPeerSessionForm = dataClient.data().enterPeerSessionForm ? dataClient.data().enterPeerSessionForm : false
                        this.psfItemsFormRepeater = dataClient.data().psfItemsFormRepeater ? dataClient.data().psfItemsFormRepeater : []
                        this.psfNextId = dataClient.data().psfNextId ? dataClient.data().psfNextId : 2

                        // Peer Services Discharge Form
                        this.enterPeerServicesDischargeForm = dataClient.data().enterPeerServicesDischargeForm ? dataClient.data().enterPeerServicesDischargeForm : false
                        this.psdfDate = dataClient.data().psdfDate ? dataClient.data().psdfDate : ''
                        this.psdfStatus = dataClient.data().psdfStatus ? dataClient.data().psdfStatus : null
                        this.psdfDisposition = dataClient.data().psdfDisposition ? dataClient.data().psdfDisposition : []
                        this.psdfReferralDisposition = dataClient.data().psdfReferralDisposition ? dataClient.data().psdfReferralDisposition : []
                        this.psdfGamblingComparison = dataClient.data().psdfGamblingComparison ? dataClient.data().psdfGamblingComparison : null
                        this.psdfSelfHelp = dataClient.data().psdfSelfHelp ? dataClient.data().psdfSelfHelp : null
                        this.psdfContinuedServices = dataClient.data().psdfContinuedServices ? dataClient.data().psdfContinuedServices : []
                        this.psdfPgTreatment = dataClient.data().psdfPgTreatment ? dataClient.data().psdfPgTreatment : null
                        this.psdfSudTreatment = dataClient.data().psdfSudTreatment ? dataClient.data().psdfSudTreatment : null
                        this.psdfRecoveryServices = dataClient.data().psdfRecoveryServices ? dataClient.data().psdfRecoveryServices : []
                        this.psdfRecoveryRcoc = dataClient.data().psdfRecoveryRcoc ? dataClient.data().psdfRecoveryRcoc : ''
                        this.psdfRecoveryYouth = dataClient.data().psdfRecoveryYouth ? dataClient.data().psdfRecoveryYouth : ''
                        this.psdfRecoveryPeer = dataClient.data().psdfRecoveryPeer ? dataClient.data().psdfRecoveryPeer : ''
                        this.psdfRecoveryOpen = dataClient.data().psdfRecoveryOpen ? dataClient.data().psdfRecoveryOpen : ''
                        this.psdfRecoveryFamily = dataClient.data().psdfRecoveryFamily ? dataClient.data().psdfRecoveryFamily : ''
                        this.psdfRecoveryRegional = dataClient.data().psdfRecoveryRegional ? dataClient.data().psdfRecoveryRegional : ''
                        this.psdfRecoveryOther = dataClient.data().psdfRecoveryOther ? dataClient.data().psdfRecoveryOther : ''
                        this.psdfProblemGambling = dataClient.data().psdfProblemGambling ? dataClient.data().psdfProblemGambling : null
                        this.psdfProblemDrug = dataClient.data().psdfProblemDrug ? dataClient.data().psdfProblemDrug : null
                        this.psdfProblemAlcohol = dataClient.data().psdfProblemAlcohol ? dataClient.data().psdfProblemAlcohol : null
                        this.psdfProblemFinancial = dataClient.data().psdfProblemFinancial ? dataClient.data().psdfProblemFinancial : null
                        this.psdfProblemLegal = dataClient.data().psdfProblemLegal ? dataClient.data().psdfProblemLegal : null
                        this.psdfProblemVocational = dataClient.data().psdfProblemVocational ? dataClient.data().psdfProblemVocational : null
                        this.psdfProblemMedical = dataClient.data().psdfProblemMedical ? dataClient.data().psdfProblemMedical : null
                        this.psdfProblemLethalitySelf = dataClient.data().psdfProblemLethalitySelf ? dataClient.data().psdfProblemLethalitySelf : null
                        this.psdfProblemLethalityOther = dataClient.data().psdfProblemLethalityOther ? dataClient.data().psdfProblemLethalityOther : null
                        this.psdfProblemMental = dataClient.data().psdfProblemMental ? dataClient.data().psdfProblemMental : null
                        this.psdfProblemFamily = dataClient.data().psdfProblemFamily ? dataClient.data().psdfProblemFamily : null
                        this.pSNotes = dataClient.data().pSNotes ? dataClient.data().pSNotes : ''
                        // psdfSessionsAttended: '',
                        
                        // content right
                        this.specialIssuesOrOtherComments = dataClient.data().specialIssuesOrOtherComments
                        this.callNotes = dataClient.data().callNotes
                        this.activityStatus = dataClient.data().activityStatus
                        this.engagedStatus = dataClient.data().engagedStatus ? dataClient.data().engagedStatus : ''
                        this.closeNotes = dataClient.data().closeNotes
                        this.client = objClient

                        this.removeRecordAdmissionData = dataClient.data().removeRecordAdmissionData ? dataClient.data().removeRecordAdmissionData : false
                        this.removeRecordDischargeData = dataClient.data().removeRecordDischargeData ? dataClient.data().removeRecordDischargeData : false

                        if(this.dateOfAdmission && this.removeRecordDischargeData) {
                            db.collection('clientsActivity').doc(this.idClientActivity).update({
                                activityStatusLogical: 'Admitted'
                            })
                            .catch(error => console.log(error))

                            // update data client clientActivity
                            db.collection('clientsActivity').doc(this.idClientActivity).get()
                            .then(dataCA => {
                                var statusLogicOnHold = ''
                                if(dataCA.data().activityStatus === 'Closed - Referred to OASAS Program' && dataCA.data().referredToPeerAdvocate === 'No') {
                                    // statusLogical = 'Closed - Referred to OASAS Program'
                                    statusLogicOnHold = 'Closed - Referred to OASAS Program'
                                } else if((dataCA.data().activityStatus === 'Engaged' && (dataCA.data().engagedStatus === 'Referred to Clinician and Peer Advocate' || dataCA.data().engagedStatus === 'Referred to Peer Advocate')) || (dataCA.data().activityStatus === 'Closed - Referred to OASAS Program' && dataCA.data().referredToPeerAdvocate === 'Yes')) {
                                    if(dataCA.data().psdfDate) {
                                        // statusLogical = 'Discharged from peer services'
                                        statusLogicOnHold = dataCA.data().activityStatus === 'Closed - Referred to OASAS Program' && dataCA.data().referredToPeerAdvocate === 'Yes' ? 'Closed-Referred to OASAS Program and Discharged from Peer Services' : (dataCA.data().dateOfAdmission && dataCA.data().removeRecordDischargeData) ? 'Admitted and Discharged from Peer Services' : dataCA.data().dateOfAdmission && (!dataCA.data().dateOfDischarge || dataCA.data().dateOfDischarge === 'N/A') ? 'Admitted and Discharged from Peer Services' : dataCA.data().dateOfDischarge && dataCA.data().dateOfDischarge !== 'N/A' ? 'Discharged and Discharged from Peer Services' : dataCA.data().activityStatus === 'Closed - Referred to OASAS Program' && dataCA.data().referredToPeerAdvocate === 'Yes' ? 'Closed-Referred to OASAS Program and Discharged from Peer Services' : 'Discharged from peer services'
                                    } else {
                                        if(dataCA.data().dateOfAdmission && dataCA.data().removeRecordDischargeData) {
                                            statusLogicOnHold = dataCA.data().activityStatus === 'On Hold' ? 'Admitted (On Hold)' : 'Admitted'
                                        } else if(dataCA.data().dateOfAdmission && (!dataCA.data().dateOfDischarge || dataCA.data().dateOfDischarge === 'N/A')) {
                                            statusLogicOnHold = dataCA.data().activityStatus === 'On Hold' ? 'Admitted (On Hold)' : 'Admitted'
                                        } else if(dataCA.data().dateOfDischarge && dataCA.data().dateOfDischarge !== 'N/A') {
                                            statusLogicOnHold = dataCA.data().activityStatus === 'On Hold' ? 'Discharged (On Hold)' : 'Discharged'
                                        } else {
                                            // statusLogical = dataCA.data().activityStatus
                                            statusLogicOnHold = dataCA.data().activityStatus
                                        }
                                    }
                                } else {
                                    if(dataCA.data().dateOfAdmission && dataCA.data().removeRecordDischargeData) {
                                        statusLogicOnHold = dataCA.data().activityStatus === 'On Hold' ? 'Admitted (On Hold)' : 'Admitted'
                                    } else if(dataCA.data().dateOfAdmission && (!dataCA.data().dateOfDischarge || dataCA.data().dateOfDischarge === 'N/A')) {
                                        statusLogicOnHold = dataCA.data().activityStatus === 'On Hold' ? 'Admitted (On Hold)' : 'Admitted'
                                    } else if(dataCA.data().dateOfDischarge && dataCA.data().dateOfDischarge !== 'N/A') {
                                        statusLogicOnHold = dataCA.data().activityStatus === 'On Hold' ? 'Discharged (On Hold)' : 'Discharged'
                                    } else {
                                        if((dataCA.data().activityStatus === 'Engaged' && (dataCA.data().engagedStatus === 'Referred to Clinician and Peer Advocate' || dataCA.data().engagedStatus === 'Referred to Peer Advocate')) || (dataCA.data().activityStatus === 'Closed - Referred to OASAS Program' && dataCA.data().referredToPeerAdvocate === 'Yes')) {
                                            if(dataCA.data().psdfDate) {
                                                // statusLogical = 'Discharged from peer services'
                                                statusLogicOnHold = dataCA.data().activityStatus === 'Closed - Referred to OASAS Program' && dataCA.data().referredToPeerAdvocate === 'Yes' ? 'Closed-Referred to OASAS Program and Discharged from Peer Services' : (dataCA.data().dateOfAdmission && dataCA.data().removeRecordDischargeData) ? 'Admitted and Discharged from Peer Services' : dataCA.data().dateOfAdmission && (!dataCA.data().dateOfDischarge || dataCA.data().dateOfDischarge === 'N/A') ? 'Admitted and Discharged from Peer Services' : dataCA.data().dateOfDischarge && dataCA.data().dateOfDischarge !== 'N/A' ? 'Discharged and Discharged from Peer Services' : dataCA.data().activityStatus === 'Closed - Referred to OASAS Program' && dataCA.data().referredToPeerAdvocate === 'Yes' ? 'Closed-Referred to OASAS Program and Discharged from Peer Services' : 'Discharged from peer services'
                                            } else {
                                                // statusLogical = dataCA.data().activityStatus
                                                statusLogicOnHold = dataCA.data().activityStatus
                                            }
                                        } else {
                                            // statusLogical = dataCA.data().activityStatus
                                            statusLogicOnHold = dataCA.data().activityStatus
                                        }
                                    }
                                }

                                db.collection('clients').doc(dataCA.data().client).update({
                                    statusAct: 'Admitted',
                                    statusLogicOnHold: statusLogicOnHold
                                })
                            })
                        } else if(this.dateOfAdmission && (!this.dateOfDischarge || this.dateOfDischarge === 'N/A')) {
                            db.collection('clientsActivity').doc(this.idClientActivity).update({
                                activityStatusLogical: 'Admitted'
                            })
                            .catch(error => console.log(error))

                            // update data client clientActivity
                            db.collection('clientsActivity').doc(this.idClientActivity).get()
                            .then(dataCA => {
                                var statusLogicOnHold = ''
                                if(dataCA.data().activityStatus === 'Closed - Referred to OASAS Program' && dataCA.data().referredToPeerAdvocate === 'No') {
                                    // statusLogical = 'Closed - Referred to OASAS Program'
                                    statusLogicOnHold = 'Closed - Referred to OASAS Program'
                                } else if((dataCA.data().activityStatus === 'Engaged' && (dataCA.data().engagedStatus === 'Referred to Clinician and Peer Advocate' || dataCA.data().engagedStatus === 'Referred to Peer Advocate')) || (dataCA.data().activityStatus === 'Closed - Referred to OASAS Program' && dataCA.data().referredToPeerAdvocate === 'Yes')) {
                                    if(dataCA.data().psdfDate) {
                                        // statusLogical = 'Discharged from peer services'
                                        statusLogicOnHold = dataCA.data().activityStatus === 'Closed - Referred to OASAS Program' && dataCA.data().referredToPeerAdvocate === 'Yes' ? 'Closed-Referred to OASAS Program and Discharged from Peer Services' : (dataCA.data().dateOfAdmission && dataCA.data().removeRecordDischargeData) ? 'Admitted and Discharged from Peer Services' : dataCA.data().dateOfAdmission && (!dataCA.data().dateOfDischarge || dataCA.data().dateOfDischarge === 'N/A') ? 'Admitted and Discharged from Peer Services' : dataCA.data().dateOfDischarge && dataCA.data().dateOfDischarge !== 'N/A' ? 'Discharged and Discharged from Peer Services' : dataCA.data().activityStatus === 'Closed - Referred to OASAS Program' && dataCA.data().referredToPeerAdvocate === 'Yes' ? 'Closed-Referred to OASAS Program and Discharged from Peer Services' : 'Discharged from peer services'
                                    } else {
                                        if(dataCA.data().dateOfAdmission && dataCA.data().removeRecordDischargeData) {
                                            statusLogicOnHold = dataCA.data().activityStatus === 'On Hold' ? 'Admitted (On Hold)' : 'Admitted'
                                        } else if(dataCA.data().dateOfAdmission && (!dataCA.data().dateOfDischarge || dataCA.data().dateOfDischarge === 'N/A')) {
                                            statusLogicOnHold = dataCA.data().activityStatus === 'On Hold' ? 'Admitted (On Hold)' : 'Admitted'
                                        } else if(dataCA.data().dateOfDischarge && dataCA.data().dateOfDischarge !== 'N/A') {
                                            statusLogicOnHold = dataCA.data().activityStatus === 'On Hold' ? 'Discharged (On Hold)' : 'Discharged'
                                        } else {
                                            // statusLogical = dataCA.data().activityStatus
                                            statusLogicOnHold = dataCA.data().activityStatus
                                        }
                                    }
                                } else {
                                    if(dataCA.data().dateOfAdmission && dataCA.data().removeRecordDischargeData) {
                                        statusLogicOnHold = dataCA.data().activityStatus === 'On Hold' ? 'Admitted (On Hold)' : 'Admitted'
                                    } else if(dataCA.data().dateOfAdmission && (!dataCA.data().dateOfDischarge || dataCA.data().dateOfDischarge === 'N/A')) {
                                        statusLogicOnHold = dataCA.data().activityStatus === 'On Hold' ? 'Admitted (On Hold)' : 'Admitted'
                                    } else if(dataCA.data().dateOfDischarge && dataCA.data().dateOfDischarge !== 'N/A') {
                                        statusLogicOnHold = dataCA.data().activityStatus === 'On Hold' ? 'Discharged (On Hold)' : 'Discharged'
                                    } else {
                                        if((dataCA.data().activityStatus === 'Engaged' && (dataCA.data().engagedStatus === 'Referred to Clinician and Peer Advocate' || dataCA.data().engagedStatus === 'Referred to Peer Advocate')) || (dataCA.data().activityStatus === 'Closed - Referred to OASAS Program' && dataCA.data().referredToPeerAdvocate === 'Yes')) {
                                            if(dataCA.data().psdfDate) {
                                                // statusLogical = 'Discharged from peer services'
                                                statusLogicOnHold = dataCA.data().activityStatus === 'Closed - Referred to OASAS Program' && dataCA.data().referredToPeerAdvocate === 'Yes' ? 'Closed-Referred to OASAS Program and Discharged from Peer Services' : (dataCA.data().dateOfAdmission && dataCA.data().removeRecordDischargeData) ? 'Admitted and Discharged from Peer Services' : dataCA.data().dateOfAdmission && (!dataCA.data().dateOfDischarge || dataCA.data().dateOfDischarge === 'N/A') ? 'Admitted and Discharged from Peer Services' : dataCA.data().dateOfDischarge && dataCA.data().dateOfDischarge !== 'N/A' ? 'Discharged and Discharged from Peer Services' : dataCA.data().activityStatus === 'Closed - Referred to OASAS Program' && dataCA.data().referredToPeerAdvocate === 'Yes' ? 'Closed-Referred to OASAS Program and Discharged from Peer Services' : 'Discharged from peer services'
                                            } else {
                                                // statusLogical = dataCA.data().activityStatus
                                                statusLogicOnHold = dataCA.data().activityStatus
                                            }
                                        } else {
                                            // statusLogical = dataCA.data().activityStatus
                                            statusLogicOnHold = dataCA.data().activityStatus
                                        }
                                    }
                                }

                                // update statusAct client
                                db.collection('clients').doc(dataCA.data().client).update({
                                    statusAct: 'Admitted',
                                    statusLogicOnHold: statusLogicOnHold
                                })
                            })
                        } else if(this.dateOfDischarge && this.dateOfDischarge !== 'N/A') {
                            db.collection('clientsActivity').doc(this.idClientActivity).update({
                                activityStatusLogical: 'Discharged'  
                            })
                            .catch(error => console.log(error))

                            // update data client clientActivity
                            db.collection('clientsActivity').doc(this.idClientActivity).get()
                            .then(dataCA => {
                                var statusLogicOnHold = ''
                                if(dataCA.data().activityStatus === 'Closed - Referred to OASAS Program' && dataCA.data().referredToPeerAdvocate === 'No') {
                                    // statusLogical = 'Closed - Referred to OASAS Program'
                                    statusLogicOnHold = 'Closed - Referred to OASAS Program'
                                } else if((dataCA.data().activityStatus === 'Engaged' && (dataCA.data().engagedStatus === 'Referred to Clinician and Peer Advocate' || dataCA.data().engagedStatus === 'Referred to Peer Advocate')) || (dataCA.data().activityStatus === 'Closed - Referred to OASAS Program' && dataCA.data().referredToPeerAdvocate === 'Yes')) {
                                    if(dataCA.data().psdfDate) {
                                        // statusLogical = 'Discharged from peer services'
                                        statusLogicOnHold = dataCA.data().activityStatus === 'Closed - Referred to OASAS Program' && dataCA.data().referredToPeerAdvocate === 'Yes' ? 'Closed-Referred to OASAS Program and Discharged from Peer Services' : (dataCA.data().dateOfAdmission && dataCA.data().removeRecordDischargeData) ? 'Admitted and Discharged from Peer Services' : dataCA.data().dateOfAdmission && (!dataCA.data().dateOfDischarge || dataCA.data().dateOfDischarge === 'N/A') ? 'Admitted and Discharged from Peer Services' : dataCA.data().dateOfDischarge && dataCA.data().dateOfDischarge !== 'N/A' ? 'Discharged and Discharged from Peer Services' : dataCA.data().activityStatus === 'Closed - Referred to OASAS Program' && dataCA.data().referredToPeerAdvocate === 'Yes' ? 'Closed-Referred to OASAS Program and Discharged from Peer Services' : 'Discharged from peer services'
                                    } else {
                                        if(dataCA.data().dateOfAdmission && dataCA.data().removeRecordDischargeData) {
                                            statusLogicOnHold = dataCA.data().activityStatus === 'On Hold' ? 'Admitted (On Hold)' : 'Admitted'
                                        } else if(dataCA.data().dateOfAdmission && (!dataCA.data().dateOfDischarge || dataCA.data().dateOfDischarge === 'N/A')) {
                                            statusLogicOnHold = dataCA.data().activityStatus === 'On Hold' ? 'Admitted (On Hold)' : 'Admitted'
                                        } else if(dataCA.data().dateOfDischarge && dataCA.data().dateOfDischarge !== 'N/A') {
                                            statusLogicOnHold = dataCA.data().activityStatus === 'On Hold' ? 'Discharged (On Hold)' : 'Discharged'
                                        } else {
                                            // statusLogical = dataCA.data().activityStatus
                                            statusLogicOnHold = dataCA.data().activityStatus
                                        }
                                    }
                                } else {
                                    if(dataCA.data().dateOfAdmission && dataCA.data().removeRecordDischargeData) {
                                        statusLogicOnHold = dataCA.data().activityStatus === 'On Hold' ? 'Admitted (On Hold)' : 'Admitted'
                                    } else if(dataCA.data().dateOfAdmission && (!dataCA.data().dateOfDischarge || dataCA.data().dateOfDischarge === 'N/A')) {
                                        statusLogicOnHold = dataCA.data().activityStatus === 'On Hold' ? 'Admitted (On Hold)' : 'Admitted'
                                    } else if(dataCA.data().dateOfDischarge && dataCA.data().dateOfDischarge !== 'N/A') {
                                        statusLogicOnHold = dataCA.data().activityStatus === 'On Hold' ? 'Discharged (On Hold)' : 'Discharged'
                                    } else {
                                        if((dataCA.data().activityStatus === 'Engaged' && (dataCA.data().engagedStatus === 'Referred to Clinician and Peer Advocate' || dataCA.data().engagedStatus === 'Referred to Peer Advocate')) || (dataCA.data().activityStatus === 'Closed - Referred to OASAS Program' && dataCA.data().referredToPeerAdvocate === 'Yes')) {
                                            if(dataCA.data().psdfDate) {
                                                // statusLogical = 'Discharged from peer services'
                                                statusLogicOnHold = dataCA.data().activityStatus === 'Closed - Referred to OASAS Program' && dataCA.data().referredToPeerAdvocate === 'Yes' ? 'Closed-Referred to OASAS Program and Discharged from Peer Services' : (dataCA.data().dateOfAdmission && dataCA.data().removeRecordDischargeData) ? 'Admitted and Discharged from Peer Services' : dataCA.data().dateOfAdmission && (!dataCA.data().dateOfDischarge || dataCA.data().dateOfDischarge === 'N/A') ? 'Admitted and Discharged from Peer Services' : dataCA.data().dateOfDischarge && dataCA.data().dateOfDischarge !== 'N/A' ? 'Discharged and Discharged from Peer Services' : dataCA.data().activityStatus === 'Closed - Referred to OASAS Program' && dataCA.data().referredToPeerAdvocate === 'Yes' ? 'Closed-Referred to OASAS Program and Discharged from Peer Services' : 'Discharged from peer services'
                                            } else {
                                                // statusLogical = dataCA.data().activityStatus
                                                statusLogicOnHold = dataCA.data().activityStatus
                                            }
                                        } else {
                                            // statusLogical = dataCA.data().activityStatus
                                            statusLogicOnHold = dataCA.data().activityStatus
                                        }
                                    }
                                }
                                
                                db.collection('clients').doc(dataCA.data().client).update({
                                    statusAct: 'Discharged',
                                    statusLogicOnHold: statusLogicOnHold
                                })
                            })
                        }

                        this.json_data = [
                            {
                                'contactDate': this.dateOfContact,
                                'admissionDate': this.dateOfAdmission,
                                'dischargeDate': this.dateOfDischarge,
                                'clientId': dataClient.data().client,
                                'clinicianId': concatClinician ? concatClinician : '',
                                'clinicianEngagementId': '',
                                'callWasHelpful': this.wasTheCallHelpful,
                                'callWasNotHelpfulReason': this.wasTheCallHelpfulIfNotWhy,
                                'comments': this.specialIssuesOrOtherComments,
                                'dateCreated': '',
                                'eligibleForServices': '',
                                'externalReferenceLocation': '',
                                'informationKitAccepted': this.informationKitAccepted,
                                'informationKitOption': this.informationKitOption,
                                'initialAppointmentDate': this.initialAppointmentDate,
                                'notes': this.callNotes,
                                'referencedExternally': this.referredBy,
                                'familyMemberSelf': this.familyMemberSelf,
                                'problemGamblingSelfHelpGroupMeetings': this.problemGamblingSelfHelpGroupMeetings,
                                'problemGamblingTreatmentServices': this.problemGamblingTreatmentServices,
                                'substanceUseTreatmentServices': this.substanceUseTreatmentServices,
                                'recoverySupportServices': this.recoverySupportServices,
                                'referredByOther': this.otherReferredBy,
                                'warmTransfer': this.warmTransfer,
                                'engagedStatus': this.engagedStatus,
                                'clientStatusCloseNotes': this.closeNotes,
                                'readmission': this.readmission,
                                'clientStatusId': '',
                                'clientStatus': '',
                                'contactMethodId': this.methodOfContact,
                                'callerTypeId': '',
                                'referredByTypeId': '',
                                'regionId': '',
                            }
                        ]
                        this.loadDataPage = true
                    // })
                })
            } else {
                db.collection('clientsActivityVSE').doc(this.idClientActivity).get()
                .then(dataClient => {
                    this.notesVSE = dataClient.data().notesVSE ? dataClient.data().notesVSE : ''
                    this.finalStatusVSE = dataClient.data().finalStatusVSE ? dataClient.data().finalStatusVSE : ''
                    this.staffMemberCompletingFormVSE = dataClient.data().staffMemberCompletingFormVSE ? dataClient.data().staffMemberCompletingFormVSE : ''
                    this.contactDateVSE = dataClient.data().contactDateVSE ? dataClient.data().contactDateVSE : ''
                    this.genderVSE = dataClient.data().genderVSE ? dataClient.data().genderVSE : ''
                    this.referredByVSE = dataClient.data().referredByVSE ? dataClient.data().referredByVSE : ''
                    this.familyMemberSelfVSE = dataClient.data().familyMemberSelfVSE ? dataClient.data().familyMemberSelfVSE : ''
                    this.problemGamblingTreatmentServicesVSE = dataClient.data().problemGamblingTreatmentServicesVSE ? dataClient.data().problemGamblingTreatmentServicesVSE : ''
                    this.problemGamblingSelfHelpGroupMeetingsVSE = dataClient.data().problemGamblingSelfHelpGroupMeetingsVSE ? dataClient.data().problemGamblingSelfHelpGroupMeetingsVSE : ''
                    this.substanceUseTreatmentServicesVSE = dataClient.data().substanceUseTreatmentServicesVSE ? dataClient.data().substanceUseTreatmentServicesVSE : ''
                    this.recoverySupportServicesVSE = dataClient.data().recoverySupportServicesVSE ? dataClient.data().recoverySupportServicesVSE : ''
                    this.otherReferredByVSE = dataClient.data().otherReferredByVSE ? dataClient.data().otherReferredByVSE : ''
                    this.warmTransferVSE = dataClient.data().warmTransferVSE ? dataClient.data().warmTransferVSE : ''
                    this.pgrcPmSE = dataClient.data().pgrcPmSE ? dataClient.data().pgrcPmSE : ''
                    this.PGRCPrivatePractitionerVSE = dataClient.data().PGRCPrivatePractitionerVSE ? dataClient.data().PGRCPrivatePractitionerVSE : ''
                    this.OASASProgramVSE = dataClient.data().OASASProgramVSE ? dataClient.data().OASASProgramVSE : ''
                    this.GamingFacilityVSE = dataClient.data().GamingFacilityVSE ? dataClient.data().GamingFacilityVSE : ''
                    this.connectedToPGRCVSE = dataClient.data().connectedToPGRCVSE ? dataClient.data().connectedToPGRCVSE : ''
                    this.connectedToPeerAdvocateVSE = dataClient.data().connectedToPeerAdvocateVSE ? dataClient.data().connectedToPeerAdvocateVSE : ''
                    this.connectedtoNYSGamingCommissionVSE = dataClient.data().connectedtoNYSGamingCommissionVSE ? dataClient.data().connectedtoNYSGamingCommissionVSE : ''
                    this.typesofGamblingEngagedInVSE = dataClient.data().typesofGamblingEngagedInVSE ? dataClient.data().typesofGamblingEngagedInVSE : ''
                    this.interventionStatusVSE = dataClient.data().interventionStatusVSE ? dataClient.data().interventionStatusVSE : ''
                    this.pendingVSE = dataClient.data().pendingVSE ? dataClient.data().pendingVSE : ''
                    this.appointmentDateVSE = dataClient.data().appointmentDateVSE ? dataClient.data().appointmentDateVSE : ''
                    this.followUpDateVSE = dataClient.data().followUpDateVSE ? dataClient.data().followUpDateVSE : ''
                    this.VSETimeframe = dataClient.data().VSETimeframe ? dataClient.data().VSETimeframe : ''

                    this.loadDataPage = true
                })
            }
        })

        db.collection('usuarios').where('role', 'in', ['clinician','clinician-staff']).get()
        .then(docsClinicians => {
            this.optionsClinician = []
            docsClinicians.forEach(dataClinician => {
                // db.collection('usuarios').doc(dataClinician.id).collection('details').doc('trackingDetail').get()
                // .then(docTracking => {
                //     var statusReferral = ''
                //     if(docTracking.data()) {
                //         if(docTracking.data().datePickers) {
                //             statusReferral = docTracking.data().datePickers[8].value ? 'active' : 'inactive'
                //         } else {
                //             statusReferral = 'inactive'
                //         }
                //     }

                    // if(dataClinician.data().status === 'active' && statusReferral === 'active') {
                        var obj = dataClinician.data()
                        obj.agencyAndName = dataClinician.data().firstName + ' ' + dataClinician.data().lastName + ' · ' + dataClinician.data().agency  + ' (#' + dataClinician.data().codigo + ')'
                        this.optionsClinician.push(obj)
                    // }
                    // console.log('first')
                // })
            })
        })
    },
    mounted() {
        if(window.location.pathname.includes('users/edit/clinician')) {
            this.clinicianOrClinicianViewer = true
            this.viewClinicianCLienActivity = true
        }
        // window.location.hash="client-activity";
        // window.location.hash="client-activity";
        // window.onhashchange = function() {
        //     window.location.hash="client-activity";
        //     goBack()
        // }

        // var goBack = () => {
            // history.pushState("", document.title, window.location.pathname + window.location.search);
            // console.log(this.statusEditClientActivity);
            // if(this.statusEditClientActivity) {
                // this.statusEditClientActivity = false
                // this.$emit('statusEditClientActivity',false)
            // }
        // }
        this.initTrHeight()

        if (window.history && window.history.pushState) {
            window.history.pushState('forward', null, '');

            window.addEventListener('popstate', () => {
                // alert('Back button was pressed.');
                this.statusEditClientActivity = false
                this.$emit('statusEditClientActivity',false)
            });
        }

        this.pushEditButton = false
        this.$emit('statusEditClientActivity',true)
    },
    destroyed() {
        window.removeEventListener('resize', this.initTrHeight)
    },
}
</script>

<style>
.cancelBtn-modal {
    border-radius: 13px !important;
}
.vs--disabled .vs__selected {
    color: #656b85 !important;
}
/* .btn-primary:hover:focus:active:visited {
    box-shadow: none !important;
}
.btn-primary:hover:focus:active:visited {
    box-shadow: none !important;
} */
.btn-primary:hover {
    box-shadow: none !important;
}
.btn-primary:focus {
    box-shadow: none !important;
}
.btn-primary:active {
    box-shadow: none !important;
}
.btn-primary:visited {
    box-shadow: none !important;
}
.select-utilization-form .vs__dropdown-menu {
    max-height: 185px !important;
    /* position: fixed;
    top: 50px !important;
    left: 50px !important;
    width: 200px !important;
    height: 400px !important;
    background-color: yellow !important;
    z-index: 9999 !important; */
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>